msgid ""
msgstr ""
"POT-Creation-Date: 2024-06-27 10:13-0400\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. js-lingui-id: ++rVAm
msgid "Social Media"
msgstr "Social Media"

#. js-lingui-id: +0B+ue
msgid "Projects"
msgstr "Projects"

#. js-lingui-id: +0n5e0
msgid "Entry date: "
msgstr "Entry date: "

#. js-lingui-id: +0qfCN
msgid "Previous Employer"
msgstr "Previous Employer"

#. js-lingui-id: +1z7P1
msgid "We understand you were interested in this property. While it's no longer available, we have many other exceptional properties that might be perfect for you."
msgstr "We understand you were interested in this property. While it's no longer available, we have many other exceptional properties that might be perfect for you."

#. js-lingui-id: +2CdJq
msgid "Request additional co-signers"
msgstr "Request additional co-signers"

#. js-lingui-id: +2Venh
msgid "Credit Check Request"
msgstr "Credit Check Request"

#. js-lingui-id: +2ponR
msgid "Landlord Information"
msgstr "Landlord Information"

#. js-lingui-id: +7Oup8
msgid "Resend Invite"
msgstr "Resend Invite"

#. js-lingui-id: +8Nek/
msgid "Monthly"
msgstr "Monthly"

#. js-lingui-id: +D5Ct6
msgid "Previous Rental Property Address"
msgstr "Previous Rental Property Address"

#. js-lingui-id: +E+RKY
msgid "We strongly recommend to a SSN to our secured form to improve the chances to obtain a credit report. This information is not saved and is only used to verify your identity when running the credit check."
msgstr "We strongly recommend to a SSN to our secured form to improve the chances to obtain a credit report. This information is not saved and is only used to verify your identity when running the credit check."

#. js-lingui-id: +FjWgX
msgid "Thu"
msgstr "Thu"

#. js-lingui-id: +GmWz3
msgid "A friend who will be a co-applicant"
msgstr "A friend who will be a co-applicant"

#. js-lingui-id: +HT37C
msgid "Apply for a Property"
msgstr "Apply for a Property"

#. js-lingui-id: +I4pWD
msgid "Company/Employer Name"
msgstr "Company/Employer Name"

#. js-lingui-id: +IrOzl
msgid "Legal Disclaimer"
msgstr "Legal Disclaimer"

#. js-lingui-id: +JJZXx
msgid "This title will be used in external promotions"
msgstr "This title will be used in external promotions"

#. js-lingui-id: +LhgAJ
msgid "Background Check Not Run"
msgstr "Background Check Not Run"

#. js-lingui-id: +MNb3v
msgid "Previous rental payment records"
msgstr "Previous rental payment records"

#. js-lingui-id: +NCBA+
msgid "Specialized Lenders"
msgstr "Specialized Lenders"

#. js-lingui-id: +Nj6xm
msgid "A user associated with this e-mail was found in the application. Verify the email provided and try again."
msgstr "A user associated with this e-mail was found in the application. Verify the email provided and try again."

#. js-lingui-id: +OHQ0U
msgid "The property manager provided the following reason:"
msgstr "The property manager provided the following reason:"

#. js-lingui-id: +OJ3GQ
msgid "Housing Costs"
msgstr "Housing Costs"

#. js-lingui-id: +P/gFR
msgid "Takes less than 5 minutes"
msgstr "Takes less than 5 minutes"

#. js-lingui-id: +PsgaI
msgid "The preferred language is required"
msgstr "The preferred language is required"

#. js-lingui-id: +SSxNi
msgid "Start typing your address..."
msgstr "Start typing your address..."

#. js-lingui-id: +VporH
msgid "Reject Application"
msgstr "Reject Application"

#. js-lingui-id: +YnJ0j
msgid "Listing updated successfully"
msgstr "Listing updated successfully"

#. js-lingui-id: +bay9a
msgid "This submission was on hold"
msgstr "This submission was on hold"

#. js-lingui-id: +eFgSm
msgid "Application in Progress"
msgstr "Application in Progress"

#. js-lingui-id: +f3Wkz
msgid "This applicant did not provide any references to check. Please contact them to provide references."
msgstr "This applicant did not provide any references to check. Please contact them to provide references."

#. js-lingui-id: +hw7+q
msgid "Add a Visit Agent"
msgstr "Add a Visit Agent"

#. js-lingui-id: +kf9vT
msgid "Debt Categories"
msgstr "Debt Categories"

#. js-lingui-id: +kjk+9
msgid "Age 18+"
msgstr "Age 18+"

#. js-lingui-id: +kzc5I
msgid "New from last time:"
msgstr "New from last time:"

#. js-lingui-id: +nPx/9
msgid "near"
msgstr "near"

#. js-lingui-id: +naPgK
msgid "Your personal information is protected and only shared with the landlord"
msgstr "Your personal information is protected and only shared with the landlord"

#. js-lingui-id: +oQhet
msgid "Import Preview"
msgstr "Import Preview"

#. js-lingui-id: +oj2Lm
msgid "Provide the tenant's information to get started"
msgstr "Provide the tenant's information to get started"

#. js-lingui-id: +vTvJs
msgid "Rental Application"
msgstr "Rental Application"

#. js-lingui-id: +x3bPj
msgid "Unnamed Building"
msgstr "Unnamed Building"

#. js-lingui-id: +x7aMr
msgid "Max sqft"
msgstr "Max sqft"

#. js-lingui-id: +yBm0S
msgid "Total Buildings"
msgstr "Total Buildings"

#. js-lingui-id: +z9xdk
msgid "Promote"
msgstr "Promote"

#. js-lingui-id: +zy2Nq
msgid "Type"
msgstr "Type"

#. js-lingui-id: /0C4ok
msgid "Your application did not meet our required credit score for this property."
msgstr "Your application did not meet our required credit score for this property."

#. js-lingui-id: /1/ej2
msgid "Completed on {insuranceDate}"
msgstr "Completed on {insuranceDate}"

#. js-lingui-id: /1r4bR
msgid "Current Tenant"
msgstr "Current Tenant"

#. js-lingui-id: /3IBTP
msgid "Rejected Reasons"
msgstr "Rejected Reasons"

#. js-lingui-id: /4TFrF
msgid "Full Name"
msgstr "Full Name"

#. js-lingui-id: /73IfE
msgid "Search applicants, submissions and more..."
msgstr "Search applicants, submissions and more..."

#. js-lingui-id: /CoN1P
msgid "Max size"
msgstr "Max size"

#. js-lingui-id: /H3Pek
msgid "Current applicants"
msgstr "Current applicants"

#. js-lingui-id: /IX/7x
msgid "Other"
msgstr "Other"

#. js-lingui-id: /JrclD
msgid "{tooltipText}: Good"
msgstr "{tooltipText}: Good"

#. js-lingui-id: /K2CvV
msgid "Template"
msgstr "Template"

#. js-lingui-id: /LCAwL
msgid "In progress"
msgstr "In progress"

#. js-lingui-id: /MXLJb
msgid "Lease"
msgstr "Lease"

#. js-lingui-id: /RCmK9
msgid "Car Loan"
msgstr "Car Loan"

#. js-lingui-id: /Rirn3
msgid "Run additional check"
msgstr "Run additional check"

#. js-lingui-id: /YOcwB
msgid "Gain comprehensive insights into background history and public records to make informed decisions with confidence."
msgstr "Gain comprehensive insights into background history and public records to make informed decisions with confidence."

#. js-lingui-id: /aod7d
msgid "Asset Amount"
msgstr "Asset Amount"

#. js-lingui-id: /hL6/r
msgid "User deleted successfully."
msgstr "User deleted successfully."

#. js-lingui-id: /j9zPO
msgid "Date of birth is required"
msgstr "Date of birth is required"

#. js-lingui-id: /mfICu
msgid "Fees"
msgstr "Fees"

#. js-lingui-id: /pkNvF
msgid "Amenities"
msgstr "Amenities"

#. js-lingui-id: /tNxAh
msgid "Confirm Your Selection"
msgstr "Confirm Your Selection"

#. js-lingui-id: /uM7L8
msgid "Not Included"
msgstr "Not Included"

#. js-lingui-id: /wzAIt
msgid "The user receiving personal information about a prospective tenant acknowledges and agrees that Eversa shall not, under any circumstances, be held liable for any direct or indirect damages resulting from the transmission, interpretation, or use of inaccurate, incomplete, or incorrect information. This applies whether such information was initially provided by the prospective tenant, submitted by the user, or supplied by third parties, including credit reporting agencies or other external partners."
msgstr "The user receiving personal information about a prospective tenant acknowledges and agrees that Eversa shall not, under any circumstances, be held liable for any direct or indirect damages resulting from the transmission, interpretation, or use of inaccurate, incomplete, or incorrect information. This applies whether such information was initially provided by the prospective tenant, submitted by the user, or supplied by third parties, including credit reporting agencies or other external partners."

#. js-lingui-id: 07/Ujr
msgid "Partial Applications"
msgstr "Partial Applications"

#. js-lingui-id: 07DgB4
msgid "Search Applicants"
msgstr "Search Applicants"

#. js-lingui-id: 07kxvV
msgid "Delivery Setup"
msgstr "Delivery Setup"

#. js-lingui-id: 0I0Hac
msgid "Important Notice"
msgstr "Important Notice"

#. js-lingui-id: 0J/aTA
msgid "I understand that this accommodation does not allow smoking within the premises"
msgstr "I understand that this accommodation does not allow smoking within the premises"

#. js-lingui-id: 0KDB7S
msgid "Select Entry Date"
msgstr "Select Entry Date"

#. js-lingui-id: 0M0CU4
msgid "This is a high salary. Please confirm it's correct."
msgstr "This is a high salary. Please confirm it's correct."

#. js-lingui-id: 0R1H0M
msgid "Why do you charge application fees?"
msgstr "Why do you charge application fees?"

#. js-lingui-id: 0VABa/
msgid "Current Rent"
msgstr "Current Rent"

#. js-lingui-id: 0WeP54
msgid "Add a co-applicant"
msgstr "Add a co-applicant"

#. js-lingui-id: 0a/zKn
msgid "Application Status: Under Reconsideration"
msgstr "Application Status: Under Reconsideration"

#. js-lingui-id: 0cOhlH
msgid "Upload Units"
msgstr "Upload Units"

#. js-lingui-id: 0f7U0k
msgid "Wed"
msgstr "Wed"

#. js-lingui-id: 0fzruQ
msgid "Email Preferences"
msgstr "Email Preferences"

#. js-lingui-id: 0oPWCt
msgid "{street}, {city}, Unit# {unitIdx}"
msgstr "{street}, {city}, Unit# {unitIdx}"

#. js-lingui-id: 0oXwkF
msgid "I have received permission from the applicant to run a credit check."
msgstr "I have received permission from the applicant to run a credit check."

#. js-lingui-id: 0oYdMY
msgid "Consent Verification"
msgstr "Consent Verification"

#. js-lingui-id: 0p2lf/
msgid "Excellent"
msgstr "Excellent"

#. js-lingui-id: 0tWyKI
msgid "Capture important financial information to help you make informed decisions."
msgstr "Capture important financial information to help you make informed decisions."

#. js-lingui-id: 0vxZXz
msgid "Guarantor Documents"
msgstr "Guarantor Documents"

#. js-lingui-id: 0xD8Of
msgid "The page you're looking for doesn't exist or has been moved."
msgstr "The page you're looking for doesn't exist or has been moved."

#. js-lingui-id: 0yPSCj
msgid "High Risk"
msgstr "High Risk"

#. js-lingui-id: 0zR8pa
msgid "Listings Management View Options"
msgstr "Listings Management View Options"

#. js-lingui-id: 1+4SpX
msgid "Send Email Invitation"
msgstr "Send Email Invitation"

#. js-lingui-id: 1+DWdk
msgid "Listing created"
msgstr "Listing created"

#. js-lingui-id: 15DaP1
msgid "View lease details"
msgstr "View lease details"

#. js-lingui-id: 169++X
msgid "No. Credits Checks"
msgstr "No. Credits Checks"

#. js-lingui-id: 1718Q+
msgid "Issues"
msgstr "Issues"

#. js-lingui-id: 19xfly
msgid "Manage all units across buildings in this project"
msgstr "Manage all units across buildings in this project"

#. js-lingui-id: 1B+Zhk
msgid "We are currently processing the report. Come back later."
msgstr "We are currently processing the report. Come back later."

#. js-lingui-id: 1B5tzk
msgid "Unlimited users"
msgstr "Unlimited users"

#. js-lingui-id: 1DBGsz
msgid "Notes"
msgstr "Notes"

#. js-lingui-id: 1DRSRK
msgid "You must take action on this submission"
msgstr "You must take action on this submission"

#. js-lingui-id: 1Dbl+5
msgid "Income verification"
msgstr "Income verification"

#. js-lingui-id: 1I1xeb
msgid "I understand that this accommodation does not accept pets and confirm that I have no pets and no adopted ones during my lease"
msgstr "I understand that this accommodation does not accept pets and confirm that I have no pets and no adopted ones during my lease"

#. js-lingui-id: 1I8JQd
msgid "Final review and decision by the landlord"
msgstr "Final review and decision by the landlord"

#. js-lingui-id: 1JMWG3
msgid "Legal Status"
msgstr "Legal Status"

#. js-lingui-id: 1Jif/R
msgid "New application"
msgstr "New application"

#. js-lingui-id: 1PqICB
msgid "Only XLSX files are accepted"
msgstr "Only XLSX files are accepted"

#. js-lingui-id: 1TNIig
msgid "Open"
msgstr "Open"

#. js-lingui-id: 1UzENP
msgid "No"
msgstr "No"

#. js-lingui-id: 1V5RP8
msgid "Go to my application"
msgstr "Go to my application"

#. js-lingui-id: 1Y7n4e
msgid "Assign yourself"
msgstr "Assign yourself"

#. js-lingui-id: 1ZaQUH
msgid "Last name"
msgstr "Last name"

#. js-lingui-id: 1aEY/3
msgid "Your candidate submissions"
msgstr "Your candidate submissions"

#. js-lingui-id: 1bTCU8
msgid "Application & Analysis Fee"
msgstr "Application & Analysis Fee"

#. js-lingui-id: 1c0ou9
msgid "image(s) uploaded"
msgstr "image(s) uploaded"

#. js-lingui-id: 1dkv5X
msgid "Current Status"
msgstr "Current Status"

#. js-lingui-id: 1gdNSY
msgid "Needs Attention"
msgstr "Needs Attention"

#. js-lingui-id: 1geQCt
msgid "Floor Plan"
msgstr "Floor Plan"

#. js-lingui-id: 1iBTV8
msgid "Incompleted"
msgstr "Incompleted"

#. js-lingui-id: 1imxKE
msgid "Choose how you'd like to manage the applicants in this submission"
msgstr "Choose how you'd like to manage the applicants in this submission"

#. js-lingui-id: 1mt+ts
msgid "Apartment/Unit #"
msgstr "Apartment/Unit #"

#. js-lingui-id: 1t/NnN
msgid "Reject"
msgstr "Reject"

#. js-lingui-id: 1yFAiI
msgid "Insurance"
msgstr "Insurance"

#. js-lingui-id: 2+PwyN
msgid "Credit Utilization Threshold"
msgstr "Credit Utilization Threshold"

#. js-lingui-id: 2//P6D
msgid "Waiting for results"
msgstr "Waiting for results"

#. js-lingui-id: 2/iT/I
msgid "Additional Financial Documentation"
msgstr "Additional Financial Documentation"

#. js-lingui-id: 21Cw3b
msgid "Apply In Person"
msgstr "Apply In Person"

#. js-lingui-id: 22F2Jm
msgid "The information obtained will be used solely for the purpose of your rental application and will not be shared with third parties without your consent, except as required by law."
msgstr "The information obtained will be used solely for the purpose of your rental application and will not be shared with third parties without your consent, except as required by law."

#. js-lingui-id: 23pyLB
msgid "Create New Tenant"
msgstr "Create New Tenant"

#. js-lingui-id: 26dtmt
msgid "Show all tasks"
msgstr "Show all tasks"

#. js-lingui-id: 27YFs9
msgid "Debt Overview"
msgstr "Debt Overview"

#. js-lingui-id: 2BBAbc
msgid "List"
msgstr "List"

#. js-lingui-id: 2LM5Sp
msgid "Quebec bankruptcy records"
msgstr "Quebec bankruptcy records"

#. js-lingui-id: 2Uup2p
msgid "I understand that there is <strong>{limit}</strong> parking space included in the unit."
msgstr "I understand that there is <strong>{limit}</strong> parking space included in the unit."

#. js-lingui-id: 2WPrlc
msgid "You confirm that the information provided is accurate and up to date. Any false or misleading information may affect the outcome of your application."
msgstr "You confirm that the information provided is accurate and up to date. Any false or misleading information may affect the outcome of your application."

#. js-lingui-id: 2ZgzTU
msgid "Enter the email of the tenant that you want to invite"
msgstr "Enter the email of the tenant that you want to invite"

#. js-lingui-id: 2fokfN
msgid "Please provide one of the following documents:"
msgstr "Please provide one of the following documents:"

#. js-lingui-id: 2kAD9a
msgid "Important consequences:"
msgstr "Important consequences:"

#. js-lingui-id: 2njB29
msgid "Enter your current monthly rent"
msgstr "Enter your current monthly rent"

#. js-lingui-id: 2q/Q7x
msgid "Visibility"
msgstr "Visibility"

#. js-lingui-id: 2tPLae
msgid "Please verify the applicant's information and confirm consent."
msgstr "Please verify the applicant's information and confirm consent."

#. js-lingui-id: 2tb9I3
msgid "Documents uploaded"
msgstr "Documents uploaded"

#. js-lingui-id: 306na7
msgid "Add another applicant"
msgstr "Add another applicant"

#. js-lingui-id: 32DXjW
msgid "Industry standard is 30% or less for optimal credit health and financial stability"
msgstr "Industry standard is 30% or less for optimal credit health and financial stability"

#. js-lingui-id: 33bdMY
msgid "Invite tenant directly"
msgstr "Invite tenant directly"

#. js-lingui-id: 37YEFk
msgid "Years at current job is required unless you are retired"
msgstr "Years at current job is required unless you are retired"

#. js-lingui-id: 37chR6
msgid "Show all listings"
msgstr "Show all listings"

#. js-lingui-id: 37yDkn
msgid "Enable submission assignement to expand platform capabilities by increasing available features. This adds the ability to assign submissions to users, enhancing management flexibility and collaboration."
msgstr "Enable submission assignement to expand platform capabilities by increasing available features. This adds the ability to assign submissions to users, enhancing management flexibility and collaboration."

#. js-lingui-id: 38J2b8
msgid "Credit Report Prices"
msgstr "Credit Report Prices"

#. js-lingui-id: 3C9jEv
msgid "Recent documentation showing your current income"
msgstr "Recent documentation showing your current income"

#. js-lingui-id: 3CuNjX
msgid "Payment Success"
msgstr "Payment Success"

#. js-lingui-id: 3DCojC
msgid "{tenantName} rental: {type} with {bedrooms} bedrooms in {city}, {address}"
msgstr "{tenantName} rental: {type} with {bedrooms} bedrooms in {city}, {address}"

#. js-lingui-id: 3IKOYC
msgid "Add a reason for discarding this submission"
msgstr "Add a reason for discarding this submission"

#. js-lingui-id: 3JPSB1
msgid "Endorser/Guarantor"
msgstr "Endorser/Guarantor"

#. js-lingui-id: 3JPTpK
msgid "Manage your tasks efficiently and prioritize your day"
msgstr "Manage your tasks efficiently and prioritize your day"

#. js-lingui-id: 3QuwJC
msgid "No units found with current filters. Try adjusting your filters or add units."
msgstr "No units found with current filters. Try adjusting your filters or add units."

#. js-lingui-id: 3TcQ9I
msgid "Send to submissions"
msgstr "Send to submissions"

#. js-lingui-id: 3UBCCI
msgid "Enter English title"
msgstr "Enter English title"

#. js-lingui-id: 3Xu0UZ
msgid "{differenceInDays} days ago"
msgstr "{differenceInDays} days ago"

#. js-lingui-id: 3aUB6I
msgid "Re-open this lead"
msgstr "Re-open this lead"

#. js-lingui-id: 3b4kt0
msgid "bathrooms"
msgstr "bathrooms"

#. js-lingui-id: 3bbqLM
msgid "Attention Required"
msgstr "Attention Required"

#. js-lingui-id: 3bvkPk
msgid "No assignee"
msgstr "No assignee"

#. js-lingui-id: 3dO6rb
msgid "Passport"
msgstr "Passport"

#. js-lingui-id: 3dpU/b
msgid "Send to leads"
msgstr "Send to leads"

#. js-lingui-id: 3j3MnF
msgid "Enter your Facebook Pixel ID (e.g., XXXXXXXXXXXXXXXXXX)"
msgstr "Enter your Facebook Pixel ID (e.g., XXXXXXXXXXXXXXXXXX)"

#. js-lingui-id: 3jydzm
msgid "Secure payment with no hidden fees or recurring charges"
msgstr "Secure payment with no hidden fees or recurring charges"

#. js-lingui-id: 3kmOfT
msgid "Mortgage"
msgstr "Mortgage"

#. js-lingui-id: 3lqHZn
msgid "Analyzing AI Salary"
msgstr "Analyzing AI Salary"

#. js-lingui-id: 3nRszo
msgid "Partial"
msgstr "Partial"

#. js-lingui-id: 3oJT1Y
msgid "Meets Minimum Score"
msgstr "Meets Minimum Score"

#. js-lingui-id: 3qk2V6
msgid "Total balances"
msgstr "Total balances"

#. js-lingui-id: 3rsvtZ
msgid "You can access the tenant's view of their application to complete missing information or correct issues on their behalf."
msgstr "You can access the tenant's view of their application to complete missing information or correct issues on their behalf."

#. js-lingui-id: 3s7lyE
msgid "We're not quite ready for this yet!"
msgstr "We're not quite ready for this yet!"

#. js-lingui-id: 3tIWwO
msgid "Set the baseline credit grade for tenant approval"
msgstr "Set the baseline credit grade for tenant approval"

#. js-lingui-id: 3u2W35
msgid "Applicant successfully moved to submissions"
msgstr "Applicant successfully moved to submissions"

#. js-lingui-id: 3wLMe2
msgid "Our property management team is here to assist you. Please don't hesitate to reach out with any questions or concerns."
msgstr "Our property management team is here to assist you. Please don't hesitate to reach out with any questions or concerns."

#. js-lingui-id: 3wV73y
msgid "City"
msgstr "City"

#. js-lingui-id: 3wXqxH
msgid "The tenant has an email address"
msgstr "The tenant has an email address"

#. js-lingui-id: 3xAOQ2
msgid "Review carefully before proceeding"
msgstr "Review carefully before proceeding"

#. js-lingui-id: 3xWw8X
msgid "Credit"
msgstr "Credit"

#. js-lingui-id: 3y+V4p
msgid "Organization Address"
msgstr "Organization Address"

#. js-lingui-id: 3zHWEJ
msgid "Currently Renting"
msgstr "Currently Renting"

#. js-lingui-id: 4+xCbE
msgid "Waiting for manager to prepare lease"
msgstr "Waiting for manager to prepare lease"

#. js-lingui-id: 4/sIJj
msgid "WARNING: Impersonating {tenantSlug}"
msgstr "WARNING: Impersonating {tenantSlug}"

#. js-lingui-id: 403lg+
msgid "Specify which references tenants need to provide with their application"
msgstr "Specify which references tenants need to provide with their application"

#. js-lingui-id: 41BQ3k
msgid "Contact Email"
msgstr "Contact Email"

#. js-lingui-id: 42iHn5
msgid "Insufficient Data for Analysis"
msgstr "Insufficient Data for Analysis"

#. js-lingui-id: 42v1c0
msgid "The report will be updated and ready shortly."
msgstr "The report will be updated and ready shortly."

#. js-lingui-id: 4Cp2Bu
msgid "Additional Notes"
msgstr "Additional Notes"

#. js-lingui-id: 4EN1Ko
msgid "Specify which documents tenants need to provide with their application"
msgstr "Specify which documents tenants need to provide with their application"

#. js-lingui-id: 4EZrJN
msgid "Rules"
msgstr "Rules"

#. js-lingui-id: 4HBFYh
msgid "Map"
msgstr "Map"

#. js-lingui-id: 4IxwaI
msgid "verified tenants"
msgstr "verified tenants"

#. js-lingui-id: 4JcNPM
msgid "No Answer"
msgstr "No Answer"

#. js-lingui-id: 4LA8GW
msgid "Don't have these exact documents? You can upload alternative documents that prove your {documentName} and our team will evaluate them."
msgstr "Don't have these exact documents? You can upload alternative documents that prove your {documentName} and our team will evaluate them."

#. js-lingui-id: 4OK01F
msgid "Submission has been successfully un-snoozed. It will now show up in the list to process."
msgstr "Submission has been successfully un-snoozed. It will now show up in the list to process."

#. js-lingui-id: 4Pfbfv
msgid "Debt Utilization Trends"
msgstr "Debt Utilization Trends"

#. js-lingui-id: 4QrWVd
msgid "per month"
msgstr "per month"

#. js-lingui-id: 4R0Wz7
msgid "Furthermore, the user agrees to fully indemnify Eversa against any amounts it may be required to pay for damages, legal fees, or other costs arising from any action or omission attributable to the user related to the use of personal information later found to be inaccurate, false, or misleading."
msgstr "Furthermore, the user agrees to fully indemnify Eversa against any amounts it may be required to pay for damages, legal fees, or other costs arising from any action or omission attributable to the user related to the use of personal information later found to be inaccurate, false, or misleading."

#. js-lingui-id: 4TSeNJ
msgid "The application has been declined in its current state. However, if a co-signer is provided, the landlord will reconsider the case and may issue a positive response."
msgstr "The application has been declined in its current state. However, if a co-signer is provided, the landlord will reconsider the case and may issue a positive response."

#. js-lingui-id: 4VOGk0
msgid "Converted to regular listing"
msgstr "Converted to regular listing"

#. js-lingui-id: 4Vxo6V
msgid "No Submissions Found!"
msgstr "No Submissions Found!"

#. js-lingui-id: 4XSc4l
msgid "Weekly"
msgstr "Weekly"

#. js-lingui-id: 4b3kQf
msgid "Please provide suitable description"
msgstr "Please provide suitable description"

#. js-lingui-id: 4bRMuv
msgid "Enter an address"
msgstr "Enter an address"

#. js-lingui-id: 4c4TGc
msgid "Application fees cover the costs associated with processing and verifying your rental application, including background checks, credit reports, and employment verification to ensure a thorough and professional screening process."
msgstr "Application fees cover the costs associated with processing and verifying your rental application, including background checks, credit reports, and employment verification to ensure a thorough and professional screening process."

#. js-lingui-id: 4cqVkH
msgid "No leads found"
msgstr "No leads found"

#. js-lingui-id: 4dzoL9
msgid "Hide the 'Chosen' category in the submission workflow."
msgstr "Hide the 'Chosen' category in the submission workflow."

#. js-lingui-id: 4gUV3t
msgid "Billing is properly configured"
msgstr "Billing is properly configured"

#. js-lingui-id: 4k24cF
msgid "Duplicate Unit"
msgstr "Duplicate Unit"

#. js-lingui-id: 4lUh8p
msgid "Promotional Title"
msgstr "Promotional Title"

#. js-lingui-id: 4oZgYS
msgid "Date Paid"
msgstr "Date Paid"

#. js-lingui-id: 4pIc+0
msgid "Available on {formatedAvailability}"
msgstr "Available on {formatedAvailability}"

#. js-lingui-id: 4pwejF
msgid "First name is required"
msgstr "First name is required"

#. js-lingui-id: 4qsPeV
msgid "Front and back of valid license"
msgstr "Front and back of valid license"

#. js-lingui-id: 4sXlwl
msgid "Application Fee Agreement"
msgstr "Application Fee Agreement"

#. js-lingui-id: 4sYaNl
msgid "Monthly Rent"
msgstr "Monthly Rent"

#. js-lingui-id: 4vA3oS
msgid "Manage project"
msgstr "Manage project"

#. js-lingui-id: 4wTON8
msgid "Need help? We're here to assist you."
msgstr "Need help? We're here to assist you."

#. js-lingui-id: 4ypJfF
msgid "Upload your required proof of income and ID documentation"
msgstr "Upload your required proof of income and ID documentation"

#. js-lingui-id: 4yvLkg
msgid "Notification sent when a rental agent is assigned to a rental application submission"
msgstr "Notification sent when a rental agent is assigned to a rental application submission"

#. js-lingui-id: 51FUZc
msgid "Maximum Credit Utilization"
msgstr "Maximum Credit Utilization"

#. js-lingui-id: 54/ySy
msgid "Enter Youtube URL"
msgstr "Enter Youtube URL"

#. js-lingui-id: 553MXo
msgid "Employment and landlord reference verification"
msgstr "Employment and landlord reference verification"

#. js-lingui-id: 58X1WA
msgid "All Units"
msgstr "All Units"

#. js-lingui-id: 59HXHe
msgid "Major Banks"
msgstr "Major Banks"

#. js-lingui-id: 5HFsIV
msgid "Enable Projects"
msgstr "Enable Projects"

#. js-lingui-id: 5Qvo0g
msgid "Unit Change Threshold ($)"
msgstr "Unit Change Threshold ($)"

#. js-lingui-id: 5TsUYH
msgid "Submission has been successfully rejected"
msgstr "Submission has been successfully rejected"

#. js-lingui-id: 5VAzM9
msgid "Learn more about"
msgstr "Learn more about"

#. js-lingui-id: 5cxuuq
msgid "The field is invalid"
msgstr "The field is invalid"

#. js-lingui-id: 5dydNg
msgid "Additional notes"
msgstr "Additional notes"

#. js-lingui-id: 5eLj4k
msgid "Application not started"
msgstr "Application not started"

#. js-lingui-id: 5iM1gD
msgid "Quebec court records and legal history verification"
msgstr "Quebec court records and legal history verification"

#. js-lingui-id: 5iNewk
msgid "Global watchlist records indicate prior criminal involvement."
msgstr "Global watchlist records indicate prior criminal involvement."

#. js-lingui-id: 5iVHpx
msgid "Processing for lease signing"
msgstr "Processing for lease signing"

#. js-lingui-id: 5lbavF
msgid "Search listings"
msgstr "Search listings"

#. js-lingui-id: 5nij+b
msgid "Additional Review Required"
msgstr "Additional Review Required"

#. js-lingui-id: 5oEFR0
msgid "Add any relevant information about this applicant..."
msgstr "Add any relevant information about this applicant..."

#. js-lingui-id: 5pvqmj
msgid "Criminal Records"
msgstr "Criminal Records"

#. js-lingui-id: 5qU5Gh
msgid "Annual revenue"
msgstr "Annual revenue"

#. js-lingui-id: 5v4qYi
msgid "Preferred language"
msgstr "Preferred language"

#. js-lingui-id: 5xxrhm
msgid "Add a note"
msgstr "Add a note"

#. js-lingui-id: 5y3O+A
msgid "Deactivate"
msgstr "Deactivate"

#. js-lingui-id: 5ykxbP
msgid "API Documentation"
msgstr "API Documentation"

#. js-lingui-id: 6+Z07a
msgid "Rent: "
msgstr "Rent: "

#. js-lingui-id: 6/TeyT
msgid "{tenantName} {type} for rent in {city}: {bedrooms} bedrooms, {address}"
msgstr "{tenantName} {type} for rent in {city}: {bedrooms} bedrooms, {address}"

#. js-lingui-id: 6/dCYd
msgid "Overview"
msgstr "Overview"

#. js-lingui-id: 621rYf
msgid "Payment"
msgstr "Payment"

#. js-lingui-id: 623gDt
msgid "Failed to delete user."
msgstr "Failed to delete user."

#. js-lingui-id: 642qru
msgid "ROLE"
msgstr "ROLE"

#. js-lingui-id: 6B6oQj
msgid "Application on hold - Action required"
msgstr "Application on hold - Action required"

#. js-lingui-id: 6D9V6K
msgid "Delivery status illustration"
msgstr "Delivery status illustration"

#. js-lingui-id: 6GPUe/
msgid "Select a new listing and unit"
msgstr "Select a new listing and unit"

#. js-lingui-id: 6KnyG0
msgid "Enter email"
msgstr "Enter email"

#. js-lingui-id: 6NvSPB
msgid "Identity Documents"
msgstr "Identity Documents"

#. js-lingui-id: 6Q5Pc9
msgid "Inventory View"
msgstr "Inventory View"

#. js-lingui-id: 6RHkyC
msgid "{v} bathrooms"
msgstr "{v} bathrooms"

#. js-lingui-id: 6RmHKN
msgid "Primary Color"
msgstr "Primary Color"

#. js-lingui-id: 6SUhyj
msgid "Biweekly"
msgstr "Biweekly"

#. js-lingui-id: 6UXwfl
msgid "Send an invitation email to the tenant. They can complete the application at their convenience."
msgstr "Send an invitation email to the tenant. They can complete the application at their convenience."

#. js-lingui-id: 6XBwub
msgid "Delete Unit"
msgstr "Delete Unit"

#. js-lingui-id: 6Xdu/D
msgid "Current Balance"
msgstr "Current Balance"

#. js-lingui-id: 6YtxFj
msgid "Name"
msgstr "Name"

#. js-lingui-id: 6cHqQI
msgid "Enable the listing website functionality to allow property listings and management. This restores all listing features, providing users with tools to create and manage rental applications seamlessly."
msgstr "Enable the listing website functionality to allow property listings and management. This restores all listing features, providing users with tools to create and manage rental applications seamlessly."

#. js-lingui-id: 6dZCPF
msgid "Select events to trigger this webhook"
msgstr "Select events to trigger this webhook"

#. js-lingui-id: 6exX+8
msgid "Regenerate"
msgstr "Regenerate"

#. js-lingui-id: 6f1jSa
msgid "Failed to process action"
msgstr "Failed to process action"

#. js-lingui-id: 6foA8n
msgid "Are you sure?"
msgstr "Are you sure?"

#. js-lingui-id: 6iLZrh
msgid "Assigned Date"
msgstr "Assigned Date"

#. js-lingui-id: 6jefe3
msgid "months"
msgstr "months"

#. js-lingui-id: 6jfS51
msgid "Welcome"
msgstr "Welcome"

#. js-lingui-id: 6kPk3+
msgid "Personal Information"
msgstr "Personal Information"

#. js-lingui-id: 6lGV3K
msgid "Show less"
msgstr "Show less"

#. js-lingui-id: 6n/LTh
msgid "Your Rental Application"
msgstr "Your Rental Application"

#. js-lingui-id: 6oZDWL
msgid "Enter company address"
msgstr "Enter company address"

#. js-lingui-id: 6ogpwN
msgid "Market intelligence features are currently being developed and will be available in the next update."
msgstr "Market intelligence features are currently being developed and will be available in the next update."

#. js-lingui-id: 6oyQjb
msgid "Youtube"
msgstr "Youtube"

#. js-lingui-id: 6q4g1d
msgid "You must type \"I understand the risk\" to proceed"
msgstr "You must type \"I understand the risk\" to proceed"

#. js-lingui-id: 6wEL+N
msgid "Sign below to confirm"
msgstr "Sign below to confirm"

#. js-lingui-id: 7+btY9
msgid "A delivery agent has not been assigned to this delivery."
msgstr "A delivery agent has not been assigned to this delivery."

#. js-lingui-id: 7+i6oV
msgid "Snooze"
msgstr "Snooze"

#. js-lingui-id: 70Cb+2
msgid "All rights reserved."
msgstr "All rights reserved."

#. js-lingui-id: 70yAY8
msgid "Access Application as Tenant"
msgstr "Access Application as Tenant"

#. js-lingui-id: 71Xwww
msgid "Invalid request"
msgstr "Invalid request"

#. js-lingui-id: 72c5Qo
msgid "Total"
msgstr "Total"

#. js-lingui-id: 77pX2A
msgid "Please reach out to our friendly support team and we'll be happy to help you with your request."
msgstr "Please reach out to our friendly support team and we'll be happy to help you with your request."

#. js-lingui-id: 793noG
msgid "Please provide one of the following income documents:"
msgstr "Please provide one of the following income documents:"

#. js-lingui-id: 7AS0iK
msgid "Our system is certified by Cybersecure Canada, meeting rigorous security standards to protect your personal information. We employ industry-leading encryption and security practices to safeguard your data."
msgstr "Our system is certified by Cybersecure Canada, meeting rigorous security standards to protect your personal information. We employ industry-leading encryption and security practices to safeguard your data."

#. js-lingui-id: 7Ao9Wl
msgid "{tooltipText}: Warning"
msgstr "{tooltipText}: Warning"

#. js-lingui-id: 7BAOFm
msgid "Not assigned"
msgstr "Not assigned"

#. js-lingui-id: 7Bj3x9
msgid "Failed"
msgstr "Failed"

#. js-lingui-id: 7C6L6q
msgid "Hold this submission"
msgstr "Hold this submission"

#. js-lingui-id: 7CTnHd
msgid "Manage and invite Team Members."
msgstr "Manage and invite Team Members."

#. js-lingui-id: 7DHQo6
msgid "Average per Check"
msgstr "Average per Check"

#. js-lingui-id: 7EnT52
msgid "Tax Documents"
msgstr "Tax Documents"

#. js-lingui-id: 7H42q4
msgid "Available now"
msgstr "Available now"

#. js-lingui-id: 7HD+DV
msgid "Property manager login"
msgstr "Property manager login"

#. js-lingui-id: 7J+c8c
msgid "Can't find the address?"
msgstr "Can't find the address?"

#. js-lingui-id: 7L01XJ
msgid "Actions"
msgstr "Actions"

#. js-lingui-id: 7MuXko
msgid "Personal"
msgstr "Personal"

#. js-lingui-id: 7NqkkO
msgid "Notification sent to the applicant to remind them to complete their application"
msgstr "Notification sent to the applicant to remind them to complete their application"

#. js-lingui-id: 7PzzBU
msgid "User"
msgstr "User"

#. js-lingui-id: 7TElxB
#. placeholder {0}: submission.tenants.length
msgid "{0, plural, one {Person applying for this property} other {People applying for this property}}"
msgstr "{0, plural, one {Person applying for this property} other {People applying for this property}}"

#. js-lingui-id: 7VpPHA
msgid "Confirm"
msgstr "Confirm"

#. js-lingui-id: 7Wi/hL
msgid "Release to confirm"
msgstr "Release to confirm"

#. js-lingui-id: 7YWZId
msgid "Application in progress"
msgstr "Application in progress"

#. js-lingui-id: 7a51q5
msgid "Need help? Contact the property manager:"
msgstr "Need help? Contact the property manager:"

#. js-lingui-id: 7aDnUb
msgid "Developer"
msgstr "Developer"

#. js-lingui-id: 7eMo+U
msgid "Go Home"
msgstr "Go Home"

#. js-lingui-id: 7i8j3G
msgid "Company"
msgstr "Company"

#. js-lingui-id: 7iNO9W
msgid "Uploaded successfully"
msgstr "Uploaded successfully"

#. js-lingui-id: 7iwThZ
msgid "View and manage your upcoming property deliveries"
msgstr "View and manage your upcoming property deliveries"

#. js-lingui-id: 7jpQWC
msgid "Hurry up, 4+ people have already applied !"
msgstr "Hurry up, 4+ people have already applied !"

#. js-lingui-id: 7p5kLi
msgid "Dashboard"
msgstr "Dashboard"

#. js-lingui-id: 7pPYrg
msgid "Requires Action"
msgstr "Requires Action"

#. js-lingui-id: 7quAj0
msgid "With Utilities"
msgstr "With Utilities"

#. js-lingui-id: 7rOyDW
msgid "CR"
msgstr "CR"

#. js-lingui-id: 7sKAkn
msgid "Put on hold"
msgstr "Put on hold"

#. js-lingui-id: 7tU19g
msgid "Application Inactive"
msgstr "Application Inactive"

#. js-lingui-id: 7uHWR+
msgid "Date of Birth"
msgstr "Date of Birth"

#. js-lingui-id: 7w2+8j
msgid "Sex offender records identified."
msgstr "Sex offender records identified."

#. js-lingui-id: 800f5o
msgid "You authorize Eversa and its partners to obtain and review your credit report from a recognized credit bureau."
msgstr "You authorize Eversa and its partners to obtain and review your credit report from a recognized credit bureau."

#. js-lingui-id: 87cqmN
msgid "Confirm Unit Change"
msgstr "Confirm Unit Change"

#. js-lingui-id: 87nAg7
msgid "Active Submissions"
msgstr "Active Submissions"

#. js-lingui-id: 8B+pY5
msgid "Property"
msgstr "Property"

#. js-lingui-id: 8Bz31i
msgid "Are you sure you want to deactivate this user?"
msgstr "Are you sure you want to deactivate this user?"

#. js-lingui-id: 8F5PiU
msgid "Next, choose what to do with the remaining applications"
msgstr "Next, choose what to do with the remaining applications"

#. js-lingui-id: 8H0Id6
msgid "Enter website URL"
msgstr "Enter website URL"

#. js-lingui-id: 8HjX3H
msgid "Verify credit score"
msgstr "Verify credit score"

#. js-lingui-id: 8JXBzV
msgid "Financial health assessment"
msgstr "Financial health assessment"

#. js-lingui-id: 8KGn7T
msgid "Government Photo ID"
msgstr "Government Photo ID"

#. js-lingui-id: 8KbpTf
msgid "No Reference"
msgstr "No Reference"

#. js-lingui-id: 8PORut
msgid "Visit Conclusive"
msgstr "Visit Conclusive"

#. js-lingui-id: 8Paa3N
msgid "By accepting and proceeding, you expressly consent to the credit check under the terms outlined above."
msgstr "By accepting and proceeding, you expressly consent to the credit check under the terms outlined above."

#. js-lingui-id: 8Tg/JR
msgid "Custom"
msgstr "Custom"

#. js-lingui-id: 8U7Kq/
msgid "Promotion"
msgstr "Promotion"

#. js-lingui-id: 8YTPsu
msgid "Listing Type"
msgstr "Listing Type"

#. js-lingui-id: 8ccNPJ
msgid "Short-term Loans"
msgstr "Short-term Loans"

#. js-lingui-id: 8csHcN
msgid "Your application requires additional documentation. Please proceed to the section below to upload the requested documents."
msgstr "Your application requires additional documentation. Please proceed to the section below to upload the requested documents."

#. js-lingui-id: 8df67a
msgid "Use of Information:"
msgstr "Use of Information:"

#. js-lingui-id: 8ea8Yx
msgid "By submitting your credit check request, you acknowledge and agree to the following:"
msgstr "By submitting your credit check request, you acknowledge and agree to the following:"

#. js-lingui-id: 8f+BAx
msgid "Owns current property"
msgstr "Owns current property"

#. js-lingui-id: 8faOjQ
msgid "Create New"
msgstr "Create New"

#. js-lingui-id: 8hvxGX
msgid "Call"
msgstr "Call"

#. js-lingui-id: 8i1KwT
msgid "Additional"
msgstr "Additional"

#. js-lingui-id: 8lDp42
msgid "Building has been unarchived."
msgstr "Building has been unarchived."

#. js-lingui-id: 8nkZDI
msgid "Background check price must be greater than or equal to 0"
msgstr "Background check price must be greater than or equal to 0"

#. js-lingui-id: 8sTahH
msgid "Date Settled"
msgstr "Date Settled"

#. js-lingui-id: 9/1YKL
msgid "Enter last name"
msgstr "Enter last name"

#. js-lingui-id: 9/q/+g
msgid "No criminal records found in the last 10 years."
msgstr "No criminal records found in the last 10 years."

#. js-lingui-id: 92O9Tp
msgid "Stretched"
msgstr "Stretched"

#. js-lingui-id: 9317Ly
msgid "Copy & share link"
msgstr "Copy & share link"

#. js-lingui-id: 9392kR
msgid "Authorization:"
msgstr "Authorization:"

#. js-lingui-id: 95E4wJ
msgid "Last 24 months of payment activity"
msgstr "Last 24 months of payment activity"

#. js-lingui-id: 95U74+
msgid "This property is no longer available"
msgstr "This property is no longer available"

#. js-lingui-id: 97V8+4
msgid "No deliveries scheduled for this date."
msgstr "No deliveries scheduled for this date."

#. js-lingui-id: 97e/Vk
msgid "Credit Check Reports"
msgstr "Credit Check Reports"

#. js-lingui-id: 99W5Gw
msgid "Submission has been successfully marked as visit conclusive"
msgstr "Submission has been successfully marked as visit conclusive"

#. js-lingui-id: 99aYHN
msgid "Require tenants to provide landlord references"
msgstr "Require tenants to provide landlord references"

#. js-lingui-id: 9AGWn9
msgid "income"
msgstr "income"

#. js-lingui-id: 9AYRvD
msgid "Enter your date of birth"
msgstr "Enter your date of birth"

#. js-lingui-id: 9Eq34y
msgid "Reference Check Not Run"
msgstr "Reference Check Not Run"

#. js-lingui-id: 9GaiPo
msgid "e.g., Self-employed, student, retired, etc."
msgstr "e.g., Self-employed, student, retired, etc."

#. js-lingui-id: 9K4YRv
msgid "Ideal candidate, strong financial health"
msgstr "Ideal candidate, strong financial health"

#. js-lingui-id: 9LZMmC
msgid "Please provide your date of birth to proceed with the credit check"
msgstr "Please provide your date of birth to proceed with the credit check"

#. js-lingui-id: 9PTaMz
msgid "Available From"
msgstr "Available From"

#. js-lingui-id: 9QIaqi
msgid "Add a payment method to accept applicants and use all features"
msgstr "Add a payment method to accept applicants and use all features"

#. js-lingui-id: 9Qs99X
msgid "Email:"
msgstr "Email:"

#. js-lingui-id: 9W3KV/
msgid "Setup Payment"
msgstr "Setup Payment"

#. js-lingui-id: 9WVFoB
msgid "Snooze this application if you are missing additional details"
msgstr "Snooze this application if you are missing additional details"

#. js-lingui-id: 9ZPH8F
msgid "Strong Candidate"
msgstr "Strong Candidate"

#. js-lingui-id: 9aloPG
msgid "References"
msgstr "References"

#. js-lingui-id: 9bOOxk
msgid "The image with the \"Featured\" badge will be your main image"
msgstr "The image with the \"Featured\" badge will be your main image"

#. js-lingui-id: 9cezby
msgid "Please explain why you don't have a landlord reference"
msgstr "Please explain why you don't have a landlord reference"

#. js-lingui-id: 9cxCHd
msgid "Hi {firstName},<0/><1>Your Application Needs Attention</1>"
msgstr "Hi {firstName},<0/><1>Your Application Needs Attention</1>"

#. js-lingui-id: 9e930q
msgid "e.g., First time renting, previous landlord is no longer available, etc."
msgstr "e.g., First time renting, previous landlord is no longer available, etc."

#. js-lingui-id: 9eF5oV
msgid "Welcome back"
msgstr "Welcome back"

#. js-lingui-id: 9fkkek
msgid "Minimum required income as multiple of rent"
msgstr "Minimum required income as multiple of rent"

#. js-lingui-id: 9gCieb
msgid "Confirm user identity"
msgstr "Confirm user identity"

#. js-lingui-id: 9iqnDb
msgid "{promotionPrice}$ / Monthly"
msgstr "{promotionPrice}$ / Monthly"

#. js-lingui-id: 9msbaN
msgid "Edit listing"
msgstr "Edit listing"

#. js-lingui-id: 9qhp8Z
msgid "Credit Report Consent"
msgstr "Credit Report Consent"

#. js-lingui-id: 9qpf5y
msgid "Unfinished Submissions"
msgstr "Unfinished Submissions"

#. js-lingui-id: 9sFPiZ
msgid "Having someone co-sign or guarantee your lease could provide additional security."
msgstr "Having someone co-sign or guarantee your lease could provide additional security."

#. js-lingui-id: 9wTb7y
msgid "SIN must be 9 digits"
msgstr "SIN must be 9 digits"

#. js-lingui-id: A0Ba3X
msgid "Delivery Calendar"
msgstr "Delivery Calendar"

#. js-lingui-id: A0C9La
msgid "Email us"
msgstr "Email us"

#. js-lingui-id: A0eVKL
msgid "Enable tenants to add co-applicants to their application"
msgstr "Enable tenants to add co-applicants to their application"

#. js-lingui-id: A1taO8
msgid "Search"
msgstr "Search"

#. js-lingui-id: A2FDZa
msgid "You are currently viewing the dashboard as {selectedAgentFName} {selectedAgentLName}"
msgstr "You are currently viewing the dashboard as {selectedAgentFName} {selectedAgentLName}"

#. js-lingui-id: A5Rcld
msgid "Transit Score®"
msgstr "Transit Score®"

#. js-lingui-id: A6rJrW
msgid "Manage your settings."
msgstr "Manage your settings."

#. js-lingui-id: A8xwgi
msgid "Lease Information"
msgstr "Lease Information"

#. js-lingui-id: AIYkvD
msgid "Maximum allowed credit utilization percentage"
msgstr "Maximum allowed credit utilization percentage"

#. js-lingui-id: AIupfI
msgid "To start your application, please enter your email address and verify it"
msgstr "To start your application, please enter your email address and verify it"

#. js-lingui-id: AKF94d
msgid "Business documents, contracts, or income statements if self-employed"
msgstr "Business documents, contracts, or income statements if self-employed"

#. js-lingui-id: AKx4pt
msgid "You are applying with email updates. Do not exit until the process is completed."
msgstr "You are applying with email updates. Do not exit until the process is completed."

#. js-lingui-id: AModYF
msgid "New Applicant"
msgstr "New Applicant"

#. js-lingui-id: ANkWB0
msgid "No listings found"
msgstr "No listings found"

#. js-lingui-id: AO5QEO
msgid "Previous Landlord"
msgstr "Previous Landlord"

#. js-lingui-id: APvW6L
msgid "Utilization"
msgstr "Utilization"

#. js-lingui-id: AQRrKw
msgid "Promotion removed from unit"
msgstr "Promotion removed from unit"

#. js-lingui-id: AQoIUq
msgid "Verification Checks"
msgstr "Verification Checks"

#. js-lingui-id: AQoSYJ
msgid "Account Details"
msgstr "Account Details"

#. js-lingui-id: AXQ2Ts
msgid "Enter the english description"
msgstr "Enter the english description"

#. js-lingui-id: AaGTbP
msgid "Move to favorite listing?"
msgstr "Move to favorite listing?"

#. js-lingui-id: Aar52/
msgid "Annual Salary"
msgstr "Annual Salary"

#. js-lingui-id: AdMvsx
msgid "listed"
msgstr "listed"

#. js-lingui-id: Ae7pe8
msgid "Not received"
msgstr "Not received"

#. js-lingui-id: AeTZZf
msgid "Tenants pay for their application"
msgstr "Tenants pay for their application"

#. js-lingui-id: AjkJ0d
msgid "I acknowledge and agree that any fees paid to <0>Eversa</0> are non-refundable and will be used to process and analyze my profile."
msgstr "I acknowledge and agree that any fees paid to <0>Eversa</0> are non-refundable and will be used to process and analyze my profile."

#. js-lingui-id: AlGvz8
msgid "Check back later for updates."
msgstr "Check back later for updates."

#. js-lingui-id: AlniDR
msgid "Based on inquiries from different types of lenders"
msgstr "Based on inquiries from different types of lenders"

#. js-lingui-id: Any6KN
msgid "Enter amount in dollars (e.g. 300)"
msgstr "Enter amount in dollars (e.g. 300)"

#. js-lingui-id: Ap948/
msgid "Listed"
msgstr "Listed"

#. js-lingui-id: ApsD9J
msgid "Add New"
msgstr "Add New"

#. js-lingui-id: Aso3xS
msgid "Commercial rentals"
msgstr "Commercial rentals"

#. js-lingui-id: AugMgz
msgid "Void cheque"
msgstr "Void cheque"

#. js-lingui-id: B8sGeq
msgid "Global watchlist screening"
msgstr "Global watchlist screening"

#. js-lingui-id: B9usNx
msgid "The submission status will be sent back to the start of the process."
msgstr "The submission status will be sent back to the start of the process."

#. js-lingui-id: BAOatb
msgid "Credit check request for {applicantFirstName} {applicantLastName} sent!"
msgstr "Credit check request for {applicantFirstName} {applicantLastName} sent!"

#. js-lingui-id: BBUDfW
msgid "Urgent"
msgstr "Urgent"

#. js-lingui-id: BCgdx+
msgid "Deactivate User"
msgstr "Deactivate User"

#. js-lingui-id: BGU1P9
msgid "Ads Conversion ID"
msgstr "Ads Conversion ID"

#. js-lingui-id: BJ943b
msgid "Mortgage Alert"
msgstr "Mortgage Alert"

#. js-lingui-id: BL2UDm
msgid "Run a credit check to get valuable insights into financial history and make better informed decisions."
msgstr "Run a credit check to get valuable insights into financial history and make better informed decisions."

#. js-lingui-id: BP1ZpV
msgid "Payment successful - Tenant is paying"
msgstr "Payment successful - Tenant is paying"

#. js-lingui-id: BSZHw4
msgid "Debt Ratio"
msgstr "Debt Ratio"

#. js-lingui-id: BWW2FN
msgid "All set! No deliveries are scheduled for this day."
msgstr "All set! No deliveries are scheduled for this day."

#. js-lingui-id: BXEcos
msgid "Emails"
msgstr "Emails"

#. js-lingui-id: BZz12Q
msgid "Print"
msgstr "Print"

#. js-lingui-id: BaaXjJ
msgid "Type of condition"
msgstr "Type of condition"

#. js-lingui-id: Bc8WYp
msgid "Personal Loans"
msgstr "Personal Loans"

#. js-lingui-id: Bep3Ll
msgid "The payment has been processed successfully."
msgstr "The payment has been processed successfully."

#. js-lingui-id: BrMQb6
msgid "Quebec small claims court records"
msgstr "Quebec small claims court records"

#. js-lingui-id: Bw5X+M
msgid "Search by name or email"
msgstr "Search by name or email"

#. js-lingui-id: BwJKBw
msgid "of"
msgstr "of"

#. js-lingui-id: Bzfr5Q
msgid "Recent Pay Stubs"
msgstr "Recent Pay Stubs"

#. js-lingui-id: C0C0dS
msgid "Send Invitation"
msgstr "Send Invitation"

#. js-lingui-id: C2XrlJ
msgid "Court Orders"
msgstr "Court Orders"

#. js-lingui-id: C3nD/1
msgid "Enter your email"
msgstr "Enter your email"

#. js-lingui-id: C3yOz3
msgid "Last updated"
msgstr "Last updated"

#. js-lingui-id: CCXa60
msgid "No documents uploaded"
msgstr "No documents uploaded"

#. js-lingui-id: CCyFtH
msgid "Continue to complete the application."
msgstr "Continue to complete the application."

#. js-lingui-id: CFUuM9
msgid "complete deliveries"
msgstr "complete deliveries"

#. js-lingui-id: CHaBWG
msgid "Notification updated"
msgstr "Notification updated"

#. js-lingui-id: CHeXuc
msgid "Units / ({listingCount} listings)"
msgstr "Units / ({listingCount} listings)"

#. js-lingui-id: CJd3kI
msgid "This information will be used to contact you"
msgstr "This information will be used to contact you"

#. js-lingui-id: CKyk7Q
msgid "Go back"
msgstr "Go back"

#. js-lingui-id: CQypwd
msgid "Edit Promotion"
msgstr "Edit Promotion"

#. js-lingui-id: CVNSSG
msgid "Your application<0/> has been removed"
msgstr "Your application<0/> has been removed"

#. js-lingui-id: CW11B+
msgid "Minimum"
msgstr "Minimum"

#. js-lingui-id: CW12bM
msgid "Unfinished"
msgstr "Unfinished"

#. js-lingui-id: CbwuN5
msgid "AI Verified"
msgstr "AI Verified"

#. js-lingui-id: CdVrCa
msgid "Your current role has no action to take here"
msgstr "Your current role has no action to take here"

#. js-lingui-id: CgPSDs
msgid "Need help? Email our support team at {emailLink} for assistance."
msgstr "Need help? Email our support team at {emailLink} for assistance."

#. js-lingui-id: CgpEzf
msgid "You've successfully removed the visit agent from this submission"
msgstr "You've successfully removed the visit agent from this submission"

#. js-lingui-id: ChVlsi
msgid "Proof of Funds"
msgstr "Proof of Funds"

#. js-lingui-id: CikZHq
msgid "Unfortunately, at this moment your application has been removed. You can always try again later or contact the property manager if your situation changes."
msgstr "Unfortunately, at this moment your application has been removed. You can always try again later or contact the property manager if your situation changes."

#. js-lingui-id: Cl4Mxm
msgid "Search for applicants, submissions and more..."
msgstr "Search for applicants, submissions and more..."

#. js-lingui-id: ClKRQy
msgid "Salary is required"
msgstr "Salary is required"

#. js-lingui-id: CnYzHV
msgid "An unexpected error occurred during import"
msgstr "An unexpected error occurred during import"

#. js-lingui-id: CqEAWK
msgid "Send credit check request"
msgstr "Send credit check request"

#. js-lingui-id: CrghM6
msgid "Parking Available"
msgstr "Parking Available"

#. js-lingui-id: CsUQ0O
msgid "Add Manually"
msgstr "Add Manually"

#. js-lingui-id: CsekCi
msgid "Normal"
msgstr "Normal"

#. js-lingui-id: CtihIc
msgid "e.g. John Smith - Property Manager"
msgstr "e.g. John Smith - Property Manager"

#. js-lingui-id: CxH5/W
msgid "Building not found"
msgstr "Building not found"

#. js-lingui-id: CzaXHi
msgid "View Timeline"
msgstr "View Timeline"

#. js-lingui-id: D1A/Xd
msgid "Quick search command"
msgstr "Quick search command"

#. js-lingui-id: D21vC4
msgid "By checking this box, I acknowledge that I have read, understood and agree to be bound by the <0>Terms of Service</0> and <1>Privacy Policy</1>. I understand that these terms constitute a legally binding agreement between myself and <2>Eversa</2>."
msgstr "By checking this box, I acknowledge that I have read, understood and agree to be bound by the <0>Terms of Service</0> and <1>Privacy Policy</1>. I understand that these terms constitute a legally binding agreement between myself and <2>Eversa</2>."

#. js-lingui-id: D3LSdO
msgid "Final Decision"
msgstr "Final Decision"

#. js-lingui-id: D3iCkb
msgid "Start Date"
msgstr "Start Date"

#. js-lingui-id: D3qEVV
msgid "Eversa is a Canadian company, your data is stored securely with us in Canada."
msgstr "Eversa is a Canadian company, your data is stored securely with us in Canada."

#. js-lingui-id: D7fqU3
msgid "The tenant does not have an email address"
msgstr "The tenant does not have an email address"

#. js-lingui-id: D87pha
msgid "Closed"
msgstr "Closed"

#. js-lingui-id: D89zck
msgid "Sun"
msgstr "Sun"

#. js-lingui-id: DAwCl5
msgid "DTI Ratio:"
msgstr "DTI Ratio:"

#. js-lingui-id: DEv2VI
msgid "Add your references"
msgstr "Add your references"

#. js-lingui-id: DG4xYU
msgid "Complete the application now with the tenant present. Perfect for in-person meetings."
msgstr "Complete the application now with the tenant present. Perfect for in-person meetings."

#. js-lingui-id: DGHZEW
msgid "Change interface language"
msgstr "Change interface language"

#. js-lingui-id: DHHybq
msgid "Last event"
msgstr "Last event"

#. js-lingui-id: DHhJ7s
msgid "Previous"
msgstr "Previous"

#. js-lingui-id: DK7nfO
msgid "Failed to process file"
msgstr "Failed to process file"

#. js-lingui-id: DL2sg0
msgid "Listings"
msgstr "Listings"

#. js-lingui-id: DOoOKe
msgid "Finances, Debts and Trends"
msgstr "Finances, Debts and Trends"

#. js-lingui-id: DQJljB
msgid "Conservative"
msgstr "Conservative"

#. js-lingui-id: DV+Xbw
msgid "Preferred Language"
msgstr "Preferred Language"

#. js-lingui-id: DXbmUR
msgid "Download the data of this submission (.csv)"
msgstr "Download the data of this submission (.csv)"

#. js-lingui-id: DYlwPh
msgid "Contact Person"
msgstr "Contact Person"

#. js-lingui-id: Dd/uIU
msgid "4+ deliveries"
msgstr "4+ deliveries"

#. js-lingui-id: DdK2nW
msgid "Confirmation"
msgstr "Confirmation"

#. js-lingui-id: De3Ie0
msgid "Move submission"
msgstr "Move submission"

#. js-lingui-id: DivT5Y
msgid "Restore listing"
msgstr "Restore listing"

#. js-lingui-id: Dj0nYr
msgid "years old"
msgstr "years old"

#. js-lingui-id: DjJQTF
msgid "Click to browse or drag and drop your XLSX file here"
msgstr "Click to browse or drag and drop your XLSX file here"

#. js-lingui-id: Dlfv6C
msgid "Simple payment process"
msgstr "Simple payment process"

#. js-lingui-id: Dn4OyV
msgid "Invited"
msgstr "Invited"

#. js-lingui-id: DnXcDK
msgid "Secondary Color"
msgstr "Secondary Color"

#. js-lingui-id: DoJzLz
msgid "Collections"
msgstr "Collections"

#. js-lingui-id: Ds3qWZ
msgid "No Images Found"
msgstr "No Images Found"

#. js-lingui-id: Du6bPw
msgid "Address"
msgstr "Address"

#. js-lingui-id: DwuoH0
msgid "Facebook"
msgstr "Facebook"

#. js-lingui-id: E+kmgy
msgid "Your personal information"
msgstr "Your personal information"

#. js-lingui-id: E/QGRL
msgid "Disabled"
msgstr "Disabled"

#. js-lingui-id: E/muDO
msgid "Documents"
msgstr "Documents"

#. js-lingui-id: E2QQUV
msgid "Total Units"
msgstr "Total Units"

#. js-lingui-id: EAeu1Z
msgid "Send Invite"
msgstr "Send Invite"

#. js-lingui-id: ECHQNh
msgid "Need help with your application? We're here to assist you."
msgstr "Need help with your application? We're here to assist you."

#. js-lingui-id: EG1klK
msgid "This report contains confidential information and is intended for authorized use only. Unauthorized reproduction or distribution is strictly prohibited."
msgstr "This report contains confidential information and is intended for authorized use only. Unauthorized reproduction or distribution is strictly prohibited."

#. js-lingui-id: EJoQGk
msgid "Configure a reply-to address that will be added to all system emails"
msgstr "Configure a reply-to address that will be added to all system emails"

#. js-lingui-id: EKSQjb
msgid "The leading platform for secure rental applications"
msgstr "The leading platform for secure rental applications"

#. js-lingui-id: EMiXCv
msgid "Enter number of years"
msgstr "Enter number of years"

#. js-lingui-id: EN4IBj
msgid "Promotion added to unit"
msgstr "Promotion added to unit"

#. js-lingui-id: ENJDQl
msgid "View Full Documentation"
msgstr "View Full Documentation"

#. js-lingui-id: EOaL1y
msgid "Visit conclusive"
msgstr "Visit conclusive"

#. js-lingui-id: EUQxfg
msgid "Fetching user information..."
msgstr "Fetching user information..."

#. js-lingui-id: EX1qi4
msgid "Upload Listings XLSX"
msgstr "Upload Listings XLSX"

#. js-lingui-id: EXtiXe
msgid "Valid passport photo page"
msgstr "Valid passport photo page"

#. js-lingui-id: EYK5tO
msgid "Project Name"
msgstr "Project Name"

#. js-lingui-id: EbFCme
msgid "No documents have been uploaded yet"
msgstr "No documents have been uploaded yet"

#. js-lingui-id: EbMPZJ
msgid "Unassigned"
msgstr "Unassigned"

#. js-lingui-id: EbuTi3
msgid "Alias"
msgstr "Alias"

#. js-lingui-id: EeZ0kf
msgid "Doe"
msgstr "Doe"

#. js-lingui-id: Ef7StM
msgid "Unknown"
msgstr "Unknown"

#. js-lingui-id: Efav/Z
msgid "Manage application settings"
msgstr "Manage application settings"

#. js-lingui-id: Eiidzq
msgid "Recent pay stub within 30 days"
msgstr "Recent pay stub within 30 days"

#. js-lingui-id: Ekxv+g
msgid "This invitation link is no longer valid. Try signing in again."
msgstr "This invitation link is no longer valid. Try signing in again."

#. js-lingui-id: ElGPqI
msgid "Rental"
msgstr "Rental"

#. js-lingui-id: Em99RO
msgid "Waiting for agent to process"
msgstr "Waiting for agent to process"

#. js-lingui-id: En7KCe
msgid "Hold to confirm"
msgstr "Hold to confirm"

#. js-lingui-id: Et7HPM
msgid "Continue Application"
msgstr "Continue Application"

#. js-lingui-id: Ev7gHH
msgid "Public safety concerns recorded due to criminal activity."
msgstr "Public safety concerns recorded due to criminal activity."

#. js-lingui-id: ExXy+X
msgid "Select Status"
msgstr "Select Status"

#. js-lingui-id: F/iVsn
msgid "Your billing plan information"
msgstr "Your billing plan information"

#. js-lingui-id: F2SymW
msgid "{price}$ / Monthly"
msgstr "{price}$ / Monthly"

#. js-lingui-id: F6PJ/y
msgid "Upcoming Deliveries"
msgstr "Upcoming Deliveries"

#. js-lingui-id: F6p/C4
msgid "Phone:"
msgstr "Phone:"

#. js-lingui-id: F6pfE9
msgid "Active"
msgstr "Active"

#. js-lingui-id: F7G/TS
msgid "Frequently Asked Questions"
msgstr "Frequently Asked Questions"

#. js-lingui-id: F7dRcr
msgid "Fair"
msgstr "Fair"

#. js-lingui-id: FGByEW
msgid "Matches found on the OFAC sanctions list."
msgstr "Matches found on the OFAC sanctions list."

#. js-lingui-id: FHriZ8
msgid "Previous tenant information updated"
msgstr "Previous tenant information updated"

#. js-lingui-id: FKAZwN
msgid "Manage settings for co-applicants and guarantors on the application"
msgstr "Manage settings for co-applicants and guarantors on the application"

#. js-lingui-id: FMGl6q
msgid "<0>{price}$</0> per month"
msgstr "<0>{price}$</0> per month"

#. js-lingui-id: FN82/x
msgid "Analysis based on GTI (Global Tenant Index) standards"
msgstr "Analysis based on GTI (Global Tenant Index) standards"

#. js-lingui-id: FNlEzE
msgid "Continue my application"
msgstr "Continue my application"

#. js-lingui-id: FNsxkO
msgid "Disposition"
msgstr "Disposition"

#. js-lingui-id: FPX4Rd
msgid "No references found"
msgstr "No references found"

#. js-lingui-id: FWxdTT
msgid "Cleared"
msgstr "Cleared"

#. js-lingui-id: FapWIq
msgid "Core Features"
msgstr "Core Features"

#. js-lingui-id: FbTWN1
msgid "Check back later."
msgstr "Check back later."

#. js-lingui-id: FbpJXz
msgid "Enter building name (optional)"
msgstr "Enter building name (optional)"

#. js-lingui-id: Fdp03t
msgid "on"
msgstr "on"

#. js-lingui-id: Fj50FP
msgid "Daily Recap"
msgstr "Daily Recap"

#. js-lingui-id: FjaBem
msgid "The email is invalid"
msgstr "The email is invalid"

#. js-lingui-id: FjrT4G
msgid "Choose Application Type"
msgstr "Choose Application Type"

#. js-lingui-id: Fk5NbU
msgid "On hold"
msgstr "On hold"

#. js-lingui-id: FkMol5
msgid "Featured"
msgstr "Featured"

#. js-lingui-id: FlqkF1
msgid "Square footage"
msgstr "Square footage"

#. js-lingui-id: FswBjM
msgid "Submission Address"
msgstr "Submission Address"

#. js-lingui-id: FxFJ4e
msgid "Failed to import data"
msgstr "Failed to import data"

#. js-lingui-id: FxTn4x
msgid "{tenantName}: Rent this {type} with {bedrooms} bedrooms in {city}, {address}"
msgstr "{tenantName}: Rent this {type} with {bedrooms} bedrooms in {city}, {address}"

#. js-lingui-id: Fy4HWw
msgid "PDF, JPG or PNG (Max 25MB)"
msgstr "PDF, JPG or PNG (Max 25MB)"

#. js-lingui-id: FyavOr
msgid "What if I need to update my application information?"
msgstr "What if I need to update my application information?"

#. js-lingui-id: G+h9DO
msgid "PROMO"
msgstr "PROMO"

#. js-lingui-id: G1VOz1
msgid "Employment Verification"
msgstr "Employment Verification"

#. js-lingui-id: G1WpOL
msgid "NAME"
msgstr "NAME"

#. js-lingui-id: G58cd9
msgid "Please upload the following documents to continue your application:"
msgstr "Please upload the following documents to continue your application:"

#. js-lingui-id: G6V8x2
msgid "Cancel Change"
msgstr "Cancel Change"

#. js-lingui-id: G6dKO3
msgid "You applied on"
msgstr "You applied on"

#. js-lingui-id: G6ehma
msgid "Notification sent to the applicant when you reject their application"
msgstr "Notification sent to the applicant when you reject their application"

#. js-lingui-id: G7Ee56
msgid "Edit Credit Report Prices"
msgstr "Edit Credit Report Prices"

#. js-lingui-id: G8VwSE
msgid "Discard Submission"
msgstr "Discard Submission"

#. js-lingui-id: G8krfe
msgid "Webhook Integration"
msgstr "Webhook Integration"

#. js-lingui-id: GCPgtC
msgid "Current debt + housing costs as % of monthly income"
msgstr "Current debt + housing costs as % of monthly income"

#. js-lingui-id: GCcKak
msgid "incomplete deliveries"
msgstr "incomplete deliveries"

#. js-lingui-id: GDvlUT
msgid "Role"
msgstr "Role"

#. js-lingui-id: GHms8Q
msgid "Submissions snoozed"
msgstr "Submissions snoozed"

#. js-lingui-id: GKA1kw
msgid "Building Address"
msgstr "Building Address"

#. js-lingui-id: GM6r8L
msgid "Enter a promotional title"
msgstr "Enter a promotional title"

#. js-lingui-id: GP3VtI
msgid "Refund tenants their application fee"
msgstr "Refund tenants their application fee"

#. js-lingui-id: GT1jUe
msgid "Note: While these options may help, approval is not guaranteed. Please discuss with the property manager."
msgstr "Note: While these options may help, approval is not guaranteed. Please discuss with the property manager."

#. js-lingui-id: GVcaW6
msgid "Organization Details"
msgstr "Organization Details"

#. js-lingui-id: GXS4J1
msgid "Full Application Available"
msgstr "Full Application Available"

#. js-lingui-id: GjCAJg
msgid "Enter the 6-digit verification code that was sent to your email."
msgstr "Enter the 6-digit verification code that was sent to your email."

#. js-lingui-id: GoxULk
msgid "Recent Bank Statements (last 3 months)"
msgstr "Recent Bank Statements (last 3 months)"

#. js-lingui-id: GpB8YV
msgid "Enterprise"
msgstr "Enterprise"

#. js-lingui-id: GqNjfs
msgid "Group snoozed submissions under their own category instead of having them inline with other submissions. This provides a cleaner organization of submissions based on their status."
msgstr "Group snoozed submissions under their own category instead of having them inline with other submissions. This provides a cleaner organization of submissions based on their status."

#. js-lingui-id: GtJbUa
msgid "Background"
msgstr "Background"

#. js-lingui-id: Gwzyfn
msgid "Select a listing"
msgstr "Select a listing"

#. js-lingui-id: GxkJXS
msgid "Uploading..."
msgstr "Uploading..."

#. js-lingui-id: H2AIsE
msgid "Try searching for something else."
msgstr "Try searching for something else."

#. js-lingui-id: H2EU8I
msgid "Add another address"
msgstr "Add another address"

#. js-lingui-id: H4tgrw
msgid "Below Minimum Score"
msgstr "Below Minimum Score"

#. js-lingui-id: H5HR1b
msgid "No credit inquiries found for the last 24 months"
msgstr "No credit inquiries found for the last 24 months"

#. js-lingui-id: H5S5NO
msgid "Confirm & Reset Status"
msgstr "Confirm & Reset Status"

#. js-lingui-id: HF6C2L
msgid "Phone Number"
msgstr "Phone Number"

#. js-lingui-id: HJ7K9X
msgid "Agent Assigned"
msgstr "Agent Assigned"

#. js-lingui-id: HJEnON
msgid "Account opened since"
msgstr "Account opened since"

#. js-lingui-id: HJebc2
msgid "Applicant name information is missing."
msgstr "Applicant name information is missing."

#. js-lingui-id: HQ1U8X
msgid "Verify the background history and related public records of the applicant"
msgstr "Verify the background history and related public records of the applicant"

#. js-lingui-id: HZSI85
msgid "Minimum Credit Grade"
msgstr "Minimum Credit Grade"

#. js-lingui-id: Hctf5Q
msgid "👋 Hello {firstName},<0/><1>Let's get your application processed!</1>"
msgstr "👋 Hello {firstName},<0/><1>Let's get your application processed!</1>"

#. js-lingui-id: HdNp/P
#. placeholder {0}: checks.length
msgid "{completedChecks, plural, zero {No checks ran} other {# / {0} checks ran}}"
msgstr "{completedChecks, plural, zero {No checks ran} other {# / {0} checks ran}}"

#. js-lingui-id: HeN7zs
msgid "Rent Only"
msgstr "Rent Only"

#. js-lingui-id: HhVDr2
msgid "Listing"
msgstr "Listing"

#. js-lingui-id: Hj9uqD
msgid "Rent Affordability"
msgstr "Rent Affordability"

#. js-lingui-id: Hlwffm
msgid "Submission rejected successfully"
msgstr "Submission rejected successfully"

#. js-lingui-id: Hnmg3x
msgid "Tenant Rating"
msgstr "Tenant Rating"

#. js-lingui-id: HoAdho
msgid "Edit Unit"
msgstr "Edit Unit"

#. js-lingui-id: HoKJXX
msgid "Request a free credit score check from your applicants within seconds"
msgstr "Request a free credit score check from your applicants within seconds"

#. js-lingui-id: HsoeaR
msgid "Submission Process"
msgstr "Submission Process"

#. js-lingui-id: HvI0Mo
msgid "Loading units..."
msgstr "Loading units..."

#. js-lingui-id: Hvgw7t
msgid "Multi-tenant buildings"
msgstr "Multi-tenant buildings"

#. js-lingui-id: I0hU01
msgid "Search Projects"
msgstr "Search Projects"

#. js-lingui-id: I2ODJi
msgid "Français"
msgstr "Français"

#. js-lingui-id: I2T846
msgid "Credit Assessment"
msgstr "Credit Assessment"

#. js-lingui-id: I4auxj
msgid "Please provide the most recent address where you have lived for the last 6 months."
msgstr "Please provide the most recent address where you have lived for the last 6 months."

#. js-lingui-id: I7CWPu
msgid "Absolutely! Eversa is a completely free platform. There are no hidden modules or features restricted behind a subscription. Enjoy full access to all our powerful tools for vacancy management without any additional costs."
msgstr "Absolutely! Eversa is a completely free platform. There are no hidden modules or features restricted behind a subscription. Enjoy full access to all our powerful tools for vacancy management without any additional costs."

#. js-lingui-id: ICMeFK
msgid "Accuracy of Data:"
msgstr "Accuracy of Data:"

#. js-lingui-id: ID6Zr+
msgid "Specify how many months of rent can be prepaid, in order to have the application reconsidered. This can be optional or required."
msgstr "Specify how many months of rent can be prepaid, in order to have the application reconsidered. This can be optional or required."

#. js-lingui-id: IDac6P
msgid "Edit Building"
msgstr "Edit Building"

#. js-lingui-id: IEKWq5
msgid "Associated Product:"
msgstr "Associated Product:"

#. js-lingui-id: IEQzgN
msgid "{tenantName} rental: Spacious {type}, {bedrooms} bedrooms, {city}"
msgstr "{tenantName} rental: Spacious {type}, {bedrooms} bedrooms, {city}"

#. js-lingui-id: IITbPp
msgid "Lead"
msgstr "Lead"

#. js-lingui-id: IM2CeX
msgid "Your application was incomplete or missing required information."
msgstr "Your application was incomplete or missing required information."

#. js-lingui-id: IMNkoY
msgid "Website URL is required"
msgstr "Website URL is required"

#. js-lingui-id: IUwGEM
msgid "Save Changes"
msgstr "Save Changes"

#. js-lingui-id: IY/gko
msgid "From <0>{price}$</0> per month"
msgstr "From <0>{price}$</0> per month"

#. js-lingui-id: IZBuxM
msgid "{tenantName} rental: {type} with {bedrooms} bedrooms, {address}, {city}"
msgstr "{tenantName} rental: {type} with {bedrooms} bedrooms, {address}, {city}"

#. js-lingui-id: IaIcEJ
msgid "Verified AI Salary"
msgstr "Verified AI Salary"

#. js-lingui-id: Iewazh
msgid "Waiting on the candidate application"
msgstr "Waiting on the candidate application"

#. js-lingui-id: IhK/fx
msgid "Landlord events & messages"
msgstr "Landlord events & messages"

#. js-lingui-id: Ii5qZa
msgid "Enter the applicant's basic details"
msgstr "Enter the applicant's basic details"

#. js-lingui-id: IlgkMC
msgid "Oops! We Hit a Small Bump"
msgstr "Oops! We Hit a Small Bump"

#. js-lingui-id: In6IBd
msgid "Building Name"
msgstr "Building Name"

#. js-lingui-id: IpLBXM
msgid "Rental Agent"
msgstr "Rental Agent"

#. js-lingui-id: IrVrmR
msgid "Main applicant cannot be deleted"
msgstr "Main applicant cannot be deleted"

#. js-lingui-id: IvINDM
msgid "Where do you live now?"
msgstr "Where do you live now?"

#. js-lingui-id: IwnKXj
msgid "Discard this submission"
msgstr "Discard this submission"

#. js-lingui-id: J/Upwb
msgid "days"
msgstr "days"

#. js-lingui-id: J1B1dP
msgid "Modify"
msgstr "Modify"

#. js-lingui-id: J2dS+A
msgid "No need to reapply or pay again during this period"
msgstr "No need to reapply or pay again during this period"

#. js-lingui-id: J3YyL7
msgid "Write a clear message explaining what the tenant needs to do"
msgstr "Write a clear message explaining what the tenant needs to do"

#. js-lingui-id: J5n776
msgid "Browse Listings"
msgstr "Browse Listings"

#. js-lingui-id: J8sZ7D
msgid "Action Required"
msgstr "Action Required"

#. js-lingui-id: JCb3JP
msgid "submissions"
msgstr "submissions"

#. js-lingui-id: JEBt3r
msgid "Add Co-Applicant"
msgstr "Add Co-Applicant"

#. js-lingui-id: JF/w5z
msgid "What are you looking for?"
msgstr "What are you looking for?"

#. js-lingui-id: JHmKfG
msgid "Total {totalUnits} units"
msgstr "Total {totalUnits} units"

#. js-lingui-id: JIP6qc
msgid "Currently renting"
msgstr "Currently renting"

#. js-lingui-id: JJCjZM
msgid "Information about the application"
msgstr "Information about the application"

#. js-lingui-id: JJzwOq
msgid "Failed to create user"
msgstr "Failed to create user"

#. js-lingui-id: JNCzPW
msgid "Country"
msgstr "Country"

#. js-lingui-id: JS/504
msgid "Number of months"
msgstr "Number of months"

#. js-lingui-id: JUce1S
msgid "Assignees"
msgstr "Assignees"

#. js-lingui-id: Jc7aDb
msgid "Credit report prices updated successfully"
msgstr "Credit report prices updated successfully"

#. js-lingui-id: JdiJHl
msgid "Building:"
msgstr "Building:"

#. js-lingui-id: JdkdDD
msgid "Action Required: Application Needs Additional Support"
msgstr "Action Required: Application Needs Additional Support"

#. js-lingui-id: JdnU4B
msgid "Our team has been automatically notified and is investigating the issue."
msgstr "Our team has been automatically notified and is investigating the issue."

#. js-lingui-id: Je4WIx
msgid "24-48 business hours"
msgstr "24-48 business hours"

#. js-lingui-id: JesBBS
msgid "Joint"
msgstr "Joint"

#. js-lingui-id: JgSSDZ
msgid "Please provide address history for the last 6 months"
msgstr "Please provide address history for the last 6 months"

#. js-lingui-id: Jh2n6b
msgid "Applicant"
msgstr "Applicant"

#. js-lingui-id: JhtZAK
msgid "Payment Failed"
msgstr "Payment Failed"

#. js-lingui-id: JiFNm/
msgid "Individual at risk"
msgstr "Individual at risk"

#. js-lingui-id: Jj0hAF
msgid "Verify income stability and payment history"
msgstr "Verify income stability and payment history"

#. js-lingui-id: JkToak
msgid "Max Prices"
msgstr "Max Prices"

#. js-lingui-id: JmGR0x
msgid "Digital Banks"
msgstr "Digital Banks"

#. js-lingui-id: JnZYox
msgid "Submission steps updated"
msgstr "Submission steps updated"

#. js-lingui-id: JnpUum
msgid "120 days"
msgstr "120 days"

#. js-lingui-id: JpohL9
msgid "Tax"
msgstr "Tax"

#. js-lingui-id: JtMAqE
msgid "Application steps"
msgstr "Application steps"

#. js-lingui-id: JviCz3
msgid "studio"
msgstr "studio"

#. js-lingui-id: K+XQwI
msgid "With Utilities: "
msgstr "With Utilities: "

#. js-lingui-id: K/9IDx
msgid "Application Progress"
msgstr "Application Progress"

#. js-lingui-id: K/H+7R
msgid "Background Check"
msgstr "Background Check"

#. js-lingui-id: K0KvwX
msgid "Enter the code that your roommate shared with you <0/>to apply with him on the same application folder"
msgstr "Enter the code that your roommate shared with you <0/>to apply with him on the same application folder"

#. js-lingui-id: K0s8ir
msgid "Select your unit"
msgstr "Select your unit"

#. js-lingui-id: K3YBpU
msgid "Recommended For"
msgstr "Recommended For"

#. js-lingui-id: K3ZYUz
msgid "Co-Applicant"
msgstr "Co-Applicant"

#. js-lingui-id: K3k80a
msgid "Industry standard is 3.0x (tenant's income should be at least 3 times the rent)"
msgstr "Industry standard is 3.0x (tenant's income should be at least 3 times the rent)"

#. js-lingui-id: K3ktVp
msgid "Exclusive insights powered by Eversa's proprietary analytics, comparing against the last 100 verified tenants within a 15km radius of {location}."
msgstr "Exclusive insights powered by Eversa's proprietary analytics, comparing against the last 100 verified tenants within a 15km radius of {location}."

#. js-lingui-id: K6Lyfl
msgid "This person is unscored by equifax. Review the report."
msgstr "This person is unscored by equifax. Review the report."

#. js-lingui-id: K7E9cE
msgid "Allow reapplication with conditions"
msgstr "Allow reapplication with conditions"

#. js-lingui-id: K7P0jz
msgid "Last Updated"
msgstr "Last Updated"

#. js-lingui-id: K7lqZC
msgid "Needs Review"
msgstr "Needs Review"

#. js-lingui-id: K7tIrx
msgid "Category"
msgstr "Category"

#. js-lingui-id: KAUVJk
msgid "Incomplete Application Reminder"
msgstr "Incomplete Application Reminder"

#. js-lingui-id: KBDepC
msgid "Browse and manage your candidate submissions"
msgstr "Browse and manage your candidate submissions"

#. js-lingui-id: KBEIU2
msgid "Criminal Record"
msgstr "Criminal Record"

#. js-lingui-id: KCmnMN
msgid "Address not showing up in search?"
msgstr "Address not showing up in search?"

#. js-lingui-id: KF17MC
msgid "Additional description"
msgstr "Additional description"

#. js-lingui-id: KFXip/
msgid "John"
msgstr "John"

#. js-lingui-id: KKPeSn
msgid "Ideal financial profile with comfortable budget allocation"
msgstr "Ideal financial profile with comfortable budget allocation"

#. js-lingui-id: KM6m8p
msgid "Team"
msgstr "Team"

#. js-lingui-id: KOCETe
msgid "ID Verification"
msgstr "ID Verification"

#. js-lingui-id: KOG1wV
msgid "{resendCooldown, plural, other {Resend (#s)} zero {Resend}}"
msgstr "{resendCooldown, plural, other {Resend (#s)} zero {Resend}}"

#. js-lingui-id: KPx1UV
msgid "Not found"
msgstr "Not found"

#. js-lingui-id: KQjYWM
msgid "Minimum required income as multiple of total debt"
msgstr "Minimum required income as multiple of total debt"

#. js-lingui-id: KVD/9J
msgid "Comfortable budget (30% of available income)"
msgstr "Comfortable budget (30% of available income)"

#. js-lingui-id: KYmd1x
msgid "Not run"
msgstr "Not run"

#. js-lingui-id: KYpn10
msgid "None found"
msgstr "None found"

#. js-lingui-id: KcAcW0
msgid "Missing Data"
msgstr "Missing Data"

#. js-lingui-id: KeyePW
msgid "Risks"
msgstr "Risks"

#. js-lingui-id: KgEfI7
msgid "No delivery"
msgstr "No delivery"

#. js-lingui-id: Ki1yxx
msgid "My Application"
msgstr "My Application"

#. js-lingui-id: KkftOv
msgid "Search units..."
msgstr "Search units..."

#. js-lingui-id: Knza6y
msgid "For {tenantsFullName}"
msgstr "For {tenantsFullName}"

#. js-lingui-id: KpqBx6
msgid "Payment Method Required"
msgstr "Payment Method Required"

#. js-lingui-id: KtDx3N
msgid "Stale submissions"
msgstr "Stale submissions"

#. js-lingui-id: KtZGMj
msgid "Moderate (43-48%)"
msgstr "Moderate (43-48%)"

#. js-lingui-id: KxmprN
msgid "Prepaid by organization"
msgstr "Prepaid by organization"

#. js-lingui-id: L63FSw
msgid "Only CSV files are accepted"
msgstr "Only CSV files are accepted"

#. js-lingui-id: L6jHxy
msgid "Note: This is not a standard legal reason for rejection. Please ensure you have a valid justification and document it clearly below."
msgstr "Note: This is not a standard legal reason for rejection. Please ensure you have a valid justification and document it clearly below."

#. js-lingui-id: LAqQS2
msgid "Unfortunately, at this moment your application has been rejected. You can always try again later or contact the property manager if your situation changes."
msgstr "Unfortunately, at this moment your application has been rejected. You can always try again later or contact the property manager if your situation changes."

#. js-lingui-id: LF/DpI
msgid "units"
msgstr "units"

#. js-lingui-id: LGbIQa
msgid "Legal Record Check"
msgstr "Legal Record Check"

#. js-lingui-id: LHt0ym
msgid "There is no other parking available for this unit"
msgstr "There is no other parking available for this unit"

#. js-lingui-id: LI8uGi
msgid "Not yet started"
msgstr "Not yet started"

#. js-lingui-id: LIkwbx
msgid "Impact on Your Credit Score:"
msgstr "Impact on Your Credit Score:"

#. js-lingui-id: LLAa/9
msgid "Optional"
msgstr "Optional"

#. js-lingui-id: LLMG9b
msgid "Landlord references"
msgstr "Landlord references"

#. js-lingui-id: LMRMbD
msgid "Please select a reason for rejection"
msgstr "Please select a reason for rejection"

#. js-lingui-id: LOuCXG
msgid "Current street address"
msgstr "Current street address"

#. js-lingui-id: LRpvAQ
msgid "bedrooms"
msgstr "bedrooms"

#. js-lingui-id: LTE9JA
msgid "Add Lead"
msgstr "Add Lead"

#. js-lingui-id: LTPxQT
msgid "Adverse media screening"
msgstr "Adverse media screening"

#. js-lingui-id: LXHzuB
msgid "Collection Details"
msgstr "Collection Details"

#. js-lingui-id: LYixP5
msgid "Description (English)"
msgstr "Description (English)"

#. js-lingui-id: Ld+F/n
msgid "Very High Risk"
msgstr "Very High Risk"

#. js-lingui-id: LdA9gy
msgid "Submissions"
msgstr "Submissions"

#. js-lingui-id: Lek+XJ
msgid "Confidence"
msgstr "Confidence"

#. js-lingui-id: LhgWCf
msgid "Leads"
msgstr "Leads"

#. js-lingui-id: LiXUlk
msgid "Agent Resolution Tools"
msgstr "Agent Resolution Tools"

#. js-lingui-id: LpmpQP
msgid "Start your rental journey here as the primary applicant"
msgstr "Start your rental journey here as the primary applicant"

#. js-lingui-id: LrzeOq
msgid "Verification Check"
msgstr "Verification Check"

#. js-lingui-id: LtI9AS
msgid "Owner"
msgstr "Owner"

#. js-lingui-id: LunyK6
msgid "Criminal Check"
msgstr "Criminal Check"

#. js-lingui-id: Lyw/ID
msgid "Unsatisfactory credit score"
msgstr "Unsatisfactory credit score"

#. js-lingui-id: M/mkqh
msgid "Would you like to receive updates about your application?"
msgstr "Would you like to receive updates about your application?"

#. js-lingui-id: M1j835
msgid "You must provide your Social Insurance Number (SIN) to proceed with the credit check"
msgstr "You must provide your Social Insurance Number (SIN) to proceed with the credit check"

#. js-lingui-id: M5d0SP
msgid "Get in touch with us"
msgstr "Get in touch with us"

#. js-lingui-id: M7toNQ
msgid "Employment Reference"
msgstr "Employment Reference"

#. js-lingui-id: M8Ezeb
msgid "Show all listings with no submissions"
msgstr "Show all listings with no submissions"

#. js-lingui-id: M9f590
msgid "Message to Tenant"
msgstr "Message to Tenant"

#. js-lingui-id: MBK3eV
msgid "Total Leads"
msgstr "Total Leads"

#. js-lingui-id: MCar+A
msgid "Unit# {unitIdx}"
msgstr "Unit# {unitIdx}"

#. js-lingui-id: MDSNaj
msgid "This is the unit that the leads will be associated with."
msgstr "This is the unit that the leads will be associated with."

#. js-lingui-id: MFKlMB
msgid "Invite"
msgstr "Invite"

#. js-lingui-id: MFeLgd
msgid "Currently processing with the property manager"
msgstr "Currently processing with the property manager"

#. js-lingui-id: MFmWqO
msgid "Snooze until"
msgstr "Snooze until"

#. js-lingui-id: MHZVb9
msgid "Add Unit"
msgstr "Add Unit"

#. js-lingui-id: MHrjPM
msgid "Title"
msgstr "Title"

#. js-lingui-id: MJjU9q
msgid "Personal References"
msgstr "Personal References"

#. js-lingui-id: MKY58I
msgid "Manage your notifications settings."
msgstr "Manage your notifications settings."

#. js-lingui-id: MLbP4/
msgid "What happens to my data after the application process?"
msgstr "What happens to my data after the application process?"

#. js-lingui-id: MNQQ32
msgid "You must accept the following consents in order to continue with the application"
msgstr "You must accept the following consents in order to continue with the application"

#. js-lingui-id: MRvPaD
msgid "Which address are you looking to rent?"
msgstr "Which address are you looking to rent?"

#. js-lingui-id: MTqQMG
msgid "Not set"
msgstr "Not set"

#. js-lingui-id: MUWaDL
msgid "By signing in, you agree to our <0>Terms of Service</0> and <1>Privacy Policy</1>"
msgstr "By signing in, you agree to our <0>Terms of Service</0> and <1>Privacy Policy</1>"

#. js-lingui-id: MXQYu9
msgid "Fraudulent activity recorded within the last 10 years."
msgstr "Fraudulent activity recorded within the last 10 years."

#. js-lingui-id: MXwX+5
msgid "Reply-to email address"
msgstr "Reply-to email address"

#. js-lingui-id: MYF9A3
msgid "No issues"
msgstr "No issues"

#. js-lingui-id: MZ2jYd
msgid "Civil Cases"
msgstr "Civil Cases"

#. js-lingui-id: MaaF2N
msgid "Evaluations, comments, or opinions expressed by third parties in the report solely represent their authors and do not reflect Eversa's official position."
msgstr "Evaluations, comments, or opinions expressed by third parties in the report solely represent their authors and do not reflect Eversa's official position."

#. js-lingui-id: Mb1gMp
msgid "Candidate Selection Confirmation"
msgstr "Candidate Selection Confirmation"

#. js-lingui-id: Mc2mRX
msgid "Upload Units CSV"
msgstr "Upload Units CSV"

#. js-lingui-id: Mc4C+Q
msgid "General Information"
msgstr "General Information"

#. js-lingui-id: MedRpe
msgid "Action Required: Missing Documents"
msgstr "Action Required: Missing Documents"

#. js-lingui-id: MjE6Ou
msgid "Payment status legend"
msgstr "Payment status legend"

#. js-lingui-id: Mk5J6H
msgid "Start Live Chat"
msgstr "Start Live Chat"

#. js-lingui-id: MlMR7R
msgid "You are applying in anonymous mode. Do not exit until the process is completed."
msgstr "You are applying in anonymous mode. Do not exit until the process is completed."

#. js-lingui-id: Mm7JVd
msgid "Select the financial documents the tenant needs to provide"
msgstr "Select the financial documents the tenant needs to provide"

#. js-lingui-id: MnTRqF
msgid "Debt-to-Income Risk"
msgstr "Debt-to-Income Risk"

#. js-lingui-id: MqRv3R
msgid "This application has been snoozed until <0>{formatedDate}</0> while we wait for additional information from the applicant."
msgstr "This application has been snoozed until <0>{formatedDate}</0> while we wait for additional information from the applicant."

#. js-lingui-id: MrALkn
msgid "Unnamed Unit"
msgstr "Unnamed Unit"

#. js-lingui-id: MtylGR
msgid "Last payment on"
msgstr "Last payment on"

#. js-lingui-id: N+JUcd
msgid "AI Analyzing..."
msgstr "AI Analyzing..."

#. js-lingui-id: N0bsdK
msgid "I understand that this accommodation allows smoking only within the designated areas of the premises"
msgstr "I understand that this accommodation allows smoking only within the designated areas of the premises"

#. js-lingui-id: N0tfJu
msgid "Enter detailed explanation for rejection"
msgstr "Enter detailed explanation for rejection"

#. js-lingui-id: N10ubo
msgid "Application Form"
msgstr "Application Form"

#. js-lingui-id: N18LVt
msgid "You've successfully assigned {firstName} {lastName} as the visit agent for this submission"
msgstr "You've successfully assigned {firstName} {lastName} as the visit agent for this submission"

#. js-lingui-id: N3z5On
msgid "Application form updated"
msgstr "Application form updated"

#. js-lingui-id: N40H+G
msgid "All"
msgstr "All"

#. js-lingui-id: N6Pxr9
msgid "View all"
msgstr "View all"

#. js-lingui-id: N6YUZ6
msgid "No reports available"
msgstr "No reports available"

#. js-lingui-id: N8s2uA
msgid "Current Employer"
msgstr "Current Employer"

#. js-lingui-id: N9+NTZ
msgid "SOQUIJ Check"
msgstr "SOQUIJ Check"

#. js-lingui-id: NAfv8v
msgid "You can either share this link with your applicants or invite them directly:"
msgstr "You can either share this link with your applicants or invite them directly:"

#. js-lingui-id: NCKmP9
msgid "Smart tenant screening and verification"
msgstr "Smart tenant screening and verification"

#. js-lingui-id: NDzzB2
#. placeholder {0}: Math.floor( (Date.now() - new Date(submission.createdAt).getTime()) / (1000 * 60 * 60 * 24), )
msgid "{0, plural, one {day ago} other {days ago}}"
msgstr "{0, plural, one {day ago} other {days ago}}"

#. js-lingui-id: NEz9zJ
msgid "{title} Logo"
msgstr "{title} Logo"

#. js-lingui-id: NLRDW6
msgid "I own my property"
msgstr "I own my property"

#. js-lingui-id: NMkGFJ
msgid "Your application is currently under review. You will be notified once your application status has been updated."
msgstr "Your application is currently under review. You will be notified once your application status has been updated."

#. js-lingui-id: NN9s1/
msgid "Listed Units"
msgstr "Listed Units"

#. js-lingui-id: NP1kQD
msgid "Credit Score Distribution"
msgstr "Credit Score Distribution"

#. js-lingui-id: NRbfCD
msgid "Customize which emails are sent to tenants, managers, and rental agents."
msgstr "Customize which emails are sent to tenants, managers, and rental agents."

#. js-lingui-id: NReIne
msgid "Staff members have access to most features but cannot modify organization settings or manage billing information."
msgstr "Staff members have access to most features but cannot modify organization settings or manage billing information."

#. js-lingui-id: NSB8fL
msgid "Enable projects to allow you to better manage big building with floor plans."
msgstr "Enable projects to allow you to better manage big building with floor plans."

#. js-lingui-id: NSMp/T
msgid "Past 7 Years"
msgstr "Past 7 Years"

#. js-lingui-id: NT6xx2
msgid "{tenantName} real estate: {type} for rent, {bedrooms} bedrooms, {city}"
msgstr "{tenantName} real estate: {type} for rent, {bedrooms} bedrooms, {city}"

#. js-lingui-id: NV08sc
msgid "Additional Income Verification"
msgstr "Additional Income Verification"

#. js-lingui-id: NWCzYK
msgid "Verified by"
msgstr "Verified by"

#. js-lingui-id: NWzF+B
msgid "Configure your project information and media"
msgstr "Configure your project information and media"

#. js-lingui-id: NXnhFo
msgid "Select a visit agent"
msgstr "Select a visit agent"

#. js-lingui-id: NjELnu
msgid "Your current application does not meet the minimum requirements. The property manager requires an additional person (partner, friend, parent or endorser) to strengthen your application before it can be processed."
msgstr "Your current application does not meet the minimum requirements. The property manager requires an additional person (partner, friend, parent or endorser) to strengthen your application before it can be processed."

#. js-lingui-id: Nm9j8O
msgid "No reason provided"
msgstr "No reason provided"

#. js-lingui-id: NmHsVh
msgid "Agency"
msgstr "Agency"

#. js-lingui-id: Nna+K+
msgid "Require tenants to provide employment references"
msgstr "Require tenants to provide employment references"

#. js-lingui-id: NoqawS
msgid "Your application was declined for reasons not listed above."
msgstr "Your application was declined for reasons not listed above."

#. js-lingui-id: Np28ib
msgid "or drag and drop"
msgstr "or drag and drop"

#. js-lingui-id: NqjG2t
msgid "End Date (Optional)"
msgstr "End Date (Optional)"

#. js-lingui-id: NsJhl4
msgid "Application code"
msgstr "Application code"

#. js-lingui-id: Nu4oKW
msgid "Description"
msgstr "Description"

#. js-lingui-id: NuKR0h
msgid "Others"
msgstr "Others"

#. js-lingui-id: NuSsH1
msgid "Available Now"
msgstr "Available Now"

#. js-lingui-id: NxgXoy
msgid "New Application"
msgstr "New Application"

#. js-lingui-id: NytLLx
msgid "Quick reference for API usage"
msgstr "Quick reference for API usage"

#. js-lingui-id: O00iuX
msgid "Delivery Status"
msgstr "Delivery Status"

#. js-lingui-id: O19s8b
msgid "Move to lead"
msgstr "Move to lead"

#. js-lingui-id: O38AQw
msgid "Criminal record"
msgstr "Criminal record"

#. js-lingui-id: O3oNi5
msgid "Email"
msgstr "Email"

#. js-lingui-id: O5dfBV
msgid "TAL check price must be greater than or equal to 0"
msgstr "TAL check price must be greater than or equal to 0"

#. js-lingui-id: OBPWiD
msgid "At least one check must be selected."
msgstr "At least one check must be selected."

#. js-lingui-id: OD4V1R
msgid "Invite New Applicant"
msgstr "Invite New Applicant"

#. js-lingui-id: ODIyTS
msgid "Total Applicants"
msgstr "Total Applicants"

#. js-lingui-id: OEEQKT
msgid "Good"
msgstr "Good"

#. js-lingui-id: OEY+18
msgid "I understand that this accommodation allows a maximum of <strong>{limit}</strong>. I do not own and do not intend to own, adopt, or foster any pets exceeding the maximum allowed for the duration of my lease"
msgstr "I understand that this accommodation allows a maximum of <strong>{limit}</strong>. I do not own and do not intend to own, adopt, or foster any pets exceeding the maximum allowed for the duration of my lease"

#. js-lingui-id: OJx3wK
msgid "Not available"
msgstr "Not available"

#. js-lingui-id: OMIIhk
msgid "View profile & reports"
msgstr "View profile & reports"

#. js-lingui-id: OMoGg1
msgid "Group Snoozed Submissions"
msgstr "Group Snoozed Submissions"

#. js-lingui-id: ONWvwQ
msgid "Upload"
msgstr "Upload"

#. js-lingui-id: OQtpE1
msgid "People in the accommodation"
msgstr "People in the accommodation"

#. js-lingui-id: OS7Bzf
msgid "Documentation of any additional sources of income"
msgstr "Documentation of any additional sources of income"

#. js-lingui-id: OTK3hi
msgid "May need additional verification"
msgstr "May need additional verification"

#. js-lingui-id: OTi1Uv
msgid "Your Recent Searches"
msgstr "Your Recent Searches"

#. js-lingui-id: OXE9D1
msgid "Add Building"
msgstr "Add Building"

#. js-lingui-id: Ob2yoM
msgid "Bankruptcy Details"
msgstr "Bankruptcy Details"

#. js-lingui-id: OdaIDu
msgid "Financial Documents"
msgstr "Financial Documents"

#. js-lingui-id: OhdzQS
msgid "We strive to provide the best experience possible. Our team is here to help you every step of the way."
msgstr "We strive to provide the best experience possible. Our team is here to help you every step of the way."

#. js-lingui-id: OiAzW8
msgid "What you can try:"
msgstr "What you can try:"

#. js-lingui-id: OiZ8hq
msgid "Late Payments"
msgstr "Late Payments"

#. js-lingui-id: Omol7X
msgid "Please provide your current or previous employer information"
msgstr "Please provide your current or previous employer information"

#. js-lingui-id: On0aF2
msgid "Website"
msgstr "Website"

#. js-lingui-id: OqE648
msgid "Has the landlord approved this submission"
msgstr "Has the landlord approved this submission"

#. js-lingui-id: OrJTfQ
msgid "After submitting the address, you'll be directed to the full application form."
msgstr "After submitting the address, you'll be directed to the full application form."

#. js-lingui-id: OsMawZ
msgid "Request additional documents"
msgstr "Request additional documents"

#. js-lingui-id: OsQEiG
msgid "Years at Current Job"
msgstr "Years at Current Job"

#. js-lingui-id: OtBeea
msgid "How many parking spots are available?"
msgstr "How many parking spots are available?"

#. js-lingui-id: OudWKn
msgid "Save Threshold"
msgstr "Save Threshold"

#. js-lingui-id: Oue+Zo
msgid "Upload an XLSX file containing listing data. The file should contain columns for project, street, city, region, postal code, unit alias, area, bedrooms, bathrooms, availability, status, and price."
msgstr "Upload an XLSX file containing listing data. The file should contain columns for project, street, city, region, postal code, unit alias, area, bedrooms, bathrooms, availability, status, and price."

#. js-lingui-id: P+2STN
msgid "The phone is required"
msgstr "The phone is required"

#. js-lingui-id: P+gnB7
msgid "Please try again"
msgstr "Please try again"

#. js-lingui-id: P05GKN
msgid "By entering your email and clicking verify, you agree to our <0>Terms of Service</0> and <1>Privacy Policy</1>"
msgstr "By entering your email and clicking verify, you agree to our <0>Terms of Service</0> and <1>Privacy Policy</1>"

#. js-lingui-id: P1vDY9
msgid "Invite a candidate to submit their rental application"
msgstr "Invite a candidate to submit their rental application"

#. js-lingui-id: P31uf3
msgid "Your session has expired, please log-in again"
msgstr "Your session has expired, please log-in again"

#. js-lingui-id: P3a4ZV
msgid "* Based on 40 hour work week, 52 weeks per year"
msgstr "* Based on 40 hour work week, 52 weeks per year"

#. js-lingui-id: P3iqiW
msgid "Walk Score®"
msgstr "Walk Score®"

#. js-lingui-id: P6mkiz
msgid "Last Activity On"
msgstr "Last Activity On"

#. js-lingui-id: P8LTFo
msgid "Departure date: "
msgstr "Departure date: "

#. js-lingui-id: P9FngO
msgid "How secure is your application system?"
msgstr "How secure is your application system?"

#. js-lingui-id: P9cEa2
msgid "30 days"
msgstr "30 days"

#. js-lingui-id: P9vDWz
msgid "You have activated reference checks for enhanced screening! This premium feature automatically includes both employment and landlord reference checks to provide comprehensive verification of your applicants' rental and employment history."
msgstr "You have activated reference checks for enhanced screening! This premium feature automatically includes both employment and landlord reference checks to provide comprehensive verification of your applicants' rental and employment history."

#. js-lingui-id: PAt0J+
msgid "Delete Lead"
msgstr "Delete Lead"

#. js-lingui-id: PG3GFs
msgid "This user is a new arrival and may have limited credit history."
msgstr "This user is a new arrival and may have limited credit history."

#. js-lingui-id: PMd7cF
msgid "Search by unit #..."
msgstr "Search by unit #..."

#. js-lingui-id: PUhyfz
msgid "{v} bedrooms"
msgstr "{v} bedrooms"

#. js-lingui-id: PVHnhm
msgid "Contact information for scheduling property visits"
msgstr "Contact information for scheduling property visits"

#. js-lingui-id: PWlTvh
msgid "Records"
msgstr "Records"

#. js-lingui-id: PaFTsF
msgid "Financial Health & Income"
msgstr "Financial Health & Income"

#. js-lingui-id: Pc5PZG
msgid "Contact Person's Name"
msgstr "Contact Person's Name"

#. js-lingui-id: PcMNcC
msgid "Existing application"
msgstr "Existing application"

#. js-lingui-id: PgBPZr
msgid "Entry Date"
msgstr "Entry Date"

#. js-lingui-id: PhT57J
msgid "Manage your analytics settings."
msgstr "Manage your analytics settings."

#. js-lingui-id: Phi/9J
msgid "Delete lead"
msgstr "Delete lead"

#. js-lingui-id: PiK6Ld
msgid "Sat"
msgstr "Sat"

#. js-lingui-id: PkavNK
msgid "Re-open submission"
msgstr "Re-open submission"

#. js-lingui-id: PpZkda
msgid "Features"
msgstr "Features"

#. js-lingui-id: Ppm/ZC
msgid "Consider requesting additional income verification or a co-signer."
msgstr "Consider requesting additional income verification or a co-signer."

#. js-lingui-id: Pqo+0V
msgid "Upload images"
msgstr "Upload images"

#. js-lingui-id: Pu6jDK
msgid "Enter endorser details yourself directly into the application."
msgstr "Enter endorser details yourself directly into the application."

#. js-lingui-id: PxMcud
msgid "Current balance"
msgstr "Current balance"

#. js-lingui-id: PzVLHy
msgid "Show all listings with no sumbissions"
msgstr "Show all listings with no sumbissions"

#. js-lingui-id: Q+34AT
msgid "{tooltipText}: N/A"
msgstr "{tooltipText}: N/A"

#. js-lingui-id: Q0h3vr
msgid "Application Complete"
msgstr "Application Complete"

#. js-lingui-id: Q2bkKO
msgid "No Hit"
msgstr "No Hit"

#. js-lingui-id: Q605++
msgid "More flexible requirements"
msgstr "More flexible requirements"

#. js-lingui-id: Q7h9s/
msgid "Create project"
msgstr "Create project"

#. js-lingui-id: Q891VP
msgid "Enter building address"
msgstr "Enter building address"

#. js-lingui-id: QBVJWt
msgid "Already Started or Current Tenant?"
msgstr "Already Started or Current Tenant?"

#. js-lingui-id: QDEWii
msgid "Verified"
msgstr "Verified"

#. js-lingui-id: QFd3BD
msgid "You can reorder images by dragging them once uploaded"
msgstr "You can reorder images by dragging them once uploaded"

#. js-lingui-id: QG3fwQ
msgid "The webhook will receive updates for specified events."
msgstr "The webhook will receive updates for specified events."

#. js-lingui-id: QHxHGy
msgid "We have received your application, it is currently under review"
msgstr "We have received your application, it is currently under review"

#. js-lingui-id: QJKd/s
msgid "Building added successfully"
msgstr "Building added successfully"

#. js-lingui-id: QJe728
msgid "{bedrooms} bedrooms, {city} - {tenantName} {type} for rent"
msgstr "{bedrooms} bedrooms, {city} - {tenantName} {type} for rent"

#. js-lingui-id: QJwofm
msgid "Export data"
msgstr "Export data"

#. js-lingui-id: QN14C2
msgid "When you merge applicants, their individual submissions will be removed and all their information will be consolidated into this submission. This action cannot be undone."
msgstr "When you merge applicants, their individual submissions will be removed and all their information will be consolidated into this submission. This action cannot be undone."

#. js-lingui-id: QN2QH5
msgid "Date of Birth Provided"
msgstr "Date of Birth Provided"

#. js-lingui-id: QNRVvn
msgid "Co-applicants"
msgstr "Co-applicants"

#. js-lingui-id: QOk9ZU
msgid "No credit check data available."
msgstr "No credit check data available."

#. js-lingui-id: QP/Bmv
msgid "Add a banner to the top of the website to display important information."
msgstr "Add a banner to the top of the website to display important information."

#. js-lingui-id: QQQzoh
msgid "No of rooms"
msgstr "No of rooms"

#. js-lingui-id: QQluOg
msgid "Upload Additional Documents:"
msgstr "Upload Additional Documents:"

#. js-lingui-id: QRyHTH
msgid "Submission Listing"
msgstr "Submission Listing"

#. js-lingui-id: QVDuYI
msgid "Upload Listings"
msgstr "Upload Listings"

#. js-lingui-id: QVgwmt
msgid "Please try again later. Or contact support if the issue persists."
msgstr "Please try again later. Or contact support if the issue persists."

#. js-lingui-id: QWdKwH
msgid "Move"
msgstr "Move"

#. js-lingui-id: QccLbz
msgid "Moderate Candidate"
msgstr "Moderate Candidate"

#. js-lingui-id: Qg+NuS
msgid "Your Weekly Submissions"
msgstr "Your Weekly Submissions"

#. js-lingui-id: QhQvCz
msgid "Require tenants to provide government-issued ID"
msgstr "Require tenants to provide government-issued ID"

#. js-lingui-id: QiJB1x
msgid "Additional documents needed"
msgstr "Additional documents needed"

#. js-lingui-id: QjNzf3
msgid "Admin User"
msgstr "Admin User"

#. js-lingui-id: QkFkwk
msgid "Unit #{alias}"
msgstr "Unit #{alias}"

#. js-lingui-id: QlxNyT
msgid "Verify credit history"
msgstr "Verify credit history"

#. js-lingui-id: Qm1NmK
msgid "OR"
msgstr "OR"

#. js-lingui-id: QoC/7/
msgid "Quebec court civil and penal records"
msgstr "Quebec court civil and penal records"

#. js-lingui-id: QrhaVg
msgid "Units"
msgstr "Units"

#. js-lingui-id: QuBpLd
msgid "Requirements"
msgstr "Requirements"

#. js-lingui-id: QyNoAF
msgid "Choose a property to begin the application process"
msgstr "Choose a property to begin the application process"

#. js-lingui-id: Qze0/r
msgid "Send verification code"
msgstr "Send verification code"

#. js-lingui-id: R+YFk2
msgid "On Hold"
msgstr "On Hold"

#. js-lingui-id: R+w/Va
msgid "Billing"
msgstr "Billing"

#. js-lingui-id: R0+RqB
msgid "Legal Check"
msgstr "Legal Check"

#. js-lingui-id: R0R7jA
msgid "Through the tenant's application process, they cover the cost of their credit reports, which are then seamlessly sent to the landlord at no additional charge."
msgstr "Through the tenant's application process, they cover the cost of their credit reports, which are then seamlessly sent to the landlord at no additional charge."

#. js-lingui-id: R2fPOr
msgid "Enable 'Send to Prospect' for Staff"
msgstr "Enable 'Send to Prospect' for Staff"

#. js-lingui-id: R2hbQl
msgid "Enforce Social Insurance Number"
msgstr "Enforce Social Insurance Number"

#. js-lingui-id: R5NYZD
msgid "Additional Tenants"
msgstr "Additional Tenants"

#. js-lingui-id: R5dbc1
msgid "Documentation showing your savings or available funds"
msgstr "Documentation showing your savings or available funds"

#. js-lingui-id: RBaua8
msgid "Example: Please provide the requested documents and meet the specified requirements by the deadline to have your application reconsidered."
msgstr "Example: Please provide the requested documents and meet the specified requirements by the deadline to have your application reconsidered."

#. js-lingui-id: RFy4ce
msgid "Identity Documents Required"
msgstr "Identity Documents Required"

#. js-lingui-id: RJU7Bf
msgid "checks completed"
msgstr "checks completed"

#. js-lingui-id: RNQ2Zp
msgid "Enter your annual salary"
msgstr "Enter your annual salary"

#. js-lingui-id: RNxrCU
msgid "Upload a file"
msgstr "Upload a file"

#. js-lingui-id: RO7ADZ
msgid "An unexpected error occurred while processing the file"
msgstr "An unexpected error occurred while processing the file"

#. js-lingui-id: ROFS4M
msgid "Credit report and financial history analysis"
msgstr "Credit report and financial history analysis"

#. js-lingui-id: RPpzp7
msgid "Waiting for agent to review"
msgstr "Waiting for agent to review"

#. js-lingui-id: RT4sg3
msgid "Website URL (Slug)"
msgstr "Website URL (Slug)"

#. js-lingui-id: RTXsbw
msgid "Manage submission assignments"
msgstr "Manage submission assignments"

#. js-lingui-id: RU/s5b
msgid "Rental Reference"
msgstr "Rental Reference"

#. js-lingui-id: RX5Q01
msgid "No favorites selected for this submission"
msgstr "No favorites selected for this submission"

#. js-lingui-id: RYPEU6
msgid "Identity proof (optional)"
msgstr "Identity proof (optional)"

#. js-lingui-id: RYrbVH
msgid "Project created"
msgstr "Project created"

#. js-lingui-id: RakwsO
msgid "Show only my tasks"
msgstr "Show only my tasks"

#. js-lingui-id: RhQWz/
msgid "Payment details"
msgstr "Payment details"

#. js-lingui-id: RhxPrm
msgid "Enable Listing Website"
msgstr "Enable Listing Website"

#. js-lingui-id: RiPMje
msgid "Enter organization address"
msgstr "Enter organization address"

#. js-lingui-id: RkpuBJ
msgid "Manage your API key, webhook integration, and access the API documentation"
msgstr "Manage your API key, webhook integration, and access the API documentation"

#. js-lingui-id: RmNOHZ
msgid "Your most recent tax return or assessment"
msgstr "Your most recent tax return or assessment"

#. js-lingui-id: RmiRP/
msgid "Drag and drop images directly into the upload area"
msgstr "Drag and drop images directly into the upload area"

#. js-lingui-id: Ro+iRT
msgid "Partial applications"
msgstr "Partial applications"

#. js-lingui-id: RocnF9
msgid "Very Good"
msgstr "Very Good"

#. js-lingui-id: Rrkfcw
msgid "Potential Options to Consider"
msgstr "Potential Options to Consider"

#. js-lingui-id: Ru/s1Y
msgid "Enter the address of where you lived"
msgstr "Enter the address of where you lived"

#. js-lingui-id: RvBxbz
msgid "Based on our review of the submitted documentation, your application has been declined. However, the property manager will reconsider your application upon addressing the following requirements:"
msgstr "Based on our review of the submitted documentation, your application has been declined. However, the property manager will reconsider your application upon addressing the following requirements:"

#. js-lingui-id: RxzN1M
msgid "Enabled"
msgstr "Enabled"

#. js-lingui-id: S+y6fs
msgid "All Buildings"
msgstr "All Buildings"

#. js-lingui-id: S04xTN
msgid "Form Status"
msgstr "Form Status"

#. js-lingui-id: S1vyuz
msgid "Error while downloading the file"
msgstr "Error while downloading the file"

#. js-lingui-id: S5Hzia
msgid "{tenantName} real estate: Rent this {type} with {bedrooms} bedrooms in {city}"
msgstr "{tenantName} real estate: Rent this {type} with {bedrooms} bedrooms in {city}"

#. js-lingui-id: S86Z1R
msgid "You are not signed in"
msgstr "You are not signed in"

#. js-lingui-id: S8ugMC
msgid "Print report"
msgstr "Print report"

#. js-lingui-id: S9y7VS
msgid "Enter and save essential details about the current tenant, including contact info and the end date of his lease. Keep accurate records for streamlined reference and easy access."
msgstr "Enter and save essential details about the current tenant, including contact info and the end date of his lease. Keep accurate records for streamlined reference and easy access."

#. js-lingui-id: SCV/b4
msgid "Credit Score"
msgstr "Credit Score"

#. js-lingui-id: SQ6963
msgid "Legal & Criminal Records"
msgstr "Legal & Criminal Records"

#. js-lingui-id: SUb8x0
msgid "Total available"
msgstr "Total available"

#. js-lingui-id: SVLJab
msgid "Applicant's perimission is required"
msgstr "Applicant's perimission is required"

#. js-lingui-id: SZw9tS
msgid "View Details"
msgstr "View Details"

#. js-lingui-id: SbcTPi
msgid "Rows per page:"
msgstr "Rows per page:"

#. js-lingui-id: Sdjhxj
msgid "Rental Agents"
msgstr "Rental Agents"

#. js-lingui-id: SeCtxx
msgid "Allow agent actions"
msgstr "Allow agent actions"

#. js-lingui-id: SejRZT
msgid "Please provide a recent pay stub (stub dated within the last 30 days), T4A or recent notice of assessment"
msgstr "Please provide a recent pay stub (stub dated within the last 30 days), T4A or recent notice of assessment"

#. js-lingui-id: Sg8Gt/
msgid "Strengthen your combined financial profile"
msgstr "Strengthen your combined financial profile"

#. js-lingui-id: SiJSKO
msgid "Good utilization"
msgstr "Good utilization"

#. js-lingui-id: Sje7dc
msgid "Analytics updated"
msgstr "Analytics updated"

#. js-lingui-id: SkqHao
msgid "Requested documents"
msgstr "Requested documents"

#. js-lingui-id: SkxaWJ
msgid "Current Address"
msgstr "Current Address"

#. js-lingui-id: SlfejT
msgid "Error"
msgstr "Error"

#. js-lingui-id: SmCDLv
msgid "Add Applicant"
msgstr "Add Applicant"

#. js-lingui-id: SovVci
msgid "The tenant will be able to resubmit their application once they meet the conditions you specify below. If they don't meet these conditions by the deadline, their application will be automatically marked as rejected. Make sure to set a reasonable deadline and clear requirements."
msgstr "The tenant will be able to resubmit their application once they meet the conditions you specify below. If they don't meet these conditions by the deadline, their application will be automatically marked as rejected. Make sure to set a reasonable deadline and clear requirements."

#. js-lingui-id: SpTJJn
msgid "Electricity"
msgstr "Electricity"

#. js-lingui-id: SrElbc
msgid "Notification sent to the applicant confirming they have been selected as the new tenant"
msgstr "Notification sent to the applicant confirming they have been selected as the new tenant"

#. js-lingui-id: Sxm1lO
msgid "All Statuses"
msgstr "All Statuses"

#. js-lingui-id: SxyD6I
msgid "Notification sent to the applicant when their application status changes during the review process"
msgstr "Notification sent to the applicant when their application status changes during the review process"

#. js-lingui-id: T+3pZF
msgid "Secure and confidential"
msgstr "Secure and confidential"

#. js-lingui-id: T8NLTv
msgid "Select the identity documents the tenant needs to provide"
msgstr "Select the identity documents the tenant needs to provide"

#. js-lingui-id: TCc8aM
msgid "Please provide proof of identity for your file (ex. Driver's license, Passport)"
msgstr "Please provide proof of identity for your file (ex. Driver's license, Passport)"

#. js-lingui-id: THBZFM
msgid "We Couldn't Find This Page"
msgstr "We Couldn't Find This Page"

#. js-lingui-id: TIQeV2
msgid "Update the prices for credit report services"
msgstr "Update the prices for credit report services"

#. js-lingui-id: TJBHlP
msgid "Standard"
msgstr "Standard"

#. js-lingui-id: TKSnHl
msgid "Not currently renting"
msgstr "Not currently renting"

#. js-lingui-id: TMLAx2
msgid "Required"
msgstr "Required"

#. js-lingui-id: TP41b8
msgid "Select a building"
msgstr "Select a building"

#. js-lingui-id: TPtCIY
msgid "Significant Price Change"
msgstr "Significant Price Change"

#. js-lingui-id: TUttPn
msgid "Submission not found"
msgstr "Submission not found"

#. js-lingui-id: TWG4iz
msgid "Financial Requirements Not Met"
msgstr "Financial Requirements Not Met"

#. js-lingui-id: TWe481
msgid "Thorough criminal record verification"
msgstr "Thorough criminal record verification"

#. js-lingui-id: TYbPfZ
msgid "{title} Applicant Portal"
msgstr "{title} Applicant Portal"

#. js-lingui-id: TZuCK5
msgid "Allow staff actions"
msgstr "Allow staff actions"

#. js-lingui-id: TdW6jm
msgid "Complete your profile"
msgstr "Complete your profile"

#. js-lingui-id: TdfEV7
msgid "Archived"
msgstr "Archived"

#. js-lingui-id: TjCXuD
msgid "Manage Applicants"
msgstr "Manage Applicants"

#. js-lingui-id: Tk0GD2
msgid "Affordability Analysis"
msgstr "Affordability Analysis"

#. js-lingui-id: TnAfah
msgid "Pay Stub"
msgstr "Pay Stub"

#. js-lingui-id: ToEuex
msgid "Write a message explaining what additional information you need from the tenant. This message will be sent directly to them."
msgstr "Write a message explaining what additional information you need from the tenant. This message will be sent directly to them."

#. js-lingui-id: TqQi+9
msgid "Enable Banner"
msgstr "Enable Banner"

#. js-lingui-id: TqaqN9
msgid "Last action on"
msgstr "Last action on"

#. js-lingui-id: TuOczd
msgid "Updated Proof of Income"
msgstr "Updated Proof of Income"

#. js-lingui-id: TvDoCV
msgid "Delivery Progress"
msgstr "Delivery Progress"

#. js-lingui-id: Tx6jp7
msgid "Property managers typically respond within 24-48 business hours after you submit your complete profile or any requested additional documentation. This timeline may vary depending on the verification process and property manager's schedule."
msgstr "Property managers typically respond within 24-48 business hours after you submit your complete profile or any requested additional documentation. This timeline may vary depending on the verification process and property manager's schedule."

#. js-lingui-id: Ty+xfU
msgid "Your application requires attention. It may be cancelled or discarded if no response by"
msgstr "Your application requires attention. It may be cancelled or discarded if no response by"

#. js-lingui-id: Tz0i8g
msgid "Settings"
msgstr "Settings"

#. js-lingui-id: U/v4Ri
msgid "Enter the address of the property you're interested in applying for."
msgstr "Enter the address of the property you're interested in applying for."

#. js-lingui-id: U0euB4
msgid "This notification is system enforced and cannot be disabled"
msgstr "This notification is system enforced and cannot be disabled"

#. js-lingui-id: U1gwi9
msgid "You apply alone, or want to start an application to invite your co-tenants"
msgstr "You apply alone, or want to start an application to invite your co-tenants"

#. js-lingui-id: U3pytU
msgid "Admin"
msgstr "Admin"

#. js-lingui-id: U6iChU
msgid "ACTIONS"
msgstr "ACTIONS"

#. js-lingui-id: U7AdEr
msgid "Cannot proceed: One or more requirements are not met. Please update the applicant's profile."
msgstr "Cannot proceed: One or more requirements are not met. Please update the applicant's profile."

#. js-lingui-id: U8ebX+
msgid "Landlord approved"
msgstr "Landlord approved"

#. js-lingui-id: UABggz
msgid "Important message"
msgstr "Important message"

#. js-lingui-id: UAZTy6
msgid "We collect only the minimum information necessary to process your rental application effectively. This includes basic personal details, employment information, and rental history required for property managers to make informed decisions."
msgstr "We collect only the minimum information necessary to process your rental application effectively. This includes basic personal details, employment information, and rental history required for property managers to make informed decisions."

#. js-lingui-id: UB12M3
msgid "Current Monthly Rent"
msgstr "Current Monthly Rent"

#. js-lingui-id: UEI0uP
msgid "Try a different search"
msgstr "Try a different search"

#. js-lingui-id: UHeMni
msgid "We are going to perform background and credit verification of your information"
msgstr "We are going to perform background and credit verification of your information"

#. js-lingui-id: UItjqv
msgid "% of Income"
msgstr "% of Income"

#. js-lingui-id: UOx1jT
msgid "Back to"
msgstr "Back to"

#. js-lingui-id: URmyfc
msgid "Details"
msgstr "Details"

#. js-lingui-id: USXXjt
msgid "No results for \"{query}\""
msgstr "No results for \"{query}\""

#. js-lingui-id: UXBCwc
msgid "Last Name"
msgstr "Last Name"

#. js-lingui-id: UZZhNI
msgid "Application under review"
msgstr "Application under review"

#. js-lingui-id: UbRKMZ
msgid "Pending"
msgstr "Pending"

#. js-lingui-id: UgSwvS
msgid "Affiliations with flagged organizations detected."
msgstr "Affiliations with flagged organizations detected."

#. js-lingui-id: Uh88It
msgid "Lead created successfully"
msgstr "Lead created successfully"

#. js-lingui-id: UigvAS
msgid "Eversa Analysis Configuration"
msgstr "Eversa Analysis Configuration"

#. js-lingui-id: UlrUNT
msgid "Applicants merged"
msgstr "Applicants merged"

#. js-lingui-id: UoPq9k
msgid "{type} with {bedrooms} bedrooms for rent by {tenantName}, {address}, {city}"
msgstr "{type} with {bedrooms} bedrooms for rent by {tenantName}, {address}, {city}"

#. js-lingui-id: Uoc0xs
msgid "Send an invitation email to a new applicant"
msgstr "Send an invitation email to a new applicant"

#. js-lingui-id: Ur48dJ
msgid "reg."
msgstr "reg."

#. js-lingui-id: Ur6Oka
msgid "Messages and notifications for this application"
msgstr "Messages and notifications for this application"

#. js-lingui-id: UrKHn4
msgid "Not Started"
msgstr "Not Started"

#. js-lingui-id: Uv4dnT
msgid "Street"
msgstr "Street"

#. js-lingui-id: UvRWAL
msgid "You can update your profile information at any time through your tenant portal. Any changes will be automatically reflected in your active applications."
msgstr "You can update your profile information at any time through your tenant portal. Any changes will be automatically reflected in your active applications."

#. js-lingui-id: UwX6bL
msgid "Your application is submitted<0/> and under review 🎉"
msgstr "Your application is submitted<0/> and under review 🎉"

#. js-lingui-id: V1EGGU
msgid "First name"
msgstr "First name"

#. js-lingui-id: V2/kSX
msgid "Unsnooze this application to continue with the process"
msgstr "Unsnooze this application to continue with the process"

#. js-lingui-id: V2cwns
msgid "Documents from your guarantor including their ID and proof of income"
msgstr "Documents from your guarantor including their ID and proof of income"

#. js-lingui-id: V2krU2
msgid "Your account is deactivated. Please contact support."
msgstr "Your account is deactivated. Please contact support."

#. js-lingui-id: V7H/BS
msgid "Submission has been successfully snoozed until {formatedDate}."
msgstr "Submission has been successfully snoozed until {formatedDate}."

#. js-lingui-id: V8BSAN
msgid "Monthly income"
msgstr "Monthly income"

#. js-lingui-id: VBTGXl
msgid "Unverified"
msgstr "Unverified"

#. js-lingui-id: VClcVY
msgid "Income-to-Rent Ratio Requirement"
msgstr "Income-to-Rent Ratio Requirement"

#. js-lingui-id: VDMShG
msgid "Tenant organization created successfully"
msgstr "Tenant organization created successfully"

#. js-lingui-id: VEu4pO
msgid "Manage your application reports."
msgstr "Manage your application reports."

#. js-lingui-id: VIuZGf
msgid "I'm renting"
msgstr "I'm renting"

#. js-lingui-id: VIyEtN
msgid "Add Tenant"
msgstr "Add Tenant"

#. js-lingui-id: VKwYDf
msgid "Type document name and press Enter or comma to add"
msgstr "Type document name and press Enter or comma to add"

#. js-lingui-id: VN75fO
msgid "Recent Bank Statements"
msgstr "Recent Bank Statements"

#. js-lingui-id: VNPi9T
msgid "A letter from your employer confirming your employment and salary"
msgstr "A letter from your employer confirming your employment and salary"

#. js-lingui-id: VO0PXY
msgid "Delivery Management"
msgstr "Delivery Management"

#. js-lingui-id: VTjnH0
msgid "Date of birth must be a valid date in the past and not more than 120 years ago"
msgstr "Date of birth must be a valid date in the past and not more than 120 years ago"

#. js-lingui-id: VVMkbs
msgid "Financial Overview"
msgstr "Financial Overview"

#. js-lingui-id: VWjMYe
msgid "Snooze has been successfully acknowledged"
msgstr "Snooze has been successfully acknowledged"

#. js-lingui-id: VYETp/
msgid "Manage your billing settings."
msgstr "Manage your billing settings."

#. js-lingui-id: VZeG/A
msgid "Coming Soon"
msgstr "Coming Soon"

#. js-lingui-id: Vc6DYr
msgid "Enter French description"
msgstr "Enter French description"

#. js-lingui-id: VdX6/S
msgid "Send an email to the tenant"
msgstr "Send an email to the tenant"

#. js-lingui-id: Vf0mQb
msgid "Oops! The listing you're looking for doesn't exist or has been removed."
msgstr "Oops! The listing you're looking for doesn't exist or has been removed."

#. js-lingui-id: VgBF86
msgid "New Arrival"
msgstr "New Arrival"

#. js-lingui-id: Vi2Pqx
msgid "by"
msgstr "by"

#. js-lingui-id: VlrEvi
msgid "Invalid document type selected"
msgstr "Invalid document type selected"

#. js-lingui-id: VmIhpU
msgid "You have been redirected to the home page"
msgstr "You have been redirected to the home page"

#. js-lingui-id: VnBgXL
msgid "Enable Submission Assignment"
msgstr "Enable Submission Assignment"

#. js-lingui-id: VnNZ36
msgid "No Project Available"
msgstr "No Project Available"

#. js-lingui-id: VoT8jh
msgid "All Submissions"
msgstr "All Submissions"

#. js-lingui-id: VouIXn
msgid "Error loading report!"
msgstr "Error loading report!"

#. js-lingui-id: VpG3jB
msgid "Add lead to unit"
msgstr "Add lead to unit"

#. js-lingui-id: VqFXBQ
msgid "Message from {messageSender}:"
msgstr "Message from {messageSender}:"

#. js-lingui-id: VuaarY
msgid "Please provide an explanation for other reason"
msgstr "Please provide an explanation for other reason"

#. js-lingui-id: W+RP4q
msgid "Delete Applicant"
msgstr "Delete Applicant"

#. js-lingui-id: W0BuNH
msgid "Unverified AI Salary"
msgstr "Unverified AI Salary"

#. js-lingui-id: W2mcaN
msgid "You are currently signed in with a staff account. You cannot apply on a listing."
msgstr "You are currently signed in with a staff account. You cannot apply on a listing."

#. js-lingui-id: W37bxI
msgid "Enter English description"
msgstr "Enter English description"

#. js-lingui-id: W9KP0X
msgid "Credit History"
msgstr "Credit History"

#. js-lingui-id: WDcQq9
msgid "Unlisted"
msgstr "Unlisted"

#. js-lingui-id: WE2GMj
msgid " more than the previous unit."
msgstr " more than the previous unit."

#. js-lingui-id: WFIGh+
msgid "Uploaded Documents:"
msgstr "Uploaded Documents:"

#. js-lingui-id: WFf2ZQ
msgid "Manage units in this building"
msgstr "Manage units in this building"

#. js-lingui-id: WG8MI5
msgid "Clear your browser cache and refresh the page"
msgstr "Clear your browser cache and refresh the page"

#. js-lingui-id: WGkFsd
msgid "Online application"
msgstr "Online application"

#. js-lingui-id: WJ5s0G
msgid "Submission Status Update"
msgstr "Submission Status Update"

#. js-lingui-id: WNai8g
msgid "Your configured minimum ratio (Income to Rent)"
msgstr "Your configured minimum ratio (Income to Rent)"

#. js-lingui-id: WNrbGX
msgid "This account is not authorized to sign in to this application. Please contact support."
msgstr "This account is not authorized to sign in to this application. Please contact support."

#. js-lingui-id: WS0xSN
msgid "Quebec residential properties"
msgstr "Quebec residential properties"

#. js-lingui-id: WZ8g4+
msgid "Animals allowed in the unit"
msgstr "Animals allowed in the unit"

#. js-lingui-id: WZubgm
msgid "Payment Setup Required"
msgstr "Payment Setup Required"

#. js-lingui-id: WbTDwg
msgid "In Progress"
msgstr "In Progress"

#. js-lingui-id: Weq9zb
msgid "General"
msgstr "General"

#. js-lingui-id: WndzGF
msgid "Ask your administrator to configure payment"
msgstr "Ask your administrator to configure payment"

#. js-lingui-id: Wsk5pi
msgid "Project Settings"
msgstr "Project Settings"

#. js-lingui-id: WuOFQd
msgid "Completed on {financeDate}"
msgstr "Completed on {financeDate}"

#. js-lingui-id: WwJwIo
msgid "{tenantName} real estate: Spacious {type} with {bedrooms} bedrooms for rent in {city}"
msgstr "{tenantName} real estate: Spacious {type} with {bedrooms} bedrooms for rent in {city}"

#. js-lingui-id: WwP87g
msgid "Apply once, valid for 60 days"
msgstr "Apply once, valid for 60 days"

#. js-lingui-id: WxfcfZ
msgid "It's empty"
msgstr "It's empty"

#. js-lingui-id: X/VKtM
msgid "Delivery Management View Options"
msgstr "Delivery Management View Options"

#. js-lingui-id: X0QTsk
msgid "Qualification Analysis"
msgstr "Qualification Analysis"

#. js-lingui-id: X0m5kl
msgid "Salary Breakdown"
msgstr "Salary Breakdown"

#. js-lingui-id: X5c31T
msgid "Applicant's permission"
msgstr "Applicant's permission"

#. js-lingui-id: X8ASN1
msgid "Waiting for agent to approve"
msgstr "Waiting for agent to approve"

#. js-lingui-id: X8RtOS
msgid "Delivery Agent Details"
msgstr "Delivery Agent Details"

#. js-lingui-id: X9d0q3
msgid "Confirm Rejection"
msgstr "Confirm Rejection"

#. js-lingui-id: X9kySA
msgid "Favorites"
msgstr "Favorites"

#. js-lingui-id: XAH5zB
msgid "Enter French title"
msgstr "Enter French title"

#. js-lingui-id: XGmlvq
msgid "Team Member Roles"
msgstr "Team Member Roles"

#. js-lingui-id: XILg0L
msgid "Invalid email address"
msgstr "Invalid email address"

#. js-lingui-id: XJrFpX
msgid "Proof of income (optional)"
msgstr "Proof of income (optional)"

#. js-lingui-id: XLHm9h
msgid "Require tenants to upload proof of income documents"
msgstr "Require tenants to upload proof of income documents"

#. js-lingui-id: XMRrWw
msgid "Verification Status"
msgstr "Verification Status"

#. js-lingui-id: XOIEih
msgid "Eversa Market Intelligence"
msgstr "Eversa Market Intelligence"

#. js-lingui-id: XOPBvW
msgid "Confirmation that an application has been successfully received in the system"
msgstr "Confirmation that an application has been successfully received in the system"

#. js-lingui-id: XPPeYX
msgid "Credit Limit"
msgstr "Credit Limit"

#. js-lingui-id: XQqH0U
msgid "Add additional information for the visit agent. (e.g: current tenant details, possible unit# to visit etc...)"
msgstr "Add additional information for the visit agent. (e.g: current tenant details, possible unit# to visit etc...)"

#. js-lingui-id: XRWzs3
msgid "Configure the features of your website. These features can be enabled or disabled."
msgstr "Configure the features of your website. These features can be enabled or disabled."

#. js-lingui-id: XU9aUK
msgid "Acceptance"
msgstr "Acceptance"

#. js-lingui-id: XUOsJo
msgid "Upload Documents"
msgstr "Upload Documents"

#. js-lingui-id: XVSust
msgid "Missed Payment"
msgstr "Missed Payment"

#. js-lingui-id: XXFT/4
msgid "I am a new arrival to Canada (immigrant, international student, or temporary worker)"
msgstr "I am a new arrival to Canada (immigrant, international student, or temporary worker)"

#. js-lingui-id: XZDoO8
msgid "Enter Tenant Details"
msgstr "Enter Tenant Details"

#. js-lingui-id: XachSV
msgid "Action Required: Review your Application"
msgstr "Action Required: Review your Application"

#. js-lingui-id: XdO6hR
msgid "Completed on"
msgstr "Completed on"

#. js-lingui-id: XibS9K
msgid "Team Members"
msgstr "Team Members"

#. js-lingui-id: Xl3sIK
msgid "Vulnerable sector check"
msgstr "Vulnerable sector check"

#. js-lingui-id: XnEQ12
msgid "Failed to upload csv file"
msgstr "Failed to upload csv file"

#. js-lingui-id: XnT0vs
msgid "Large Unit Change Trigger"
msgstr "Large Unit Change Trigger"

#. js-lingui-id: XqxJmS
msgid "Is the prepaid rent required?"
msgstr "Is the prepaid rent required?"

#. js-lingui-id: Xz3NE3
msgid "Units/Buildings"
msgstr "Units/Buildings"

#. js-lingui-id: Y/fDke
msgid "Other (Non-Legal Reason)"
msgstr "Other (Non-Legal Reason)"

#. js-lingui-id: Y72kOS
msgid "Right to Access and Correction:"
msgstr "Right to Access and Correction:"

#. js-lingui-id: Y7WHtv
msgid "Enter Facebook URL"
msgstr "Enter Facebook URL"

#. js-lingui-id: Y9TPjC
msgid "{city} rental: {type} with {bedrooms} bedrooms for rent, {tenantName} real estate"
msgstr "{city} rental: {type} with {bedrooms} bedrooms for rent, {tenantName} real estate"

#. js-lingui-id: YBGFCn
msgid "When a submission is unsnoozed by the tenant completing the required action, it will move to the selected step. If no step is selected, the submission will keep its current step."
msgstr "When a submission is unsnoozed by the tenant completing the required action, it will move to the selected step. If no step is selected, the submission will keep its current step."

#. js-lingui-id: YBzMIm
msgid "Annually:"
msgstr "Annually:"

#. js-lingui-id: YCmxKV
msgid "No Credit Score"
msgstr "No Credit Score"

#. js-lingui-id: YJns+p
msgid "Application on Hold"
msgstr "Application on Hold"

#. js-lingui-id: YMfmlH
msgid "This salary seems unusually high. Please verify the amount."
msgstr "This salary seems unusually high. Please verify the amount."

#. js-lingui-id: YPjyXG
msgid "Please select at least one applicant"
msgstr "Please select at least one applicant"

#. js-lingui-id: YSwcF6
msgid "This application has been put on hold until <0>{formatedDate}</0> while we wait for additional information from the applicant."
msgstr "This application has been put on hold until <0>{formatedDate}</0> while we wait for additional information from the applicant."

#. js-lingui-id: YT6bro
msgid "You've successfully removed the assignee from this submission"
msgstr "You've successfully removed the assignee from this submission"

#. js-lingui-id: YTCz3Y
msgid "Requirements Checklist"
msgstr "Requirements Checklist"

#. js-lingui-id: YUltpZ
msgid "Upload a CSV file containing unit data. The file should contain columns for unit number, floor, and any other relevant data."
msgstr "Upload a CSV file containing unit data. The file should contain columns for unit number, floor, and any other relevant data."

#. js-lingui-id: YY+s6C
msgid "This category is empty for now."
msgstr "This category is empty for now."

#. js-lingui-id: YZCpAB
msgid "Delete Promotion"
msgstr "Delete Promotion"

#. js-lingui-id: YaEBJt
msgid "This account has been written off"
msgstr "This account has been written off"

#. js-lingui-id: YahcST
msgid "Incomplete Application"
msgstr "Incomplete Application"

#. js-lingui-id: YirHq7
msgid "Feedback"
msgstr "Feedback"

#. js-lingui-id: YjKETn
msgid "{tenantTitle} | {street}, {city}"
msgstr "{tenantTitle} | {street}, {city}"

#. js-lingui-id: YkbyP9
msgid "Financial stability assessment"
msgstr "Financial stability assessment"

#. js-lingui-id: Yo/CwQ
msgid "Unit updated successfully"
msgstr "Unit updated successfully"

#. js-lingui-id: YpGzmW
msgid "Your application<0/> has been rejected"
msgstr "Your application<0/> has been rejected"

#. js-lingui-id: YudRP7
msgid "You are editing the application. Do not exit until the process is completed."
msgstr "You are editing the application. Do not exit until the process is completed."

#. js-lingui-id: YvAmot
msgid "Included Analysis"
msgstr "Included Analysis"

#. js-lingui-id: YzSJxy
msgid "{value, plural, one {bathroom} two {bathrooms} other {bathrooms}}"
msgstr "{value, plural, one {bathroom} two {bathrooms} other {bathrooms}}"

#. js-lingui-id: YzZwmB
msgid "How many animals are allowed?"
msgstr "How many animals are allowed?"

#. js-lingui-id: Z1tR1p
msgid "Banner Text English"
msgstr "Banner Text English"

#. js-lingui-id: Z3FXyt
msgid "Loading..."
msgstr "Loading..."

#. js-lingui-id: Z59X0b
msgid "I don't have a landlord reference"
msgstr "I don't have a landlord reference"

#. js-lingui-id: Z6PbaC
msgid "We are currently waiting on your co-applicant to complete their application"
msgstr "We are currently waiting on your co-applicant to complete their application"

#. js-lingui-id: ZCW63d
msgid "Upload a featured image for your project that will be displayed on listing pages"
msgstr "Upload a featured image for your project that will be displayed on listing pages"

#. js-lingui-id: ZCXgK6
msgid "Bike Score®"
msgstr "Bike Score®"

#. js-lingui-id: ZDdb1D
msgid "Select agent"
msgstr "Select agent"

#. js-lingui-id: ZFLX50
msgid "Update building information"
msgstr "Update building information"

#. js-lingui-id: ZJJrSW
msgid "Landlord Review"
msgstr "Landlord Review"

#. js-lingui-id: ZJRzFw
msgid "Upload a featured image for this building that will be displayed on listing pages"
msgstr "Upload a featured image for this building that will be displayed on listing pages"

#. js-lingui-id: ZNR48C
msgid "Debt-to-income ratio calculation"
msgstr "Debt-to-income ratio calculation"

#. js-lingui-id: ZNbr0u
msgid "I acknowledge and agree that any fees paid to <0>Eversa</0> are non-refundable and will be used to process and analyze my profile. The property manager will refund the application fee if your application is selected."
msgstr "I acknowledge and agree that any fees paid to <0>Eversa</0> are non-refundable and will be used to process and analyze my profile. The property manager will refund the application fee if your application is selected."

#. js-lingui-id: ZPs6Fh
msgid "Good standing"
msgstr "Good standing"

#. js-lingui-id: ZSDQwQ
msgid "Language:"
msgstr "Language:"

#. js-lingui-id: ZU3JQG
msgid "Submitted"
msgstr "Submitted"

#. js-lingui-id: ZW5uL6
msgid "Total Credit Checks"
msgstr "Total Credit Checks"

#. js-lingui-id: ZWSiK2
msgid "Hold to Merge"
msgstr "Hold to Merge"

#. js-lingui-id: ZYkdBw
msgid "Unit# (Optional)"
msgstr "Unit# (Optional)"

#. js-lingui-id: ZYrTdn
msgid "Search leads"
msgstr "Search leads"

#. js-lingui-id: ZZHjJR
msgid "Oups, this listing is no longer available."
msgstr "Oups, this listing is no longer available."

#. js-lingui-id: Za5k8Z
msgid "No updates yet"
msgstr "No updates yet"

#. js-lingui-id: ZchOpj
msgid "Homeowner"
msgstr "Homeowner"

#. js-lingui-id: Zl/iSo
msgid "Financial Documents Required"
msgstr "Financial Documents Required"

#. js-lingui-id: ZlwDi6
msgid "Analytics"
msgstr "Analytics"

#. js-lingui-id: ZoOIuR
msgid "Rental history analysis"
msgstr "Rental history analysis"

#. js-lingui-id: Zork3f
msgid "Driver's License"
msgstr "Driver's License"

#. js-lingui-id: ZpSbWv
msgid "Agent Dashboard"
msgstr "Agent Dashboard"

#. js-lingui-id: Zr0egD
msgid "Send a credit check request to an applicant by email, once they have completed the application you will be notified."
msgstr "Send a credit check request to an applicant by email, once they have completed the application you will be notified."

#. js-lingui-id: ZrFiVl
msgid "Type or choose an assignee"
msgstr "Type or choose an assignee"

#. js-lingui-id: ZrsGjm
msgid "Inventory"
msgstr "Inventory"

#. js-lingui-id: ZsZeV2
msgid "Email is required"
msgstr "Email is required"

#. js-lingui-id: ZudkOx
msgid "Control your rental application form"
msgstr "Control your rental application form"

#. js-lingui-id: Zw2dYJ
msgid "No leads available"
msgstr "No leads available"

#. js-lingui-id: a/jCru
msgid "{daysSinceUpdated} days ago"
msgstr "{daysSinceUpdated} days ago"

#. js-lingui-id: a3EgZz
msgid "Payment History"
msgstr "Payment History"

#. js-lingui-id: a3pVqb
msgid "Frequently asked questions"
msgstr "Frequently asked questions"

#. js-lingui-id: a4ma1L
msgid "Units in Project"
msgstr "Units in Project"

#. js-lingui-id: a4ruqo
msgid "Unsnooze"
msgstr "Unsnooze"

#. js-lingui-id: a5+3cU
msgid "Verify the file is valid and try again. Or contact support if the issue persists."
msgstr "Verify the file is valid and try again. Or contact support if the issue persists."

#. js-lingui-id: a5JPSe
msgid "Living with parents"
msgstr "Living with parents"

#. js-lingui-id: a7u1N9
msgid "Price"
msgstr "Price"

#. js-lingui-id: a91YWO
msgid "A fee of ${formattedPrice} will have to be paid to complete your housing request"
msgstr "A fee of ${formattedPrice} will have to be paid to complete your housing request"

#. js-lingui-id: a9eYBr
msgid "Manage your API key"
msgstr "Manage your API key"

#. js-lingui-id: aAIQg2
msgid "Appearance"
msgstr "Appearance"

#. js-lingui-id: aCl9zQ
msgid "Add project"
msgstr "Add project"

#. js-lingui-id: aDPoVW
msgid "This submission is on hold"
msgstr "This submission is on hold"

#. js-lingui-id: aG5d+K
msgid "Leads Stats"
msgstr "Leads Stats"

#. js-lingui-id: aI4dXu
msgid "Continue your home search journey"
msgstr "Continue your home search journey"

#. js-lingui-id: aIXsmO
msgid "Has the tenant accepted the visit on this listing"
msgstr "Has the tenant accepted the visit on this listing"

#. js-lingui-id: aIy42X
msgid "Cancel Delivery"
msgstr "Cancel Delivery"

#. js-lingui-id: aJ4pMe
msgid "FAQs"
msgstr "FAQs"

#. js-lingui-id: aJwGh/
msgid "For accurate affordability analysis, we require monthly income of at least $1,000 and monthly rent of at least $100. Please update the information to see the complete affordability assessment."
msgstr "For accurate affordability analysis, we require monthly income of at least $1,000 and monthly rent of at least $100. Please update the information to see the complete affordability assessment."

#. js-lingui-id: aK1ReW
msgid "Income Verification"
msgstr "Income Verification"

#. js-lingui-id: aOIfD3
msgid "Monthly:"
msgstr "Monthly:"

#. js-lingui-id: aOS+ix
msgid "Upload Additional Documents"
msgstr "Upload Additional Documents"

#. js-lingui-id: aP4Av2
msgid "Generated on"
msgstr "Generated on"

#. js-lingui-id: aQST8Z
msgid "Financial"
msgstr "Financial"

#. js-lingui-id: aQk4Lr
msgid "The tenant has not paid the deposit and the financial information has not been verified."
msgstr "The tenant has not paid the deposit and the financial information has not been verified."

#. js-lingui-id: aSwfbR
msgid "Unit"
msgstr "Unit"

#. js-lingui-id: aTe3TO
msgid "The electricity bill ownership has been transferred to the tenant."
msgstr "The electricity bill ownership has been transferred to the tenant."

#. js-lingui-id: aTr/DF
msgid "Select how you'd like to proceed with the application"
msgstr "Select how you'd like to proceed with the application"

#. js-lingui-id: aVTekH
msgid "Clear assignee"
msgstr "Clear assignee"

#. js-lingui-id: aVlWNp
msgid "The tenant has received the rules and regulations and has agreed to them."
msgstr "The tenant has received the rules and regulations and has agreed to them."

#. js-lingui-id: aWgRnQ
msgid "Manage your submission assignement and statuses"
msgstr "Manage your submission assignement and statuses"

#. js-lingui-id: aZufkv
msgid "Credit Check Not Run"
msgstr "Credit Check Not Run"

#. js-lingui-id: agPptk
msgid "Medium"
msgstr "Medium"

#. js-lingui-id: ajC7hw
msgid "Credit report has not been run yet"
msgstr "Credit report has not been run yet"

#. js-lingui-id: an5hVd
msgid "Images"
msgstr "Images"

#. js-lingui-id: anPGKK
msgid "Invite new members by email address"
msgstr "Invite new members by email address"

#. js-lingui-id: arlFOI
msgid "Why are you rejecting this application?"
msgstr "Why are you rejecting this application?"

#. js-lingui-id: asK/EM
msgid "Reference check price must be greater than or equal to 0"
msgstr "Reference check price must be greater than or equal to 0"

#. js-lingui-id: auDIrX
msgid "{diffDays}d remaining"
msgstr "{diffDays}d remaining"

#. js-lingui-id: b3Ch0G
msgid "Reference ID"
msgstr "Reference ID"

#. js-lingui-id: b3FA4T
msgid "Where was the property you rented?"
msgstr "Where was the property you rented?"

#. js-lingui-id: b4zIfV
msgid "Listing Not Found"
msgstr "Listing Not Found"

#. js-lingui-id: b5d759
msgid "identity"
msgstr "identity"

#. js-lingui-id: b5zVyG
msgid "The tenant has not provided proof of insurance."
msgstr "The tenant has not provided proof of insurance."

#. js-lingui-id: b6V5pg
msgid "Your delivery calendar is empty for this week."
msgstr "Your delivery calendar is empty for this week."

#. js-lingui-id: b9Us19
msgid "A delivery agent has been assigned to this delivery."
msgstr "A delivery agent has been assigned to this delivery."

#. js-lingui-id: bBPc2Z
msgid "Go to My Website"
msgstr "Let's get started!"

#. js-lingui-id: bBhxEK
msgid "This user has provided consent for credit bureau checks and has signed the application."
msgstr "This user has provided consent for credit bureau checks and has signed the application."

#. js-lingui-id: bD8I7O
msgid "Complete"
msgstr "Complete"

#. js-lingui-id: bEYd5k
msgid "Application Status"
msgstr "Application Status"

#. js-lingui-id: bGJMLQ
msgid "Required Documents"
msgstr "Required Documents"

#. js-lingui-id: bHJ//P
msgid "Failed to create project"
msgstr "Failed to create project"

#. js-lingui-id: bJZm1W
msgid "Applicants"
msgstr "Applicants"

#. js-lingui-id: bMPz54
msgid "Credit Score:"
msgstr "Credit Score:"

#. js-lingui-id: bQ9w8f
msgid "Payment not received"
msgstr "Payment not received"

#. js-lingui-id: bScRyj
msgid "Repossession"
msgstr "Repossession"

#. js-lingui-id: bUCGL6
msgid "Pre-Check Verification"
msgstr "Pre-Check Verification"

#. js-lingui-id: bUdTU6
msgid "The first image you upload will be used as the featured image for this building on the listing page and in search results."
msgstr "The first image you upload will be used as the featured image for this building on the listing page and in search results."

#. js-lingui-id: bXJllT
msgid "Application Code"
msgstr "Application Code"

#. js-lingui-id: bb1jb1
msgid "Select consents that are required for this unit"
msgstr "Select consents that are required for this unit"

#. js-lingui-id: bb1u4g
msgid "Revolving"
msgstr "Revolving"

#. js-lingui-id: bbWfDN
msgid "Base:"
msgstr "Base:"

#. js-lingui-id: bc/cKi
msgid "Tenants"
msgstr "Tenants"

#. js-lingui-id: be6D0D
msgid "Submission"
msgstr "Submission"

#. js-lingui-id: bfAdf+
msgid "Income Information"
msgstr "Income Information"

#. js-lingui-id: bfIwN6
msgid "Company address"
msgstr "Company address"

#. js-lingui-id: bgDPLn
msgid "Family-oriented properties"
msgstr "Family-oriented properties"

#. js-lingui-id: bj5PN1
msgid "Other Documents"
msgstr "Other Documents"

#. js-lingui-id: bkxnxA
msgid "Landlord"
msgstr "Landlord"

#. js-lingui-id: bokdBj
msgid "Candidate meets most criteria but requires manual review of debt ratio"
msgstr "Candidate meets most criteria but requires manual review of debt ratio"

#. js-lingui-id: bpK9mh
msgid "Confirm and Continue"
msgstr "Confirm and Continue"

#. js-lingui-id: brh7GE
msgid "Listing website updated"
msgstr "Listing website updated"

#. js-lingui-id: bw4L+q
msgid "Rental History"
msgstr "Rental History"

#. js-lingui-id: c0Jlur
msgid "Other financial institutions and credit providers"
msgstr "Other financial institutions and credit providers"

#. js-lingui-id: c4RuNX
msgid "Change address"
msgstr "Change address"

#. js-lingui-id: c4SUwh
msgid "Waiting for tenant to schedule visit"
msgstr "Waiting for tenant to schedule visit"

#. js-lingui-id: c4TT53
msgid "Proof of Income"
msgstr "Proof of Income"

#. js-lingui-id: c56Ta0
msgid "Make sure you have all necessary documents ready for the next step."
msgstr "Make sure you have all necessary documents ready for the next step."

#. js-lingui-id: c5LWDG
msgid "Your application has been received"
msgstr "Your application has been received"

#. js-lingui-id: c63Cj8
msgid "Archive listing"
msgstr "Archive listing"

#. js-lingui-id: c6Fkhw
msgid "Current rent must be greater than 0"
msgstr "Current rent must be greater than 0"

#. js-lingui-id: c6k4x1
msgid "We couldn't calculate a valid debt-to-income ratio for this applicant. This may be due to missing financial information or inconsistencies in the reported data."
msgstr "We couldn't calculate a valid debt-to-income ratio for this applicant. This may be due to missing financial information or inconsistencies in the reported data."

#. js-lingui-id: c7mXbX
msgid "{tenantName}: {type} with {bedrooms} bedrooms for rent, {address}, {city}"
msgstr "{tenantName}: {type} with {bedrooms} bedrooms for rent, {address}, {city}"

#. js-lingui-id: c9JTLS
msgid "T4A or Notice of Assessment"
msgstr "T4A or Notice of Assessment"

#. js-lingui-id: cD5cmv
msgid "Financial strain likely (40-50% of available income)"
msgstr "Financial strain likely (40-50% of available income)"

#. js-lingui-id: cFdvuz
msgid "Leave a note on this submission (optional)"
msgstr "Leave a note on this submission (optional)"

#. js-lingui-id: cIGApK
msgid "Help & Feedback"
msgstr "Help & Feedback"

#. js-lingui-id: cJjlGa
msgid "Not processed by Eversa"
msgstr "Not processed by Eversa"

#. js-lingui-id: cJyysm
msgid "Please select one of the standard legal grounds for declining this rental application. This helps ensure fair and transparent decision-making."
msgstr "Please select one of the standard legal grounds for declining this rental application. This helps ensure fair and transparent decision-making."

#. js-lingui-id: cMDleX
msgid "For technical issues, contact Eversa Support at <0>support@eversa.app</0> or start a live chat below."
msgstr "For technical issues, contact Eversa Support at <0>support@eversa.app</0> or start a live chat below."

#. js-lingui-id: cMocp9
msgid "This applicant has been removed from the application"
msgstr "This applicant has been removed from the application"

#. js-lingui-id: cOJb0s
msgid "No Inquiries Found"
msgstr "No Inquiries Found"

#. js-lingui-id: cQoFif
msgid "Call us"
msgstr "Call us"

#. js-lingui-id: cQzdcM
msgid "Min Prices"
msgstr "Min Prices"

#. js-lingui-id: cSev+j
msgid "Filters"
msgstr "Filters"

#. js-lingui-id: cVOset
msgid "Financial Check Not Run"
msgstr "Financial Check Not Run"

#. js-lingui-id: cVPmuB
msgid "I do not want to share my Social Insurance Number"
msgstr "I do not want to share my Social Insurance Number"

#. js-lingui-id: cVyQR/
msgid "Luxury rentals"
msgstr "Luxury rentals"

#. js-lingui-id: cWTgy7
msgid "Enter project name"
msgstr "Enter project name"

#. js-lingui-id: cYyKAC
msgid "Merge Applicants"
msgstr "Merge Applicants"

#. js-lingui-id: ce4osx
msgid "Payment history analysis"
msgstr "Payment history analysis"

#. js-lingui-id: cgONby
msgid "The landlord will receive a comprehensive <0>Eversa™ Report</0> to evaluate your application and accessibility requirements."
msgstr "The landlord will receive a comprehensive <0>Eversa™ Report</0> to evaluate your application and accessibility requirements."

#. js-lingui-id: ch5ovu
msgid "Building has been archived."
msgstr "Building has been archived."

#. js-lingui-id: cj1/wV
msgid "Step"
msgstr "Step"

#. js-lingui-id: cklVjM
msgid "Timeline"
msgstr "Timeline"

#. js-lingui-id: cnGeoo
msgid "Delete"
msgstr "Delete"

#. js-lingui-id: cnbbjE
msgid "Add additional applicants"
msgstr "Add additional applicants"

#. js-lingui-id: cqbM5J
msgid "This feature is currently under development."
msgstr "This feature is currently under development."

#. js-lingui-id: cukKHK
msgid "The background check information for this applicant is currently unavailable."
msgstr "The background check information for this applicant is currently unavailable."

#. js-lingui-id: d/UNFS
msgid "Unit created successfully"
msgstr "Unit created successfully"

#. js-lingui-id: d8Y9sW
msgid "Debt-to-Income Ratio"
msgstr "Debt-to-Income Ratio"

#. js-lingui-id: dEJ3xG
msgid "Please tell us about your current living situation"
msgstr "Please tell us about your current living situation"

#. js-lingui-id: dEgA5A
msgid "Cancel"
msgstr "Cancel"

#. js-lingui-id: dEzB1X
msgid "I understand the risk"
msgstr "I understand the risk"

#. js-lingui-id: dJW40d
msgid "Postal Code"
msgstr "Postal Code"

#. js-lingui-id: dKXIKM
msgid "Top Buildings by Amount"
msgstr "Top Buildings by Amount"

#. js-lingui-id: dN7i8v
msgid "STATUS"
msgstr "STATUS"

#. js-lingui-id: dRVq80
msgid "Show all listings with submissions"
msgstr "Show all listings with submissions"

#. js-lingui-id: dVTBTD
msgid "Hourly Rate:"
msgstr "Hourly Rate:"

#. js-lingui-id: dXoieq
msgid "Summary"
msgstr "Summary"

#. js-lingui-id: dZmVpz
msgid "Credit Score Scale"
msgstr "Credit Score Scale"

#. js-lingui-id: dZxSSS
msgid "Trusted Individual"
msgstr "Trusted Individual"

#. js-lingui-id: da4KrH
msgid "Deliveries"
msgstr "Deliveries"

#. js-lingui-id: db9vEi
msgid "View all units"
msgstr "View all units"

#. js-lingui-id: dblERr
msgid "Understood"
msgstr "Understood"

#. js-lingui-id: dfN8rY
msgid "Self-Employment Documentation"
msgstr "Self-Employment Documentation"

#. js-lingui-id: dg3VpM
msgid "Workplace"
msgstr "Workplace"

#. js-lingui-id: dm2vYF
msgid "Not specified"
msgstr "Not specified"

#. js-lingui-id: dtOoGl
msgid "Manager"
msgstr "Manager"

#. js-lingui-id: dtu2LP
msgid "This submission has not been updated in over 3 days"
msgstr "This submission has not been updated in over 3 days"

#. js-lingui-id: dvYuhh
msgid "Moderate"
msgstr "Moderate"

#. js-lingui-id: dwVQaS
msgid "Remove service estimates section from generated reports."
msgstr "Remove service estimates section from generated reports."

#. js-lingui-id: e/cvV1
msgid "Verifying..."
msgstr "Verifying..."

#. js-lingui-id: e0NrBM
msgid "Project"
msgstr "Project"

#. js-lingui-id: e551h5
msgid "View Current Tenant Information"
msgstr "View Current Tenant Information"

#. js-lingui-id: e5P3SW
msgid "Rent Only: "
msgstr "Rent Only: "

#. js-lingui-id: e7PviE
msgid "within"
msgstr "within"

#. js-lingui-id: e8gUzr
msgid "Is there a cost associated with using Eversa?"
msgstr "Is there a cost associated with using Eversa?"

#. js-lingui-id: eC1gV9
msgid "Invalid file type"
msgstr "Invalid file type"

#. js-lingui-id: eFeJ86
msgid "Endorser"
msgstr "Endorser"

#. js-lingui-id: eJ3lf1
msgid "Previous Tenant"
msgstr "Previous Tenant"

#. js-lingui-id: eKLncL
msgid "Reference Check"
msgstr "Reference Check"

#. js-lingui-id: eMvjNv
msgid "Identity verified"
msgstr "Identity verified"

#. js-lingui-id: ePAbSx
msgid "{names}'s submission"
msgstr "{names}'s submission"

#. js-lingui-id: ePK91l
msgid "Edit"
msgstr "Edit"

#. js-lingui-id: ePYQjq
msgid "Identity"
msgstr "Identity"

#. js-lingui-id: eTFgny
msgid "Keep the current step"
msgstr "Keep the current step"

#. js-lingui-id: eTTrWd
msgid "Are you sure you want to delete this unit?"
msgstr "Are you sure you want to delete this unit?"

#. js-lingui-id: eZsnff
msgid "Unit is required"
msgstr "Unit is required"

#. js-lingui-id: eb1pqI
msgid "You cannot proceed with adding new applicants until a payment option has been set up. Please configure your payment settings first."
msgstr "You cannot proceed with adding new applicants until a payment option has been set up. Please configure your payment settings first."

#. js-lingui-id: ecUA8p
msgid "Today"
msgstr "Today"

#. js-lingui-id: ed798D
msgid "Payment incomplete"
msgstr "Payment incomplete"

#. js-lingui-id: egHj6c
msgid "Assign Applicant to a unit"
msgstr "Assign Applicant to a unit"

#. js-lingui-id: egwwZ4
msgid "This is where you'll follow the process to apply for the property. Follow the steps below to complete your rental application."
msgstr "This is where you'll follow the process to apply for the property. Follow the steps below to complete your rental application."

#. js-lingui-id: eiDmZm
msgid "Select an Entry Date for this unit"
msgstr "Select an Entry Date for this unit"

#. js-lingui-id: ekCRTP
msgid "Rejected"
msgstr "Rejected"

#. js-lingui-id: emyGv5
msgid "Application updated"
msgstr "Application updated"

#. js-lingui-id: eps54V
msgid "Removed"
msgstr "Removed"

#. js-lingui-id: esw3GM
msgid "Total Debt"
msgstr "Total Debt"

#. js-lingui-id: euc6Ns
msgid "Duplicate"
msgstr "Duplicate"

#. js-lingui-id: ewhiPL
msgid "Moderate Risk"
msgstr "Moderate Risk"

#. js-lingui-id: eygUXi
msgid "Here's everyone currently on your application, including you. Review who's listed to add your missing co-applicant."
msgstr "Here's everyone currently on your application, including you. Review who's listed to add your missing co-applicant."

#. js-lingui-id: eyvkH3
msgid "Enter the french description"
msgstr "Enter the french description"

#. js-lingui-id: f+Zl9t
msgid "To proceed with the evaluation of your file, you must enter your payment information"
msgstr "To proceed with the evaluation of your file, you must enter your payment information"

#. js-lingui-id: f3o0kM
msgid "Editing Application"
msgstr "Editing Application"

#. js-lingui-id: f51db3
msgid "Scan to verify"
msgstr "Scan to verify"

#. js-lingui-id: f7/Eil
msgid "Delivery Agent"
msgstr "Delivery Agent"

#. js-lingui-id: f8SsES
msgid "Are you sure you want to remove {applicantName} from the submission?"
msgstr "Are you sure you want to remove {applicantName} from the submission?"

#. js-lingui-id: f9b1sj
msgid "No agents assigned"
msgstr "No agents assigned"

#. js-lingui-id: fAdPRh
msgid "Please enter your gross annual salary before taxes"
msgstr "Please enter your gross annual salary before taxes"

#. js-lingui-id: fByw/g
msgid "Individual"
msgstr "Individual"

#. js-lingui-id: fDF1VQ
msgid "Tenants will be charged the following fees when applying:"
msgstr "Tenants will be charged the following fees when applying:"

#. js-lingui-id: fF1oUJ
msgid "Promotion Price"
msgstr "Promotion Price"

#. js-lingui-id: fFQGk9
msgid "Description of the listing"
msgstr "Description of the listing"

#. js-lingui-id: fMXWoZ
msgid "{tenantName} real estate: {type} with {bedrooms} bedrooms for rent, {address}, {city}"
msgstr "{tenantName} real estate: {type} with {bedrooms} bedrooms for rent, {address}, {city}"

#. js-lingui-id: fO3Xr7
msgid "Property Details"
msgstr "Property Details"

#. js-lingui-id: fO6syE
msgid "Deadline for conditions"
msgstr "Deadline for conditions"

#. js-lingui-id: fSGoiV
msgid "Enter listing description in French"
msgstr "Enter listing description in French"

#. js-lingui-id: fTUn9h
msgid "Installment"
msgstr "Installment"

#. js-lingui-id: fU4eQN
msgid "Mark as completed"
msgstr "Mark as completed"

#. js-lingui-id: fUByRl
msgid "Absolutely not! Eversa is fundamentally free for landlords. The only expense involved is when tenants apply, as they cover the application fee. This fee includes the provision of credit reports to landlords, should they choose to request them. However, for landlords who prefer not to have tenants cover the cost of credit reports, the option is available to pay for it themselves through Eversa."
msgstr "Absolutely not! Eversa is fundamentally free for landlords. The only expense involved is when tenants apply, as they cover the application fee. This fee includes the provision of credit reports to landlords, should they choose to request them. However, for landlords who prefer not to have tenants cover the cost of credit reports, the option is available to pay for it themselves through Eversa."

#. js-lingui-id: fUQgpA
msgid "Hide Service Estimates on Reports"
msgstr "Hide Service Estimates on Reports"

#. js-lingui-id: fUqA01
msgid "Co Applicant"
msgstr "Co Applicant"

#. js-lingui-id: fcWrnU
msgid "Sign out"
msgstr "Sign out"

#. js-lingui-id: fcrjX7
msgid "Hmm.. looks like this resource doesn't have any notes."
msgstr "Hmm.. looks like this resource doesn't have any notes."

#. js-lingui-id: feCRNv
msgid "Change email"
msgstr "Change email"

#. js-lingui-id: fhAyL2
msgid "Valid until "
msgstr "Valid until "

#. js-lingui-id: fhShV9
msgid "Unit has been successfully assigned to the submission"
msgstr "Unit has been successfully assigned to the submission"

#. js-lingui-id: fj5byd
msgid "N/A"
msgstr "N/A"

#. js-lingui-id: fmq4AW
msgid "Housing Information"
msgstr "Housing Information"

#. js-lingui-id: foCvf0
msgid "Please choose one of the following methods to add them"
msgstr "Please choose one of the following methods to add them"

#. js-lingui-id: fp0Y29
msgid "Added {createdAtDate} ({createdAtAgo} ago)"
msgstr "Added {createdAtDate} ({createdAtAgo} ago)"

#. js-lingui-id: fpMgHS
msgid "Mon"
msgstr "Mon"

#. js-lingui-id: fsgSjm
msgid "Unit #"
msgstr "Unit #"

#. js-lingui-id: fwi1qh
msgid "Enter banner text in French"
msgstr "Enter banner text in French"

#. js-lingui-id: fyTCYk
msgid "Select Unit"
msgstr "Select Unit"

#. js-lingui-id: fzUQAw
msgid "Enter Facebook Pixel ID"
msgstr "Enter Facebook Pixel ID"

#. js-lingui-id: g/M3bA
msgid "Feature flags updated"
msgstr "Feature flags updated"

#. js-lingui-id: g0+4qo
msgid "Check criminal records"
msgstr "Check criminal records"

#. js-lingui-id: g0/RsH
msgid "{city}: {type} with {bedrooms} bedrooms, {tenantName} rental"
msgstr "{city}: {type} with {bedrooms} bedrooms, {tenantName} rental"

#. js-lingui-id: g1W6VN
msgid "Set requirements that would allow the tenant to reapply"
msgstr "Set requirements that would allow the tenant to reapply"

#. js-lingui-id: g2UNkE
msgid "Powered by"
msgstr "Powered by"

#. js-lingui-id: g40wrD
msgid "What's included in your application"
msgstr "What's included in your application"

#. js-lingui-id: g7FtKA
msgid "The tenant has provided proof of insurance."
msgstr "The tenant has provided proof of insurance."

#. js-lingui-id: g7ZTwA
msgid "{bathrooms} bathrooms, {bedrooms} bedrooms, {area} sqft"
msgstr "{bathrooms} bathrooms, {bedrooms} bedrooms, {area} sqft"

#. js-lingui-id: g7jwTg
msgid "Showing"
msgstr "Showing"

#. js-lingui-id: g8jjNi
msgid "Consents"
msgstr "Consents"

#. js-lingui-id: gGyz7m
msgid "Enter the tenant's basic details"
msgstr "Enter the tenant's basic details"

#. js-lingui-id: gI4Spy
msgid "Employment Letter of Offer"
msgstr "Employment Letter of Offer"

#. js-lingui-id: gKTfBi
msgid "You are about to select <0>{selected}</0> as the tenant for this unit. Please confirm your selection and if necessary, specify how to handle the remaining applications."
msgstr "You are about to select <0>{selected}</0> as the tenant for this unit. Please confirm your selection and if necessary, specify how to handle the remaining applications."

#. js-lingui-id: gM+MdT
msgid "Require applicants to provide their Social Insurance Number during the application process."
msgstr "Require applicants to provide their Social Insurance Number during the application process."

#. js-lingui-id: gMo7XR
msgid "Manual Review"
msgstr "Manual Review"

#. js-lingui-id: gOdB00
msgid "Credit check request sent"
msgstr "Credit check request sent"

#. js-lingui-id: gQ7G5a
msgid "Number of years at current job"
msgstr "Number of years at current job"

#. js-lingui-id: gQBxBJ
msgid "Your information is only shared with the property manager handling your application and their authorized landlords or subprocessors. We never sell or share your data with unauthorized third parties."
msgstr "Your information is only shared with the property manager handling your application and their authorized landlords or subprocessors. We never sell or share your data with unauthorized third parties."

#. js-lingui-id: gSwPlk
msgid "We are missing your billing information"
msgstr "We are missing your billing information"

#. js-lingui-id: gbVkz/
msgid "Waiting for tenant to sign lease"
msgstr "Waiting for tenant to sign lease"

#. js-lingui-id: gcIka/
msgid "First-time renters"
msgstr "First-time renters"

#. js-lingui-id: gkebzV
msgid "No leads are available in this category at the moment."
msgstr "No leads are available in this category at the moment."

#. js-lingui-id: glCYLq
msgid "Customize the way your tenants fill in your rental application form."
msgstr "Customize the way your tenants fill in your rental application form."

#. js-lingui-id: gm0Lz3
msgid "Back to Admin Panel"
msgstr "Back to Admin Panel"

#. js-lingui-id: gmkKhS
msgid "Remove applicant"
msgstr "Remove applicant"

#. js-lingui-id: gn7UzG
msgid "Living Arrangement"
msgstr "Living Arrangement"

#. js-lingui-id: gov1Vf
msgid "Your application was declined due to information found in your criminal background check."
msgstr "Your application was declined due to information found in your criminal background check."

#. js-lingui-id: gpWjJX
msgid "Verify the references provided by the tenant for their work and rental history."
msgstr "Verify the references provided by the tenant for their work and rental history."

#. js-lingui-id: gq6s8P
msgid "Reason for cancellation"
msgstr "Reason for cancellation"

#. js-lingui-id: gt5a0W
msgid "Promotion Details <0/>"
msgstr "Promotion Details <0/>"

#. js-lingui-id: gwfP2S
msgid "Issue with check"
msgstr "Issue with check"

#. js-lingui-id: gxYz5c
msgid "Found"
msgstr "Found"

#. js-lingui-id: gy9MoY
msgid "Proceed with the application without email notifications. The tenant will not receive any application updates."
msgstr "Proceed with the application without email notifications. The tenant will not receive any application updates."

#. js-lingui-id: gyjsV2
msgid "Commercial"
msgstr "Commercial"

#. js-lingui-id: gyrmfy
msgid "Uploading... {uploadProgress}%"
msgstr "Uploading... {uploadProgress}%"

#. js-lingui-id: gzZ8OH
msgid "{tenantName}: {type} with {bedrooms} bedrooms for rent in {city}, {address}"
msgstr "{tenantName}: {type} with {bedrooms} bedrooms for rent in {city}, {address}"

#. js-lingui-id: h28hXf
msgid "90 days"
msgstr "90 days"

#. js-lingui-id: h3GuHp
msgid "Applicant added"
msgstr "Applicant added"

#. js-lingui-id: h5e1I4
msgid "We regret to inform you that your rental application has been rejected. While this is the current decision, there may be options to strengthen your application. We understand this news may be disappointing."
msgstr "We regret to inform you that your rental application has been rejected. While this is the current decision, there may be options to strengthen your application. We understand this news may be disappointing."

#. js-lingui-id: hBm3J/
msgid "Organization name is required"
msgstr "Organization name is required"

#. js-lingui-id: hCpDDZ
msgid "Invite an applicant via e-mail, or fill out a rental application form in person"
msgstr "Invite an applicant via e-mail, or fill out a rental application form in person"

#. js-lingui-id: hF3aS6
msgid "Create Project"
msgstr "Create Project"

#. js-lingui-id: hFmUep
msgid "Payment pending - Tenant is paying"
msgstr "Payment pending - Tenant is paying"

#. js-lingui-id: hInJTA
msgid "Banner Text French"
msgstr "Banner Text French"

#. js-lingui-id: hJF/sr
msgid "Assigned:"
msgstr "Assigned:"

#. js-lingui-id: hM7Rhq
msgid "Reply-To Settings"
msgstr "Reply-To Settings"

#. js-lingui-id: hOdqT6
msgid "Comprehensive tenant screening and verification"
msgstr "Comprehensive tenant screening and verification"

#. js-lingui-id: hPur4k
msgid "Identity Verification"
msgstr "Identity Verification"

#. js-lingui-id: hQRttt
msgid "Submit"
msgstr "Submit"

#. js-lingui-id: hSVgUS
msgid "Applicant Information"
msgstr "Applicant Information"

#. js-lingui-id: hTRnIR
msgid "Credit Report"
msgstr "Credit Report"

#. js-lingui-id: hVTUaS
msgid "API Configuration"
msgstr "API Configuration"

#. js-lingui-id: hWQs8X
msgid "Employment"
msgstr "Employment"

#. js-lingui-id: hXzOVo
msgid "Next"
msgstr "Next"

#. js-lingui-id: hYgDIe
msgid "Create"
msgstr "Create"

#. js-lingui-id: hbI+8q
msgid "Applicant has been successfully removed from the submission"
msgstr "Applicant has been successfully removed from the submission"

#. js-lingui-id: hcv6uc
msgid "Your payment was not successful"
msgstr "Your payment was not successful"

#. js-lingui-id: heXFeC
msgid "Finalize and pay"
msgstr "Finalize and pay"

#. js-lingui-id: hehnjM
msgid "Amount"
msgstr "Amount"

#. js-lingui-id: hgMhjQ
msgid "Select Listing"
msgstr "Select Listing"

#. js-lingui-id: hh5ouw
msgid "Birthdate <0>(Required)</0>"
msgstr "Birthdate <0>(Required)</0>"

#. js-lingui-id: hjGM6C
msgid "For accurate affordability analysis, we need complete financial information including income, existing debt obligations, and credit history. Please ensure all required financial data is provided."
msgstr "For accurate affordability analysis, we need complete financial information including income, existing debt obligations, and credit history. Please ensure all required financial data is provided."

#. js-lingui-id: hjaZqm
msgid "Project Overview"
msgstr "Project Overview"

#. js-lingui-id: hkyw9A
msgid "Credit Check Dashboard"
msgstr "Credit Check Dashboard"

#. js-lingui-id: hq7duP
msgid "Unknown action"
msgstr "Unknown action"

#. js-lingui-id: htTcVX
msgid "Status:"
msgstr "Status:"

#. js-lingui-id: htjiy6
msgid "Light Logo"
msgstr "Light Logo"

#. js-lingui-id: hwGp6h
msgid "Enter organization name"
msgstr "Enter organization name"

#. js-lingui-id: hwXhZ8
msgid "Unsnooze Step"
msgstr "Unsnooze Step"

#. js-lingui-id: hzKQCy
msgid "Email Address"
msgstr "Email Address"

#. js-lingui-id: i+/x21
msgid "Option for prepaid rent"
msgstr "Option for prepaid rent"

#. js-lingui-id: i0qMbr
msgid "Home"
msgstr "Home"

#. js-lingui-id: i3o6QM
msgid "Insurance Proof"
msgstr "Insurance Proof"

#. js-lingui-id: i42zVQ
msgid "Chosen"
msgstr "Chosen"

#. js-lingui-id: i4V84s
msgid "No buildings for this month"
msgstr "No buildings for this month"

#. js-lingui-id: i8GmNv
msgid "User has provided consent for credit bureau checks"
msgstr "User has provided consent for credit bureau checks"

#. js-lingui-id: iDJJPV
msgid "Tenant Details"
msgstr "Tenant Details"

#. js-lingui-id: iDNBZe
msgid "Notifications"
msgstr "Notifications"

#. js-lingui-id: iEQQyu
msgid "Agent"
msgstr "Agent"

#. js-lingui-id: iH8pgl
msgid "Back"
msgstr "Back"

#. js-lingui-id: iIYyyz
msgid "Departure Date"
msgstr "Departure Date"

#. js-lingui-id: iJ5vP5
msgid "This application has been rejected with condition to be fulfilled before <0>{countdownDate}</0>"
msgstr "This application has been rejected with condition to be fulfilled before <0>{countdownDate}</0>"

#. js-lingui-id: iLZGud
msgid "Very Low Risk"
msgstr "Very Low Risk"

#. js-lingui-id: iMFcF3
msgid "Unit:"
msgstr "Unit:"

#. js-lingui-id: iNoUCp
msgid "All features"
msgstr "All features"

#. js-lingui-id: iOPfhV
msgid "Could not retrieve complete applicant information (name, DOB, or address). Please check the profile and try again."
msgstr "Could not retrieve complete applicant information (name, DOB, or address). Please check the profile and try again."

#. js-lingui-id: iQXbtV
msgid "Your Workload Overview"
msgstr "Your Workload Overview"

#. js-lingui-id: iRV0QI
msgid "This submission was discarded as the applicants are no longer pursuing the application process. Their information is saved as a lead for future reference. You can always contact them or reopen their application later."
msgstr "This submission was discarded as the applicants are no longer pursuing the application process. Their information is saved as a lead for future reference. You can always contact them or reopen their application later."

#. js-lingui-id: iRt239
msgid "Low Risk (≤43%)"
msgstr "Low Risk (≤43%)"

#. js-lingui-id: iWU6r6
msgid "Show Timeline"
msgstr "Show Timeline"

#. js-lingui-id: ibSQNg
msgid "Please provide contact information for your references"
msgstr "Please provide contact information for your references"

#. js-lingui-id: iboNXd
msgid "Amount received"
msgstr "Amount received"

#. js-lingui-id: idPYrj
msgid "{tenantName}: {type} for rent, {bedrooms} bedrooms, {address}, {city}"
msgstr "{tenantName}: {type} for rent, {bedrooms} bedrooms, {address}, {city}"

#. js-lingui-id: idhKCE
msgid "Primary Applicant"
msgstr "Primary Applicant"

#. js-lingui-id: ieAHV7
msgid "Reference Rating"
msgstr "Reference Rating"

#. js-lingui-id: ik2cu/
msgid "Didn't receive code?"
msgstr "Didn't receive code?"

#. js-lingui-id: ikeVX6
msgid "When did you start living here?"
msgstr "When did you start living here?"

#. js-lingui-id: ilQjgP
msgid "USER"
msgstr "USER"

#. js-lingui-id: ilTx8u
msgid "Start or continue your application process"
msgstr "Start or continue your application process"

#. js-lingui-id: in7EUA
msgid "Wait a few minutes and try again"
msgstr "Wait a few minutes and try again"

#. js-lingui-id: in9MKE
msgid "Are all features included in the free version?"
msgstr "Are all features included in the free version?"

#. js-lingui-id: iqxT9f
msgid "Message for Tenant"
msgstr "Message for Tenant"

#. js-lingui-id: isRobC
msgid "New"
msgstr "New"

#. js-lingui-id: iuJFAy
msgid "Low Risk"
msgstr "Low Risk"

#. js-lingui-id: ivIm6I
msgid "Charged once per applicant"
msgstr "Charged once per applicant"

#. js-lingui-id: iy15g/
msgid "Enter banner text in English"
msgstr "Enter banner text in English"

#. js-lingui-id: iyOEiI
msgid "Tenant"
msgstr "Tenant"

#. js-lingui-id: j/ToNV
msgid "Social Insurance Number"
msgstr "Social Insurance Number"

#. js-lingui-id: j/cgaV
msgid "Impact on monthly income"
msgstr "Impact on monthly income"

#. js-lingui-id: j16c2i
msgid "We regret to inform you that your rental application has been removed from consideration. While this is the current status, there may be options to strengthen your application. We understand this news may be disappointing."
msgstr "We regret to inform you that your rental application has been removed from consideration. While this is the current status, there may be options to strengthen your application. We understand this news may be disappointing."

#. js-lingui-id: j1ElMW
msgid "Unit deleted successfully"
msgstr "Unit deleted successfully"

#. js-lingui-id: j1MRp+
msgid "Are you sure you want to cancel the delivery for this submission?"
msgstr "Are you sure you want to cancel the delivery for this submission?"

#. js-lingui-id: j2OqfX
msgid "Country Code"
msgstr "Country Code"

#. js-lingui-id: j2rI5/
msgid "Reference Type"
msgstr "Reference Type"

#. js-lingui-id: jCNUYo
msgid "Have questions or need assistance? Our team is here to help you find your perfect place."
msgstr "Have questions or need assistance? Our team is here to help you find your perfect place."

#. js-lingui-id: jE1bem
msgid "All set! No deliveries are scheduled right now."
msgstr "All set! No deliveries are scheduled right now."

#. js-lingui-id: jErFHA
msgid "Court Name"
msgstr "Court Name"

#. js-lingui-id: jEu4bB
msgid "Columns"
msgstr "Columns"

#. js-lingui-id: jIPNJG
msgid "Basic Information"
msgstr "Basic Information"

#. js-lingui-id: jJ6dzg
msgid "Salary must be greater than 0"
msgstr "Salary must be greater than 0"

#. js-lingui-id: jJQZUi
msgid "Please provide contact details for your current or previous landlord or property manager"
msgstr "Please provide contact details for your current or previous landlord or property manager"

#. js-lingui-id: jJzvFJ
msgid "Employment Length"
msgstr "Employment Length"

#. js-lingui-id: jLW6SE
msgid "The reported monthly income (${income}) is too low for an accurate affordability analysis. Please verify the income information."
msgstr "The reported monthly income (${income}) is too low for an accurate affordability analysis. Please verify the income information."

#. js-lingui-id: jNLD8R
msgid "Start typing an address..."
msgstr "Start typing an address..."

#. js-lingui-id: jNX9Hl
msgid "Missing Credit"
msgstr "Missing Credit"

#. js-lingui-id: jP5+uW
msgid "Combine multiple applicants into a single submission"
msgstr "Combine multiple applicants into a single submission"

#. js-lingui-id: jQX8V+
msgid "By Status"
msgstr "By Status"

#. js-lingui-id: jRuA33
msgid "Credit Check Report"
msgstr "Credit Check Report"

#. js-lingui-id: jTxtBH
msgid "Moderate utilization"
msgstr "Moderate utilization"

#. js-lingui-id: jVI3ce
msgid "Invite Candidate"
msgstr "Invite Candidate"

#. js-lingui-id: jVit+R
msgid "Acting as {tenantSlug} with admin privileges. Actions recorded."
msgstr "Acting as {tenantSlug} with admin privileges. Actions recorded."

#. js-lingui-id: jWR9A7
msgid "Sign out of your account"
msgstr "Sign out of your account"

#. js-lingui-id: jWaJuP
msgid "Missing User"
msgstr "Missing User"

#. js-lingui-id: jYbKwR
msgid "Enables staff to take actions during this submission step"
msgstr "Enables staff to take actions during this submission step"

#. js-lingui-id: ja7jsW
msgid "Current Living Arrangement"
msgstr "Current Living Arrangement"

#. js-lingui-id: jcnQjB
msgid "Sign in to continue your application or access your tenant portal"
msgstr "Sign in to continue your application or access your tenant portal"

#. js-lingui-id: jePyJ9
msgid "Error Code: {errorCode}"
msgstr "Error Code: {errorCode}"

#. js-lingui-id: jfC/xh
msgid "Contact"
msgstr "Contact"

#. js-lingui-id: jg6q1p
msgid "Application Reports"
msgstr "Application Reports"

#. js-lingui-id: jilCAY
msgid "Owners have full administrative access to the organization, including managing team members, billing, and all organization settings."
msgstr "Owners have full administrative access to the organization, including managing team members, billing, and all organization settings."

#. js-lingui-id: jjlrdR
msgid "Start Application"
msgstr "Start Application"

#. js-lingui-id: jlYOCC
msgid "Criminal record check"
msgstr "Criminal record check"

#. js-lingui-id: jmsnSb
msgid "Choose File"
msgstr "Choose File"

#. js-lingui-id: joaY8v
msgid "The tenant has not received the rules and regulations."
msgstr "The tenant has not received the rules and regulations."

#. js-lingui-id: joygfD
msgid "Moderate stretch (30-40% of available income)"
msgstr "Moderate stretch (30-40% of available income)"

#. js-lingui-id: jp0+jP
msgid "Select the applicants you want to merge"
msgstr "Select the applicants you want to merge"

#. js-lingui-id: jpctdh
msgid "View"
msgstr "View"

#. js-lingui-id: jtc5/e
msgid "No submissions found"
msgstr "No submissions found"

#. js-lingui-id: jyxrtr
msgid "Neighborhood"
msgstr "Neighborhood"

#. js-lingui-id: k/ANik
msgid "Finances"
msgstr "Finances"

#. js-lingui-id: k1Jind
msgid "Allow staff members to see and use the 'Send to Prospect' button."
msgstr "Allow staff members to see and use the 'Send to Prospect' button."

#. js-lingui-id: k2ZWbt
msgid "You must pay your profile verification fee to continue"
msgstr "You must pay your profile verification fee to continue"

#. js-lingui-id: kDuHO3
msgid "No verifications selected"
msgstr "No verifications selected"

#. js-lingui-id: kFFkAk
msgid "Background information unavailable"
msgstr "Background information unavailable"

#. js-lingui-id: kGO4H2
msgid "Completed on {rulesDate}"
msgstr "Completed on {rulesDate}"

#. js-lingui-id: kHYqrd
msgid "Type the address here..."
msgstr "Type the address here..."

#. js-lingui-id: kJ1Oks
msgid "Payment history"
msgstr "Payment history"

#. js-lingui-id: kKHBpG
msgid "Total Application Fee"
msgstr "Total Application Fee"

#. js-lingui-id: kNeEXg
msgid "Current Price"
msgstr "Current Price"

#. js-lingui-id: kO9x/r
msgid "Configure your intelligent tenant screening parameters powered by Eversa's advanced analytics"
msgstr "Configure your intelligent tenant screening parameters powered by Eversa's advanced analytics"

#. js-lingui-id: kODvZJ
msgid "First Name"
msgstr "First Name"

#. js-lingui-id: kTTERt
msgid "The application hold has been marked as completed. Please review the application and proceed with the next steps."
msgstr "The application hold has been marked as completed. Please review the application and proceed with the next steps."

#. js-lingui-id: kTcFUK
msgid "60 days"
msgstr "60 days"

#. js-lingui-id: kWURkg
msgid "Annual Income"
msgstr "Annual Income"

#. js-lingui-id: kbZGHg
msgid "Address History (6+ Months)"
msgstr "Address History (6+ Months)"

#. js-lingui-id: kfeUSb
msgid "There was an error assigning the submission"
msgstr "There was an error assigning the submission"

#. js-lingui-id: kgFvGM
msgid "Long-term leases"
msgstr "Long-term leases"

#. js-lingui-id: kh/2xY
msgid "Information Missing"
msgstr "Information Missing"

#. js-lingui-id: kjm4uO
msgid "How long does the application process take?"
msgstr "How long does the application process take?"

#. js-lingui-id: kjoU6t
msgid "Converted to project"
msgstr "Converted to project"

#. js-lingui-id: kmE79G
msgid "Unknown account type"
msgstr "Unknown account type"

#. js-lingui-id: knDRX+
msgid "{bedrooms} bedrooms, {tenantName} {type} for rent in {city}, {address}"
msgstr "{bedrooms} bedrooms, {tenantName} {type} for rent in {city}, {address}"

#. js-lingui-id: kqqfc7
msgid "Complete all requirements before delivery"
msgstr "Complete all requirements before delivery"

#. js-lingui-id: ktRQXJ
msgid "Fill in the details below to create a new tenant organization"
msgstr "Fill in the details below to create a new tenant organization"

#. js-lingui-id: kuE2S/
msgid "Browse Available Properties"
msgstr "Browse Available Properties"

#. js-lingui-id: kvwxvf
msgid "Description (French)"
msgstr "Description (French)"

#. js-lingui-id: kw7NLK
msgid "Listing is required"
msgstr "Listing is required"

#. js-lingui-id: kxPyT8
msgid "tenant@example.com"
msgstr "tenant@example.com"

#. js-lingui-id: kxZ7LS
msgid "Webhook updated"
msgstr "Webhook updated"

#. js-lingui-id: kycuCv
msgid "Show submissions assigned to me"
msgstr "Show submissions assigned to me"

#. js-lingui-id: kzMF2k
msgid "This credit check may impact your credit score, depending on the nature of the credit score, depending on the nature of the request and the policies of the credit bureau."
msgstr "This credit check may impact your credit score, depending on the nature of the credit score, depending on the nature of the request and the policies of the credit bureau."

#. js-lingui-id: l2iifO
msgid "I am done"
msgstr "I am done"

#. js-lingui-id: l4GvBw
msgid "Manage this submission's address"
msgstr "Manage this submission's address"

#. js-lingui-id: l6MW/b
msgid "Detailed debt analysis including payment history, debt utilization trends, <0/>and debt-to-income ratios across different categories like credit cards, loans and mortgages."
msgstr "Detailed debt analysis including payment history, debt utilization trends, <0/>and debt-to-income ratios across different categories like credit cards, loans and mortgages."

#. js-lingui-id: l75CjT
msgid "Yes"
msgstr "Yes"

#. js-lingui-id: l7fStm
msgid "Utilities"
msgstr "Utilities"

#. js-lingui-id: l8u/ot
msgid "Building updated successfully"
msgstr "Building updated successfully"

#. js-lingui-id: l9fkrm
msgid "Consent"
msgstr "Consent"

#. js-lingui-id: lCF0wC
msgid "Refresh"
msgstr "Refresh"

#. js-lingui-id: lCLuUQ
msgid "Try adding more characters to your search term."
msgstr "Try adding more characters to your search term."

#. js-lingui-id: lHYEwC
msgid "Credit score verification"
msgstr "Credit score verification"

#. js-lingui-id: lKhoOk
msgid "We couldn't find any background information for this applicant"
msgstr "We couldn't find any background information for this applicant"

#. js-lingui-id: lOD90K
msgid "Promote Unit"
msgstr "Promote Unit"

#. js-lingui-id: lOPsFO
msgid "Add an Applicant"
msgstr "Add an Applicant"

#. js-lingui-id: lOoJGy
msgid "Basic application processing"
msgstr "Basic application processing"

#. js-lingui-id: lSQYpT
msgid "No References Available"
msgstr "No References Available"

#. js-lingui-id: lWfUAp
msgid "Open Full Application"
msgstr "Open Full Application"

#. js-lingui-id: lXGdbb
msgid "Assigned"
msgstr "Assigned"

#. js-lingui-id: lXa/Jf
msgid "General Notifications"
msgstr "General Notifications"

#. js-lingui-id: lXkUEV
msgid "Availability"
msgstr "Availability"

#. js-lingui-id: lYGfRP
msgid "English"
msgstr "English"

#. Language switcher. Need to be other language
#. Language switcher. Need to be other language
#. js-lingui-explicit-id
msgid "language"
msgstr "Français"

#. js-lingui-id: lb+3SG
msgid "Put this submission on hold and let the applicant know what additional information you need from them."
msgstr "Put this submission on hold and let the applicant know what additional information you need from them."

#. js-lingui-id: lgRDKv
msgid "Submission is rejected with conditions"
msgstr "Submission is rejected with conditions"

#. js-lingui-id: lhJcoY
msgid "Detailed debt category information is not available at the moment. This may be due to missing credit report data."
msgstr "Detailed debt category information is not available at the moment. This may be due to missing credit report data."

#. js-lingui-explicit-id
msgid "listings.apply.consents"
msgstr "Approve consents"

#. js-lingui-explicit-id
msgid "listings.apply.consents-description"
msgstr "Approve the terms and conditions of the application"

#. js-lingui-explicit-id
msgid "listings.apply.credit-check"
msgstr "Complete your credit check"

#. js-lingui-explicit-id
msgid "listings.apply.credit-check-description"
msgstr "We will be performing a credit check to analyze your application"

#. js-lingui-explicit-id
msgid "listings.apply.documents-uploads"
msgstr "Upload documents"

#. js-lingui-explicit-id
msgid "listings.apply.documents-uploads-description"
msgstr "Upload your required proof of work and identity."

#. js-lingui-explicit-id
msgid "listings.apply.payment-description"
msgstr "Finalize and pay the application fees."

#. js-lingui-explicit-id
msgid "listings.apply.personal-details"
msgstr "Fill your personal details"

#. js-lingui-explicit-id
msgid "listings.apply.personal-details-description"
msgstr "We need your personal information to contact you and process your application"

#. js-lingui-id: ljiIpd
msgid "The listing will be re-opened as a result of this operation."
msgstr "The listing will be re-opened as a result of this operation."

#. js-lingui-id: ljrfNc
msgid "My Settings"
msgstr "My Settings"

#. js-lingui-id: lpJtvA
msgid "Your application requires an additional person (partner, friend, parent or endorser) to strengthen your application. Please proceed to the section below to add this person."
msgstr "Your application requires an additional person (partner, friend, parent or endorser) to strengthen your application. Please proceed to the section below to add this person."

#. js-lingui-id: luAHZ6
msgid "Deliveries for"
msgstr "Deliveries for"

#. js-lingui-id: ly4ADG
msgid "Commented on"
msgstr "Commented on"

#. js-lingui-id: m01loN
msgid "We've received your application. You can follow the remaining steps below to complete your rental application process."
msgstr "We've received your application. You can follow the remaining steps below to complete your rental application process."

#. js-lingui-id: m16xKo
msgid "Add"
msgstr "Add"

#. js-lingui-id: m2KF6A
msgid "Verify income stability and payment history before proceeding."
msgstr "Verify income stability and payment history before proceeding."

#. js-lingui-id: m3akJp
msgid "I don't have a work reference"
msgstr "I don't have a work reference"

#. js-lingui-id: m4Nqxf
msgid "Upload Documents:"
msgstr "Upload Documents:"

#. js-lingui-id: m8Ew6A
msgid "View agent dashboard"
msgstr "View agent dashboard"

#. js-lingui-id: mAr4Dl
msgid "All Listings"
msgstr "All Listings"

#. js-lingui-id: mCimdw
msgid "Preparing your application..."
msgstr "Preparing your application..."

#. js-lingui-id: mDJV6q
msgid "Support via email and chat"
msgstr "Support via email and chat"

#. js-lingui-id: mJcdxJ
msgid "unlisted"
msgstr "unlisted"

#. js-lingui-id: mLR/c3
msgid "Upload the required documents below."
msgstr "Upload the required documents below."

#. js-lingui-id: mMQSH4
msgid "Bedrooms"
msgstr "Bedrooms"

#. js-lingui-id: mOFgdC
msgid "Maximum"
msgstr "Maximum"

#. js-lingui-id: mOjKS5
msgid "Social Security Number"
msgstr "Social Security Number"

#. js-lingui-id: mUwcD7
msgid "New Entries"
msgstr "New Entries"

#. js-lingui-id: mWHt8Y
msgid "Marketing Stats"
msgstr "Marketing Stats"

#. js-lingui-id: mXtW19
msgid "Last 24 Months"
msgstr "Last 24 Months"

#. js-lingui-id: mYGY3B
msgid "Date"
msgstr "Date"

#. js-lingui-id: mbM6E8
msgid "List View"
msgstr "List View"

#. js-lingui-id: mcbkPO
msgid "Save Webhook"
msgstr "Save Webhook"

#. js-lingui-id: mcfB2A
msgid "Move to"
msgstr "Move to"

#. js-lingui-id: mdRvRh
msgid "View all {leadsLength} leads"
msgstr "View all {leadsLength} leads"

#. js-lingui-id: mhc5cx
msgid "Your payment was successful"
msgstr "Your payment was successful"

#. js-lingui-id: mhsnB6
msgid "Retired"
msgstr "Retired"

#. js-lingui-id: miQvV4
msgid "APPLICANT"
msgstr "APPLICANT"

#. js-lingui-id: min/oe
msgid "The phone is invalid"
msgstr "The phone is invalid"

#. js-lingui-id: mmcbA6
msgid "Select a unit"
msgstr "Select a unit"

#. js-lingui-id: mnRo94
msgid "No background information found"
msgstr "No background information found"

#. js-lingui-id: moEkos
msgid "The first image you upload will be used as the featured image for this project on the listing page and in search results."
msgstr "The first image you upload will be used as the featured image for this project on the listing page and in search results."

#. js-lingui-id: msQkES
msgid "Time: {timestamp}"
msgstr "Time: {timestamp}"

#. js-lingui-id: mtGDyy
msgid "Incomplete"
msgstr "Incomplete"

#. js-lingui-id: mve+bF
msgid "Enter Ads Conversion ID"
msgstr "Enter Ads Conversion ID"

#. js-lingui-id: mvjCaf
msgid "I am retired"
msgstr "I am retired"

#. js-lingui-id: myXW4v
msgid "Work Reference"
msgstr "Work Reference"

#. js-lingui-id: mzD+xl
msgid "Adding more tenants to your application could strengthen the combined financial profile."
msgstr "Adding more tenants to your application could strengthen the combined financial profile."

#. js-lingui-id: n1ekoW
msgid "Sign In"
msgstr "Sign In"

#. js-lingui-id: n3MSJu
msgid "Application Fee Summary"
msgstr "Application Fee Summary"

#. js-lingui-id: n7JQEk
msgid "Project not found"
msgstr "Project not found"

#. js-lingui-id: n9u/m0
msgid "Employer"
msgstr "Employer"

#. js-lingui-id: nEUrSn
msgid "No description available"
msgstr "No description available"

#. js-lingui-id: nGKQKf
msgid "Select a Listing"
msgstr "Select a Listing"

#. js-lingui-id: nK1ecQ
msgid "This listing is not published, this is only a preview"
msgstr "This listing is not published, this is only a preview"

#. js-lingui-id: nKRwdH
msgid "Please select a specific building first to add a unit."
msgstr "Please select a specific building first to add a unit."

#. js-lingui-id: nLC6tu
msgid "French"
msgstr "French"

#. js-lingui-id: nMHIQ7
msgid "Enables visit agents to take actions during this submission step"
msgstr "Enables visit agents to take actions during this submission step"

#. js-lingui-id: nMZWl5
msgid "The project has been created and you can now add buildings to it"
msgstr "The project has been created and you can now add buildings to it"

#. js-lingui-id: nOhz3x
msgid "Logout"
msgstr "Logout"

#. js-lingui-id: nQYfYJ
msgid "Financial data is not available at the moment. This may be due to missing financial information or inconsistencies in the reported data."
msgstr "Financial data is not available at the moment. This may be due to missing financial information or inconsistencies in the reported data."

#. js-lingui-id: nTWWCZ
msgid "Low"
msgstr "Low"

#. js-lingui-id: nU5DXS
msgid "Visit Agent"
msgstr "Visit Agent"

#. js-lingui-id: nVsHM3
msgid "You will then have a pass allowing you to apply for free on other listings for a period of 30 days"
msgstr "You will then have a pass allowing you to apply for free on other listings for a period of 30 days"

#. js-lingui-id: nb+Oy7
msgid "Quebec civil court records search"
msgstr "Quebec civil court records search"

#. js-lingui-id: nbuFqP
msgid "Electricity Proof"
msgstr "Electricity Proof"

#. js-lingui-id: neXsCN
msgid "Poor Rental History"
msgstr "Poor Rental History"

#. js-lingui-id: neqk4D
msgid "Proceed with standard verification process."
msgstr "Proceed with standard verification process."

#. js-lingui-id: nfnm9D
msgid "Organization Name"
msgstr "Organization Name"

#. js-lingui-id: nhT3ZT
msgid "Submission has been successfully sent to leads"
msgstr "Submission has been successfully sent to leads"

#. js-lingui-id: nhaNzc
msgid "Click to browse or drag and drop your CSV file here"
msgstr "Click to browse or drag and drop your CSV file here"

#. js-lingui-id: nhn/TI
msgid "Calendar View"
msgstr "Calendar View"

#. js-lingui-id: ni5s4I
msgid "High Risk (≥48%)"
msgstr "High Risk (≥48%)"

#. js-lingui-id: niOZHm
msgid "Proof of Funds/Savings"
msgstr "Proof of Funds/Savings"

#. js-lingui-id: nig8jh
msgid "eg: rentals@acmeinc.com"
msgstr "eg: rentals@acmeinc.com"

#. js-lingui-id: nim7CO
msgid "Est. Utilities"
msgstr "Est. Utilities"

#. js-lingui-id: njmBly
msgid "Hide Details"
msgstr "Hide Details"

#. js-lingui-id: nmgmCl
msgid "Main Applicant"
msgstr "Main Applicant"

#. js-lingui-id: nqHFGw
msgid "Started "
msgstr "Started "

#. js-lingui-id: nqpcbE
msgid "Pixel ID"
msgstr "Pixel ID"

#. js-lingui-id: nspXst
msgid "Income Value"
msgstr "Income Value"

#. js-lingui-id: ntFtnu
msgid "Applicant successfully deleted"
msgstr "Applicant successfully deleted"

#. js-lingui-id: ntmxFO
msgid "Strong compensating factors needed"
msgstr "Strong compensating factors needed"

#. js-lingui-id: nuh/Wq
msgid "Webhook URL"
msgstr "Webhook URL"

#. js-lingui-id: nwGUh0
msgid "Application Confirmation"
msgstr "Application Confirmation"

#. js-lingui-id: nwtY4N
msgid "Something went wrong"
msgstr "Something went wrong"

#. js-lingui-id: nxg9ym
msgid "Property Manager"
msgstr "Property Manager"

#. js-lingui-id: o+7sJL
msgid "Credit Profile"
msgstr "Credit Profile"

#. js-lingui-id: o+XJ9D
msgid "Change"
msgstr "Change"

#. js-lingui-id: o1281j
msgid "View as yourself"
msgstr "View as yourself"

#. js-lingui-id: oFXWhF
msgid "Check your internet connection"
msgstr "Check your internet connection"

#. js-lingui-id: oFl0WW
msgid "Price + Promo"
msgstr "Price + Promo"

#. js-lingui-id: oMHCRM
msgid "In accordance with privacy laws, you have the right to request access to and correction of your credit information from the relevant credit bureau."
msgstr "In accordance with privacy laws, you have the right to request access to and correction of your credit information from the relevant credit bureau."

#. js-lingui-id: oNhB4x
msgid "By discarding this submission, you are confirming that you don't want to proceed with this submission for now, it will still be available in the admin dashboard."
msgstr "By discarding this submission, you are confirming that you don't want to proceed with this submission for now, it will still be available in the admin dashboard."

#. js-lingui-id: oPhDgZ
msgid "Candidate Report"
msgstr "Candidate Report"

#. js-lingui-id: oSy7+Q
msgid "Type and press Enter to add"
msgstr "Type and press Enter to add"

#. js-lingui-id: oTQAzG
msgid "{tenantTitle} | Apartment for rent {street}, {city}"
msgstr "{tenantTitle} | Apartment for rent {street}, {city}"

#. js-lingui-id: oUN0j9
msgid "Manage your submission settings."
msgstr "Manage your submission settings."

#. js-lingui-id: oVNQYH
msgid "Your configured minimum score"
msgstr "Your configured minimum score"

#. js-lingui-id: oWN+Nf
msgid "Regional Avg"
msgstr "Regional Avg"

#. js-lingui-id: oYPtMG
msgid "Total payments"
msgstr "Total payments"

#. js-lingui-id: oZd08v
msgid "Building"
msgstr "Building"

#. js-lingui-id: oaYerQ
msgid "Enter Analytics ID"
msgstr "Enter Analytics ID"

#. js-lingui-id: ofldSs
msgid "Area"
msgstr "Area"

#. js-lingui-id: ohP1RY
msgid "Can't find your address?"
msgstr "Can't find your address?"

#. js-lingui-id: oiutW1
msgid "Your Application"
msgstr "Your Application"

#. js-lingui-id: om2CIo
msgid "Please explain why you don't have a work reference"
msgstr "Please explain why you don't have a work reference"

#. js-lingui-id: on8/3S
msgid "Submission Steps"
msgstr "Submission Steps"

#. js-lingui-id: ongtbP
msgid "Open the full application form to edit all details"
msgstr "Open the full application form to edit all details"

#. js-lingui-id: ovBpbn
msgid "Please enter a realistic number of years (maximum 100)"
msgstr "Please enter a realistic number of years (maximum 100)"

#. js-lingui-id: oyIs+l
msgid "Prices"
msgstr "Prices"

#. js-lingui-id: p1fgy4
msgid "How will I be notified about my application status?"
msgstr "How will I be notified about my application status?"

#. js-lingui-id: p4zy6y
msgid "Lived here since"
msgstr "Lived here since"

#. js-lingui-id: p6F0VQ
msgid "Bankruptcy"
msgstr "Bankruptcy"

#. js-lingui-id: p6InQT
msgid "Date Filed"
msgstr "Date Filed"

#. js-lingui-id: p7Zk0t
msgid "Cannot load units without project data"
msgstr "Cannot load units without project data"

#. js-lingui-id: p8YLf5
msgid "Previous Tenant Details"
msgstr "Previous Tenant Details"

#. js-lingui-id: pBcGZu
msgid "Rental Board"
msgstr "Rental Board"

#. js-lingui-id: pCKi8o
msgid "Action completed"
msgstr "Action completed"

#. js-lingui-id: pEZLGC
msgid "Select Property"
msgstr "Select Property"

#. js-lingui-id: pFNIVp
msgid "View credit check reports"
msgstr "View credit check reports"

#. js-lingui-id: pHXpGv
msgid "No address provided"
msgstr "No address provided"

#. js-lingui-id: pJLvdS
msgid "Please select"
msgstr "Please select"

#. js-lingui-id: pJu9Fa
msgid "Select Events"
msgstr "Select Events"

#. js-lingui-id: pKg7/f
msgid "Are you sure you want to delete this promotion?"
msgstr "Are you sure you want to delete this promotion?"

#. js-lingui-id: pMJABf
msgid "Agent:"
msgstr "Agent:"

#. js-lingui-id: pN22GK
msgid "Your application was declined based on your previous rental history records."
msgstr "Your application was declined based on your previous rental history records."

#. js-lingui-id: pNTxeB
msgid "Your application did not meet our required financial criteria for this property."
msgstr "Your application did not meet our required financial criteria for this property."

#. js-lingui-id: pPofBq
msgid "{city}: {tenantName} {type} for rent, {bedrooms} bedrooms, {address}"
msgstr "{city}: {tenantName} {type} for rent, {bedrooms} bedrooms, {address}"

#. js-lingui-id: pQjjYo
msgid "Link copied to clipboard"
msgstr "Link copied to clipboard"

#. js-lingui-id: pWQHSr
msgid "Availability date"
msgstr "Availability date"

#. js-lingui-id: pYKeLz
msgid "Email already exists"
msgstr "Email already exists"

#. js-lingui-id: paehRh
msgid "Log Out"
msgstr "Log Out"

#. js-lingui-id: paqH4b
msgid "Partial Match"
msgstr "Partial Match"

#. js-lingui-id: pe3lV8
msgid "Please select an address"
msgstr "Please select an address"

#. js-lingui-id: pgi/z4
msgid "{tenantName} {type}: {bedrooms} bedrooms for rent, {address}, {city}"
msgstr "{tenantName} {type}: {bedrooms} bedrooms for rent, {address}, {city}"

#. js-lingui-id: ph32zj
msgid "By signing below, you confirm that <0>you have read and understand the terms of the credit check and authorize us to obtain your credit report</0> . You understand that this credit check will be used to evaluate your application and may affect your credit score. You certify that all information provided is accurate and consent to the verification of this information."
msgstr "By signing below, you confirm that <0>you have read and understand the terms of the credit check and authorize us to obtain your credit report</0> . You understand that this credit check will be used to evaluate your application and may affect your credit score. You certify that all information provided is accurate and consent to the verification of this information."

#. js-lingui-id: phGV+Q
msgid "Add your SIN to our secured form to improve your chances to obtain a credit report. This information is not saved and is only used to verify your identity when running the credit check."
msgstr "Add your SIN to our secured form to improve your chances to obtain a credit report. This information is not saved and is only used to verify your identity when running the credit check."

#. js-lingui-id: pl0SnL
msgid "Invalid SIN number"
msgstr "Invalid SIN number"

#. js-lingui-id: plhHQt
msgid "No data"
msgstr "No data"

#. js-lingui-id: pnZnHJ
msgid "Submission has been successfully approved by the owner"
msgstr "Submission has been successfully approved by the owner"

#. js-lingui-id: pofvdg
msgid "Eviction Records"
msgstr "Eviction Records"

#. js-lingui-id: pqSsD8
msgid "Credit Cards"
msgstr "Credit Cards"

#. js-lingui-id: pqZ3rq
msgid "Delivery not scheduled"
msgstr "Delivery not scheduled"

#. js-lingui-id: psfVQr
msgid "High-interest loans"
msgstr "High-interest loans"

#. js-lingui-id: puxKQA
msgid "Move to next step"
msgstr "Move to next step"

#. js-lingui-id: pwYmr+
msgid "Total debt impact on monthly income"
msgstr "Total debt impact on monthly income"

#. js-lingui-id: pwfsqf
msgid "Select a reason"
msgstr "Select a reason"

#. js-lingui-id: pz0qTl
msgid "You've finalized this submission and has sent to delivery successfully"
msgstr "You've finalized this submission and has sent to delivery successfully"

#. js-lingui-id: q+hNag
msgid "Collection"
msgstr "Collection"

#. js-lingui-id: q6zvmX
msgid "Last 100"
msgstr "Last 100"

#. js-lingui-id: qCwYMT
msgid "Payment plan"
msgstr "Payment plan"

#. js-lingui-id: qE0pRR
msgid "Choose this applicant"
msgstr "Choose this applicant"

#. js-lingui-id: qEZ/dZ
msgid "Drag and drop the steps to reorder them. You can also toggle the visibility of each step and change the color associated with each step."
msgstr "Drag and drop the steps to reorder them. You can also toggle the visibility of each step and change the color associated with each step."

#. js-lingui-id: qGgBdU
msgid "Poor"
msgstr "Poor"

#. js-lingui-id: qJb6G2
msgid "Try Again"
msgstr "Try Again"

#. js-lingui-id: qMN6oz
msgid "The submission will need to be re-evaluated by the team."
msgstr "The submission will need to be re-evaluated by the team."

#. js-lingui-id: qNtzA+
msgid "We're working on it..."
msgstr "We're working on it..."

#. js-lingui-id: qSk06M
msgid "DTI Ratio"
msgstr "DTI Ratio"

#. js-lingui-id: qU9/WI
msgid "{diffHours}h remaining"
msgstr "{diffHours}h remaining"

#. js-lingui-id: qZZfkc
msgid "Only lowercase letters, numbers, and hyphens are allowed"
msgstr "Only lowercase letters, numbers, and hyphens are allowed"

#. js-lingui-id: qc0GJ9
msgid "The debt category breakdown requires data from credit reports and financial verification. This information may still be processing or unavailable."
msgstr "The debt category breakdown requires data from credit reports and financial verification. This information may still be processing or unavailable."

#. js-lingui-id: qd1h8Q
msgid "No documents available"
msgstr "No documents available"

#. js-lingui-id: qer7sv
msgid "Financial strain possible. Consider additional verification"
msgstr "Financial strain possible. Consider additional verification"

#. js-lingui-id: qg4y3S
msgid "Enter a valid email"
msgstr "Enter a valid email"

#. js-lingui-id: qiHkqZ
msgid "Your payment is complete."
msgstr "Your payment is complete."

#. js-lingui-id: qjIzrT
msgid "Bankruptcies"
msgstr "Bankruptcies"

#. js-lingui-id: qkP6F0
msgid "The listed monthly rent (${monthlyRent}) appears unusually low for an accurate affordability analysis. Please verify the rental information."
msgstr "The listed monthly rent (${monthlyRent}) appears unusually low for an accurate affordability analysis. Please verify the rental information."

#. js-lingui-id: qmORKj
msgid "Select Building"
msgstr "Select Building"

#. js-lingui-id: qoL5B+
msgid "How many people are allowed?"
msgstr "How many people are allowed?"

#. js-lingui-id: qqLY+j
msgid "Customization"
msgstr "Customization"

#. js-lingui-id: qqWcBV
msgid "Completed"
msgstr "Completed"

#. js-lingui-id: qr6NSa
msgid "Internal processes"
msgstr "Internal processes"

#. js-lingui-id: qtLIFQ
msgid "Common Filters"
msgstr "Common Filters"

#. js-lingui-id: qu74CH
msgid "An error occurred while processing your payment"
msgstr "An error occurred while processing your payment"

#. js-lingui-id: qvQog4
msgid "Studio"
msgstr "Studio"

#. js-lingui-id: qwU6TW
msgid "One-time payment"
msgstr "One-time payment"

#. js-lingui-id: qwmdAk
msgid "High credit utilization may negatively impact credit score. Consider reducing utilization below 70%."
msgstr "High credit utilization may negatively impact credit score. Consider reducing utilization below 70%."

#. js-lingui-id: r/JRtv
msgid "Quebec rental board decisions"
msgstr "Quebec rental board decisions"

#. js-lingui-id: r0A7jg
msgid "See all photos"
msgstr "See all photos"

#. js-lingui-id: r2mYrt
msgid "Credit check price must be greater than or equal to 0"
msgstr "Credit check price must be greater than or equal to 0"

#. js-lingui-id: r4vBzc
msgid "Document Upload"
msgstr "Document Upload"

#. js-lingui-id: r5FOa9
msgid "Enter email address"
msgstr "Enter email address"

#. js-lingui-id: r6k9wx
msgid "Recent Pay Stubs (last 3 months)"
msgstr "Recent Pay Stubs (last 3 months)"

#. js-lingui-id: r6w7Qs
msgid "Employment history verification"
msgstr "Employment history verification"

#. js-lingui-id: r6y+jM
msgid "Warning"
msgstr "Warning"

#. js-lingui-id: r7H0Xz
msgid "Property Management Company Logo"
msgstr "Property Management Company Logo"

#. js-lingui-id: rJDHoM
msgid "Share application link"
msgstr "Share application link"

#. js-lingui-id: rJytxG
msgid "Animals"
msgstr "Animals"

#. js-lingui-id: rNisc9
msgid "Proof of income"
msgstr "Proof of income"

#. js-lingui-id: rNjtgJ
msgid "I understand that submitting this application does not guarantee approval and that property managers will make the final decision based on their criteria."
msgstr "I understand that submitting this application does not guarantee approval and that property managers will make the final decision based on their criteria."

#. js-lingui-id: rSJOTq
msgid "Risk Summary"
msgstr "Risk Summary"

#. js-lingui-id: rUNM3H
msgid "Exceptional"
msgstr "Exceptional"

#. js-lingui-id: rVCeLt
msgid "Enter your Analytics tracking ID (e.g., UA-XXXXXXXXX-X or G-XXXXXXXXXX)"
msgstr "Enter your Analytics tracking ID (e.g., UA-XXXXXXXXX-X or G-XXXXXXXXXX)"

#. js-lingui-id: rZurQn
msgid "Promoted"
msgstr "Promoted"

#. js-lingui-id: rg+U05
msgid "Featured Image"
msgstr "Featured Image"

#. js-lingui-id: rhoX4c
msgid "{value, plural, one {bedroom} two {bedrooms} other {bedrooms}}"
msgstr "{value, plural, one {bedroom} two {bedrooms} other {bedrooms}}"

#. js-lingui-id: rll8wj
msgid "Your application needs attention. The property manager has left you a message below."
msgstr "Your application needs attention. The property manager has left you a message below."

#. js-lingui-id: rnmGTr
msgid "The tenant will receive application updates at this email address"
msgstr "The tenant will receive application updates at this email address"

#. js-lingui-id: roqqY2
msgid "Contact Information"
msgstr "Contact Information"

#. js-lingui-id: rpQ2WQ
msgid "Save Banner Text"
msgstr "Save Banner Text"

#. js-lingui-id: rptTLk
msgid "When an agent changes a unit price by more than the configured amount, send back to new entry."
msgstr "When an agent changes a unit price by more than the configured amount, send back to new entry."

#. js-lingui-id: rr48zN
msgid "Application process started - {calculatedSections} sections remaining"
msgstr "Application process started - {calculatedSections} sections remaining"

#. js-lingui-id: rsVtpX
msgid "Create Building"
msgstr "Create Building"

#. js-lingui-id: rwgU2o
msgid "From {price}$"
msgstr "From {price}$"

#. js-lingui-id: rxWA39
msgid "Welcome back!"
msgstr "Welcome back!"

#. js-lingui-id: ryGlb7
msgid "Weekly:"
msgstr "Weekly:"

#. js-lingui-id: rz6s8e
msgid "Snoozed"
msgstr "Snoozed"

#. js-lingui-id: s/alvt
msgid "Example: Please provide the requested documents by the specified date to continue processing your application."
msgstr "Example: Please provide the requested documents by the specified date to continue processing your application."

#. js-lingui-id: s/ereB
msgid "active"
msgstr "active"

#. js-lingui-id: s62/cY
msgid "All rental properties"
msgstr "All rental properties"

#. js-lingui-id: s8IgPz
msgid "Income Qualification"
msgstr "Income Qualification"

#. js-lingui-id: sCtyHQ
msgid "Upload files"
msgstr "Upload files"

#. js-lingui-id: sJYPeP
msgid "Personal Details"
msgstr "Personal Details"

#. js-lingui-id: sKKp1Z
msgid "Start by assigning an agent to a submission"
msgstr "Start by assigning an agent to a submission"

#. js-lingui-id: sTB2vw
msgid "The tenant could be accepted if they give"
msgstr "The tenant could be accepted if they give"

#. js-lingui-id: sYM08M
msgid "We are going to create your administrator account and you will be able to explore what makes Eversa great !"
msgstr "We are going to create your administrator account and you will be able to explore what makes Eversa great !"

#. js-lingui-id: sZ4zMa
msgid "Your Environment has just been Launched"
msgstr "Your Environment has just been Launched"

#. js-lingui-id: sgXaIn
msgid "Configure payment settings and requirements for rental applications"
msgstr "Configure payment settings and requirements for rental applications"

#. js-lingui-id: slD65k
msgid "Applicant's email"
msgstr "Applicant's email"

#. js-lingui-id: smWh7D
msgid "Potential financial strain with {displayDebtRatioPCT} debt ratio. Rent (${monthlyRent}) is {rangeLabel} maximum budget (${displayMaxRent})."
msgstr "Potential financial strain with {displayDebtRatioPCT} debt ratio. Rent (${monthlyRent}) is {rangeLabel} maximum budget (${displayMaxRent})."

#. js-lingui-id: soOV+a
msgid "Search by applicant name, ID, or address"
msgstr "Search by applicant name, ID, or address"

#. js-lingui-id: soxPFU
msgid "Last Payment"
msgstr "Last Payment"

#. js-lingui-id: sr0UJD
msgid "Go Back"
msgstr "Go Back"

#. js-lingui-id: sr3b7J
msgid "We will not be more than <strong>{limit}</strong> people who will live in the accommodation, including the children"
msgstr "We will not be more than <strong>{limit}</strong> people who will live in the accommodation, including the children"

#. js-lingui-id: ssJCAn
msgid "Normal Risk"
msgstr "Normal Risk"

#. js-lingui-id: stDiC6
msgid "Add Another Address"
msgstr "Add Another Address"

#. js-lingui-id: sxMe+f
msgid "An email has been sent to {email}"
msgstr "An email has been sent to {email}"

#. js-lingui-id: sxkWRg
msgid "Advanced"
msgstr "Advanced"

#. js-lingui-id: szkz0e
msgid "Phone is required"
msgstr "Phone is required"

#. js-lingui-id: t/G6u4
msgid "Online lenders with standard rates"
msgstr "Online lenders with standard rates"

#. js-lingui-id: t/YqKh
msgid "Remove"
msgstr "Remove"

#. js-lingui-id: t0aIZQ
msgid "This applicant does not have any harmful background information"
msgstr "This applicant does not have any harmful background information"

#. js-lingui-id: t45b0O
msgid "Bathrooms"
msgstr "Bathrooms"

#. js-lingui-id: t58Fcj
msgid "File type"
msgstr "File type"

#. js-lingui-id: t6dDZf
msgid "Time remaining"
msgstr "Time remaining"

#. js-lingui-id: t9c3NB
msgid "Completed on {electricityDate}"
msgstr "Completed on {electricityDate}"

#. js-lingui-id: t9u0Gc
msgid "No files uploaded yet."
msgstr "No files uploaded yet."

#. js-lingui-id: tDTrQ6
msgid "Make tenants pay for their application before they can submit it."
msgstr "Make tenants pay for their application before they can submit it."

#. js-lingui-id: tEL1SL
msgid "Open applicant form"
msgstr "Open applicant form"

#. js-lingui-id: tF7kSs
msgid "Credit Utilization"
msgstr "Credit Utilization"

#. js-lingui-id: tGNn2o
msgid "Application Rejected"
msgstr "Application Rejected"

#. js-lingui-id: tGl67c
msgid "Monthly Salary:"
msgstr "Monthly Salary:"

#. js-lingui-id: tI215L
msgid "Manage your webhook endpoint"
msgstr "Manage your webhook endpoint"

#. js-lingui-id: tKaLQd
msgid "Select a submission or invite someone to apply"
msgstr "Select a submission or invite someone to apply"

#. js-lingui-id: tKgiqP
msgid "Provide clear instructions about what the tenant needs to do to have their application reconsidered."
msgstr "Provide clear instructions about what the tenant needs to do to have their application reconsidered."

#. js-lingui-id: tLXj4b
msgid "Hide 'Chosen' Category"
msgstr "Hide 'Chosen' Category"

#. js-lingui-id: tMOPL4
msgid "Your spouse or partner"
msgstr "Your spouse or partner"

#. js-lingui-id: tOhm/A
msgid "Are you sure you want to delete this lead?"
msgstr "Are you sure you want to delete this lead?"

#. js-lingui-id: tPrmjP
msgid "Address:"
msgstr "Address:"

#. js-lingui-id: tYLILB
msgid "Communication Timeline"
msgstr "Communication Timeline"

#. js-lingui-id: tZ/8mF
msgid "Add other required documents"
msgstr "Add other required documents"

#. js-lingui-id: tZxz1B
msgid "Manage buildings in this project"
msgstr "Manage buildings in this project"

#. js-lingui-id: tfDRzk
msgid "Save"
msgstr "Save"

#. js-lingui-id: tgsqn1
msgid "Credit Inquiries"
msgstr "Credit Inquiries"

#. js-lingui-id: tid3OS
msgid "Debts Utilization Trends (Past 12 months)"
msgstr "Debts Utilization Trends (Past 12 months)"

#. js-lingui-id: tlRI/Q
msgid "Monthly Income"
msgstr "Monthly Income"

#. js-lingui-id: tnD91w
msgid "Enter the full property address..."
msgstr "Enter the full property address..."

#. js-lingui-id: tv8QM/
msgid "The electricity bill ownership has not been transferred to the tenant."
msgstr "The electricity bill ownership has not been transferred to the tenant."

#. js-lingui-id: tvvrXQ
msgid "Min sqft"
msgstr "Min sqft"

#. js-lingui-id: tzSAJQ
msgid "Send my application for review"
msgstr "Send my application for review"

#. js-lingui-id: u+SBsP
msgid "How does Eversa provide tenant credit reports for free?"
msgstr "How does Eversa provide tenant credit reports for free?"

#. js-lingui-id: u/fuB6
msgid "I certify that I have an annual income of at least <strong>{limit}$ CAD</strong>"
msgstr "I certify that I have an annual income of at least <strong>{limit}$ CAD</strong>"

#. js-lingui-id: u/y58m
msgid "Your most recent pay stubs from the last 3 months"
msgstr "Your most recent pay stubs from the last 3 months"

#. js-lingui-id: u529Qw
msgid "Your applicants on this submission"
msgstr "Your applicants on this submission"

#. js-lingui-id: u6R3pO
msgid "Select a Unit"
msgstr "Select a Unit"

#. js-lingui-id: uAQUqI
msgid "Status"
msgstr "Status"

#. js-lingui-id: uBQtcp
msgid "Latest Tax Assessment"
msgstr "Latest Tax Assessment"

#. js-lingui-id: uCGJnY
msgid "Setting conditions allows the tenant to reapply once they meet your requirements"
msgstr "Setting conditions allows the tenant to reapply once they meet your requirements"

#. js-lingui-id: uDfc2W
msgid "Finding the right place takes time. Let us help you discover other properties that match your preferences and needs."
msgstr "Finding the right place takes time. Let us help you discover other properties that match your preferences and needs."

#. js-lingui-id: uDrt8M
msgid "Dark Logo"
msgstr "Dark Logo"

#. js-lingui-id: uEmTBH
msgid "Please sign in to continue"
msgstr "Please sign in to continue"

#. js-lingui-id: uEsnqP
msgid "Written off"
msgstr "Written off"

#. js-lingui-id: uGJHZ+
msgid "Daily summary of activities and updates for listings and inquiries"
msgstr "Daily summary of activities and updates for listings and inquiries"

#. js-lingui-id: uJ+Ve2
msgid "Region"
msgstr "Region"

#. js-lingui-id: uUehLT
msgid "Waiting"
msgstr "Waiting"

#. js-lingui-id: uW0HMo
msgid "Message to tenant"
msgstr "Message to tenant"

#. js-lingui-id: uXJkRJ
msgid "Enter date of birth"
msgstr "Enter date of birth"

#. js-lingui-id: uXsB4R
msgid "Staff"
msgstr "Staff"

#. js-lingui-id: uZ1Oce
msgid "Edit lead"
msgstr "Edit lead"

#. js-lingui-id: ucgZ0o
msgid "Organization"
msgstr "Organization"

#. js-lingui-id: udG6YF
msgid "Creditor"
msgstr "Creditor"

#. js-lingui-id: uekMUe
msgid "Credit score"
msgstr "Credit score"

#. js-lingui-id: ugEMJY
msgid "Applications Reports"
msgstr "Applications Reports"

#. js-lingui-id: ujb7Qp
msgid "Current Plan"
msgstr "Current Plan"

#. js-lingui-id: ulw+Wr
msgid "Original Balance"
msgstr "Original Balance"

#. js-lingui-id: upwQ06
msgid "Unit duplicated successfully"
msgstr "Unit duplicated successfully"

#. js-lingui-id: uurk+S
msgid "Occupancy Rate"
msgstr "Occupancy Rate"

#. js-lingui-id: uvIJKC
msgid "Create Listing"
msgstr "Create Listing"

#. js-lingui-id: uwI8Dd
msgid "This payment covers the landlord's review of your application, including:"
msgstr "This payment covers the landlord's review of your application, including:"

#. js-lingui-id: uyILW5
msgid "View as agent:"
msgstr "View as agent:"

#. js-lingui-id: v1DfBC
msgid "Create a new building for this project"
msgstr "Create a new building for this project"

#. js-lingui-id: v3C6ky
msgid "Update the tenant's information and application details"
msgstr "Update the tenant's information and application details"

#. js-lingui-id: v7dfDY
msgid "Invalid code. Please try again."
msgstr "Invalid or expired code. Please try again."

#. js-lingui-id: vC6cDj
msgid "Agents have limited access focused on day-to-day operations. They cannot access sensitive settings or manage team members."
msgstr "Agents have limited access focused on day-to-day operations. They cannot access sensitive settings or manage team members."

#. js-lingui-id: vERlcd
msgid "Profile"
msgstr "Profile"

#. js-lingui-id: vHrHkm
msgid "Base fee"
msgstr "Base fee"

#. js-lingui-id: vLs6n/
msgid "Send invitation email to the applicant"
msgstr "Send invitation email to the applicant"

#. js-lingui-id: vLyv1R
msgid "Hide"
msgstr "Hide"

#. js-lingui-id: vVWAuV
msgid "Enter building name"
msgstr "Enter building name"

#. js-lingui-id: vVadet
msgid "Drop your files here or click to browse"
msgstr "Drop your files here or click to browse"

#. js-lingui-id: vW+T+d
msgid "An unknown error occurred"
msgstr "An unknown error occurred"

#. js-lingui-id: vXIe7J
msgid "Language"
msgstr "Language"

#. js-lingui-id: vXPSuB
msgid "Update profile"
msgstr "Update profile"

#. js-lingui-id: vZbKTc
msgid "{city} rental: {type} with {bedrooms} bedrooms for rent by {tenantName}"
msgstr "{city} rental: {type} with {bedrooms} bedrooms for rent by {tenantName}"

#. js-lingui-id: vZloPi
msgid "Student housing"
msgstr "Student housing"

#. js-lingui-id: vbZwfI
msgid "Last update:"
msgstr "Last update:"

#. js-lingui-id: vc8/JX
msgid "Monthly payment"
msgstr "Monthly payment"

#. js-lingui-id: vdvXiO
msgid "This unit costs "
msgstr "This unit costs "

#. js-lingui-id: ve9JTU
msgid "Last name is required"
msgstr "Last name is required"

#. js-lingui-id: vhJinC
msgid "Visiting"
msgstr "Visiting"

#. js-lingui-id: viN70j
msgid "Missed Payments"
msgstr "Missed Payments"

#. js-lingui-id: vicmFE
msgid "Bank statement showing available funds"
msgstr "Bank statement showing available funds"

#. js-lingui-id: vij+ii
msgid "Bank statements from the last 3 months"
msgstr "Bank statements from the last 3 months"

#. js-lingui-id: vpAgJR
msgid "View on website"
msgstr "View on website"

#. js-lingui-id: vpKmdr
msgid "Smoking Allowed?"
msgstr "Smoking Allowed?"

#. js-lingui-id: vq2WxD
msgid "Tue"
msgstr "Tue"

#. js-lingui-id: vrnnn9
msgid "Processing"
msgstr "Processing"

#. js-lingui-id: vsCoTE
msgid "Time in process"
msgstr "Time in process"

#. js-lingui-id: vv7kpg
msgid "Cancelled"
msgstr "Cancelled"

#. js-lingui-id: vwH9Qa
msgid "Technical Support:"
msgstr "Technical Support:"

#. js-lingui-id: w/cI8L
msgid "A valid government-issued photo ID such as a driver's license or passport"
msgstr "A valid government-issued photo ID such as a driver's license or passport"

#. js-lingui-id: w00zlN
msgid "Warning: By not providing your Social Insurance Number, you may face delays or difficulties in obtaining a credit report, as this information helps verify your identity. If we can't find a report, you may be forced to provide additional details and/or pay additional fees for us to process your application."
msgstr "Warning: By not providing your Social Insurance Number, you may face delays or difficulties in obtaining a credit report, as this information helps verify your identity. If we can't find a report, you may be forced to provide additional details and/or pay additional fees for us to process your application."

#. js-lingui-id: w0A0UE
msgid "I'm living with my parents"
msgstr "I'm living with my parents"

#. js-lingui-id: w2zb+v
msgid "Who has access to my application information?"
msgstr "Who has access to my application information?"

#. js-lingui-id: w4PY79
msgid "Find a unit that's right for you."
msgstr "Find a unit that's right for you."

#. js-lingui-id: wBMWsJ
msgid "Project Address"
msgstr "Project Address"

#. js-lingui-id: wBW91V
msgid "Not provided"
msgstr "Not provided"

#. js-lingui-id: wHxJQq
msgid "No applicants found"
msgstr "No applicants found"

#. js-lingui-id: wJijgU
msgid "Location"
msgstr "Location"

#. js-lingui-id: wNuh6Y
msgid "Add New Building"
msgstr "Add New Building"

#. js-lingui-id: wO5Zi3
msgid "Visit Agent Details"
msgstr "Visit Agent Details"

#. js-lingui-id: wQYgJ7
msgid "External Promotion"
msgstr "External Promotion"

#. js-lingui-id: wWPAtV
msgid "sqft"
msgstr "sqft"

#. js-lingui-id: wYOeEe
msgid "Meets Required Ratio"
msgstr "Meets Required Ratio"

#. js-lingui-id: wZ5gKd
msgid "Submission Workflow"
msgstr "Submission Workflow"

#. js-lingui-id: waLOUb
msgid "Enter phone number"
msgstr "Enter phone number"

#. js-lingui-id: wfJoeV
msgid "Submission Assignment"
msgstr "Submission Assignment"

#. js-lingui-id: wfKu6T
msgid "Manage your organization settings."
msgstr "Manage your organization settings."

#. js-lingui-id: wg5NvF
msgid "{city}: {type} with {bedrooms} bedrooms for rent by {tenantName}"
msgstr "{city}: {type} with {bedrooms} bedrooms for rent by {tenantName}"

#. js-lingui-id: wiryFV
msgid "Create Tenant"
msgstr "Create Tenant"

#. js-lingui-id: woCTcH
msgid "Enter price"
msgstr "Enter price"

#. js-lingui-id: wqTYGd
msgid "Write description"
msgstr "Write description"

#. js-lingui-id: wtD38R
msgid "Social security number"
msgstr "Social security number"

#. js-lingui-id: wtuVU4
msgid "Frequency"
msgstr "Frequency"

#. js-lingui-id: wvJa+N
msgid "Identity proof"
msgstr "Identity proof"

#. js-lingui-id: wwiTff
msgid "Email Verification"
msgstr "Email Verification"

#. js-lingui-id: wwssS3
msgid "Submission details"
msgstr "Submission details"

#. js-lingui-id: wxPVRP
msgid "Profile of {name}"
msgstr "Profile of {name}"

#. js-lingui-id: wzqqS+
msgid "Key Features"
msgstr "Key Features"

#. js-lingui-id: x1Prl9
msgid "Important Notice - Credit Check"
msgstr "Important Notice - Credit Check"

#. js-lingui-id: x2M4j/
msgid "Fill out your personal details on the application form"
msgstr "Fill out your personal details on the application form"

#. js-lingui-id: x7aiKJ
msgid "Allow Co-Applicants"
msgstr "Allow Co-Applicants"

#. js-lingui-id: xCJdfg
msgid "Clear"
msgstr "Clear"

#. js-lingui-id: xChGGW
msgid "Sex offender registry check"
msgstr "Sex offender registry check"

#. js-lingui-id: xDDDyb
msgid "Apply securely online"
msgstr "Apply securely online"

#. js-lingui-id: xGVfLh
msgid "Continue"
msgstr "Continue"

#. js-lingui-id: xIpn/4
msgid "High utilization - consider reducing"
msgstr "High utilization - consider reducing"

#. js-lingui-id: xJDnl+
msgid "Re-open"
msgstr "Re-open"

#. js-lingui-id: xKYFTw
msgid "You'll receive email notifications about your application status, including requests for additional information and final decisions. You can also check your application status anytime through your tenant portal."
msgstr "You'll receive email notifications about your application status, including requests for additional information and final decisions. You can also check your application status anytime through your tenant portal."

#. js-lingui-id: xL8XZS
msgid "Listings View"
msgstr "Listings View"

#. js-lingui-id: xNAvO7
msgid "Provide extra proof of financial stability"
msgstr "Provide extra proof of financial stability"

#. js-lingui-id: xPOvqP
msgid "Moderate financial profile with {displayDebtRatioPCT} debt ratio. Rent (${monthlyRent}) is within recommended budget (max ${displayMaxRent})."
msgstr "Moderate financial profile with {displayDebtRatioPCT} debt ratio. Rent (${monthlyRent}) is within recommended budget (max ${displayMaxRent})."

#. js-lingui-id: xRzh4F
msgid "This application has been rejected with condition until <0>{formatedDate}</0> while we wait for additional information from the applicant."
msgstr "This application has been rejected with condition until <0>{formatedDate}</0> while we wait for additional information from the applicant."

#. js-lingui-id: xST6lc
msgid "Enter your Ads Conversion ID (e.g., AW-XXXXXXXXX/X)"
msgstr "Enter your Ads Conversion ID (e.g., AW-XXXXXXXXX/X)"

#. js-lingui-id: xUgUTh
msgid "Enter first name"
msgstr "Enter first name"

#. js-lingui-id: xVhQZV
msgid "Fri"
msgstr "Fri"

#. js-lingui-id: xYilR2
msgid "Media"
msgstr "Media"

#. js-lingui-id: xadA+H
msgid "Select a reason for rejection"
msgstr "Select a reason for rejection"

#. js-lingui-id: xdc4b1
msgid "SIN cannot start with 0"
msgstr "SIN cannot start with 0"

#. js-lingui-id: xfpSug
msgid "Debt-to-Income Ratio Limit"
msgstr "Debt-to-Income Ratio Limit"

#. js-lingui-id: xgABd1
msgid "You can activate this feature to let tenants know you will refund their application if they are chosen"
msgstr "You can activate this feature to let tenants know you will refund their application if they are chosen"

#. js-lingui-id: xgWM7n
msgid "Website Features"
msgstr "Website Features"

#. js-lingui-id: xleo2L
msgid "Unnamed Project"
msgstr "Unnamed Project"

#. js-lingui-id: xowcRf
msgid "Terms of Service"
msgstr "Terms of Service"

#. js-lingui-id: xt8m+1
msgid "Financial data is not available at the moment."
msgstr "Financial data is not available at the moment."

#. js-lingui-id: xtAV07
msgid "Strong financial profile with {displayDebtRatioPCT} debt ratio. Rent (${monthlyRent}) is within comfortable budget (max ${displayMaxRent})."
msgstr "Strong financial profile with {displayDebtRatioPCT} debt ratio. Rent (${monthlyRent}) is within comfortable budget (max ${displayMaxRent})."

#. js-lingui-id: xtVMrp
msgid "Building Rules"
msgstr "Building Rules"

#. js-lingui-id: xuqEo1
msgid "What information do you collect and store?"
msgstr "What information do you collect and store?"

#. js-lingui-id: xwQRuc
msgid "Enter listing description in English"
msgstr "Enter listing description in English"

#. js-lingui-id: xxsw3W
msgid "Income"
msgstr "Income"

#. js-lingui-id: y/0uwd
msgid "Yesterday"
msgstr "Yesterday"

#. js-lingui-id: y1IX+e
msgid "Additional Co-Applicants"
msgstr "Additional Co-Applicants"

#. js-lingui-id: y1mxvW
msgid "Add a co-signer for additional security"
msgstr "Add a co-signer for additional security"

#. js-lingui-id: y58u1a
msgid "A parent or endorser who can support your application"
msgstr "A parent or endorser who can support your application"

#. js-lingui-id: y5GZtQ
msgid "Listing ID is required"
msgstr "Listing ID is required"

#. js-lingui-id: y6V3iP
msgid "The tenant has paid the deposit and the financial information has been verified."
msgstr "The tenant has paid the deposit and the financial information has been verified."

#. js-lingui-id: y9pBle
msgid "Contact Phone Number"
msgstr "Contact Phone Number"

#. js-lingui-id: yCVzGD
msgid "Liability Amount"
msgstr "Liability Amount"

#. js-lingui-id: yFRXKt
msgid "Rent to Income"
msgstr "Rent to Income"

#. js-lingui-id: yG2qjp
msgid "To be signed"
msgstr "To be signed"

#. js-lingui-id: yIeIf2
msgid "Restore lead"
msgstr "Restore lead"

#. js-lingui-id: yS25z6
msgid "All residential rentals"
msgstr "All residential rentals"

#. js-lingui-id: yTaKp/
msgid "Agent Portal"
msgstr "Agent Portal"

#. js-lingui-id: yYDKjE
msgid "Upload Document"
msgstr "Upload Document"

#. js-lingui-id: yYxB17
msgid "Clear all"
msgstr "Clear all"

#. js-lingui-id: yZvjVv
msgid "Try using a different browser, or a different device"
msgstr "Try using a different browser, or a different device"

#. js-lingui-id: ycMMt1
msgid "Review and approve the consents required for your application"
msgstr "Review and approve the consents required for your application"

#. js-lingui-id: ycZ2l4
msgid "It looks like you don't have submissions yet"
msgstr "It looks like you don't have submissions yet"

#. js-lingui-id: yca4wa
msgid "You have been invited to join this workspace."
msgstr "You have been invited to join this workspace."

#. js-lingui-id: yixoBN
msgid "Exact Match"
msgstr "Exact Match"

#. js-lingui-id: yjAr5D
msgid "Your application requires an additional applicant to proceed. This could be:"
msgstr "Your application requires an additional applicant to proceed. This could be:"

#. js-lingui-id: ylkOkk
msgid "Providing extra proof of income, savings, or other financial assets may help support your application."
msgstr "Providing extra proof of income, savings, or other financial assets may help support your application."

#. js-lingui-id: ynIIm/
msgid "{nbImages, plural, other {+ {nbImages} photos} one {one photo} two {two photos}}"
msgstr "{nbImages, plural, other {+ {nbImages} photos} one {one photo} two {two photos}}"

#. js-lingui-id: yqDxLg
msgid "Company Address"
msgstr "Company Address"

#. js-lingui-id: yt9SZ/
msgid "Registered on"
msgstr "Registered on"

#. js-lingui-id: yvxSxj
msgid "Unassigned leads"
msgstr "Unassigned leads"

#. js-lingui-id: yx/fMc
msgid "High"
msgstr "High"

#. js-lingui-id: yxJoM9
msgid "Is this unit currently occupied?"
msgstr "Is this unit currently occupied?"

#. js-lingui-id: yz7wBu
msgid "Close"
msgstr "Close"

#. js-lingui-id: z1U/Fh
msgid "Rating"
msgstr "Rating"

#. js-lingui-id: z2TQ0s
msgid "Smoking"
msgstr "Smoking"

#. js-lingui-id: z2W2h2
msgid "Credit Check"
msgstr "Credit Check"

#. js-lingui-id: z4+VzX
msgid "Contact History"
msgstr "Contact History"

#. js-lingui-id: z6hOBH
msgid "All requested documents have been uploaded."
msgstr "All requested documents have been uploaded."

#. js-lingui-id: z8LWu2
msgid "Project data is not available"
msgstr "Project data is not available"

#. js-lingui-id: z8vnmb
msgid "<0>months</0> of payment in advance"
msgstr "<0>months</0> of payment in advance"

#. js-lingui-id: zDJYZ5
msgid "Calculated Monthly Income"
msgstr "Calculated Monthly Income"

#. js-lingui-id: zDivex
msgid "Enter reason for cancellation"
msgstr "Enter reason for cancellation"

#. js-lingui-id: zE9Yd+
msgid "Traditional banks with competitive rates"
msgstr "Traditional banks with competitive rates"

#. js-lingui-id: zFaTAT
msgid "Listing Status"
msgstr "Listing Status"

#. js-lingui-id: zFrh3M
msgid "Invite Tenant"
msgstr "Invite Tenant"

#. js-lingui-id: zKHn6T
msgid "Send your accommodation request easily and securely online with our web application form"
msgstr "Send your accommodation request easily and securely online with our web application form"

#. js-lingui-id: zR3Uwj
msgid "Run this check to verify income, debts and payment history."
msgstr "Run this check to verify income, debts and payment history."

#. js-lingui-id: zRH+YV
msgid "To proceed with the application process, a security deposit equivalent to {prepaidRentMonths} months' rent will be required as a condition of approval."
msgstr "To proceed with the application process, a security deposit equivalent to {prepaidRentMonths} months' rent will be required as a condition of approval."

#. js-lingui-id: zTNjrI
msgid "Update Prices"
msgstr "Update Prices"

#. js-lingui-id: zU+Ro7
msgid "Signed in as"
msgstr "Signed in as"

#. js-lingui-id: zYD7lE
msgid "TAL Check"
msgstr "TAL Check"

#. js-lingui-id: zYU3sk
msgid "Below Required Ratio"
msgstr "Below Required Ratio"

#. js-lingui-id: zYV2Bg
msgid "Buildings"
msgstr "Buildings"

#. js-lingui-id: zZ3dVu
#. placeholder {0}: amenities.length - MAX_AMENITIES
#. placeholder {1}: amenities.length - MAX_AMENITIES
msgid "{0, plural, other {+ {1} amenities} one {one amenity} two {two amenities}}"
msgstr "{0, plural, other {+ {1} amenities} one {one amenity} two {two amenities}}"

#. js-lingui-id: zaJYvc
msgid "Enter an address..."
msgstr "Enter an address..."

#. js-lingui-id: zb77GC
msgid "Rent"
msgstr "Rent"

#. js-lingui-id: zbfHPr
msgid "We maintain strict data retention policies and only keep your information for as long as necessary to process your application. After the required retention period, your data is securely deleted from our systems."
msgstr "We maintain strict data retention policies and only keep your information for as long as necessary to process your application. After the required retention period, your data is securely deleted from our systems."

#. js-lingui-id: zirCsS
msgid "Industry standard is 3.0x (tenant's income should be at least 3 times their monthly debt)"
msgstr "Industry standard is 3.0x (tenant's income should be at least 3 times their monthly debt)"

#. js-lingui-id: zkWmBh
msgid "Yearly"
msgstr "Yearly"

#. js-lingui-id: zl80jE
msgid "Edit Tenant Information"
msgstr "Edit Tenant Information"

#. js-lingui-id: zmXrJg
msgid "Create a new building"
msgstr "Create a new building"

#. js-lingui-id: zmwvG2
msgid "Phone"
msgstr "Phone"

#. js-lingui-id: zp88zI
msgid "Missing data"
msgstr "Missing data"

#. js-lingui-id: zujYom
msgid "Please enter a positive number or zero for years at your job"
msgstr "Please enter a positive number or zero for years at your job"

#. js-lingui-id: zy7MBs
msgid "The user will not be able to access the app."
msgstr "The user will not be able to access the app."

#. js-lingui-id: zzDlyQ
msgid "Success"
msgstr "Success"
